<!-- 首页 -->
<template>
  <div class="elite_layout">
    <section class="el-container is-vertical">
      <header class="el-header" style="height: 60px">
        <div class="topNav">
          <ul
            role="menubar"
            class="el-menu-demo el-menu--horizontal el-menu"
            style="background-color: rgb(255, 255, 255)"
          >
            <div class="logo">
              <img src="../../assets/images/images/logo.png" alt="" />
            </div>

            <!-- 
            <div class="select_city" style="display: none">
              <span>
                <span class="el-icon-location" style="font-size: 18px"></span>
              </span>
              <form-item label="城市选择" id="show_city">
                <el-cascader
                  v-model="city"
                  :options="optionsCity"
                  @change="handleChange"
                  placeholder="选择地区"
                ></el-cascader>
                 @change="handleChange"   
              </form-item>
            </div>
-->
            <li
              role="menuitem"
              class="el-menu-item is-active"
              style="
                color: rgb(255, 153, 0);
                border-bottom-color: rgb(255, 153, 0);
                background: none;
              "
              @click="$router.push('/')"
            >
              首页
            </li>
            <li
              role="menuitem"
              class="el-menu-item"
              style="
                color: rgb(0, 0, 0);
                border-bottom-color: transparent;
                background: none;
              "
              @click="$router.push('/elite_position')"
            >
              职位
            </li>
            <li
              role="menuitem"
              class="el-menu-item"
              style="
                color: rgb(0, 0, 0);
                border-bottom-color: transparent;
                background: none;
              "
              @click="$router.push('/elite_company')"
            >
              企业
            </li>
            <li
              role="menuitem"
              class="el-menu-item"
              style="
                color: rgb(0, 0, 0);
                border-bottom-color: transparent;
                background: none;
              "
              @click="$router.push('/elite_resume')"
            >
              简历
            </li>
            <li
              role="menuitem"
              class="el-menu-item"
              style="
                color: rgb(0, 0, 0);
                border-bottom-color: transparent;
                background: none;
              "
              @click="$router.push('/elite_chat')"
            >
              聊天
            </li>

            <div v-if="weixin_nickname != null" class="menu_me">
              <span class="el-popover__reference-wrapper"
                ><div
                  class="el-dropdown-link el-popover__reference"
                  aria-describedby="el-popover-5162"
                  tabindex="0"
                >
                  <span>{{ weixin_nickname }}</span
                  ><img :src="weixin_pic" />

                  <span> <a href="" @click="tuichu">退出</a></span>
                </div></span
              >
              <!----><!---->
            </div>

            <div class="menu_me" v-else>
              <div class="btn" @click="$router.push('/login')">企业登录</div>
              <div class="btnZP" @click="$router.push('/register')">
                我要招聘
              </div>
              <div class="btnZP" @click="$router.push('/elite_login')">
                我要找工作
              </div>
            </div>
          </ul>
        </div>
      </header>
      <main class="el-main">
        <div class="main">
          <!---->
          <div class="elite_index">
            <div class="search">
              <div class="view">
                <div id="header_imgs">
                  <img
                    src="../../assets/images/images/header1.jpg"
                    style="display: none"
                  />
                  <img
                    src="../../assets/images/images/header2.jpg"
                    style="display: none"
                  />
                  <img
                    src="../../assets/images/images/header3.jpg"
                    style="display: none"
                  />
                </div>
                <div
                  :class="{ banner: true, trans: flag }"
                  @mouseenter="enter"
                  @mouseleave="leave"
                >
                  <img :src="imagesUrl[imgindex]" alt="" class="img_brand" />
                </div>
                <ul>
                  <!-- 点击小圆点切换对应图片展示 -->
                </ul>
                <div class="p_and_n">
                  <img
                    src="../../assets/images/images/prev.png"
                    @click="prev"
                    class="prev"
                  />
                  <img
                    src="../../assets/images/images/next.png"
                    @click="next"
                    class="next"
                  />
                </div>
              </div>
            </div>
            <div class="conent">
              <div class="tuijian">
                <div class="con_tuijian">
                  <div class="title">
                    <img
                      src="data:image/png;base64,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"
                      alt=""
                    />
                  </div>

                  <div class="float_con">
                    <div
                      class="con"
                      v-for="(item, i) in jd_Data"
                      :key="i"
                      @click="
                        $router.push('/elite_position_details?id=' + item.id)
                      "
                    >
                      <p class="jd_name">{{ item.jd_title }}</p>
                      <p class="info">
                        <span>{{ item.jd_edu_str }}</span
                        ><span>{{ item.jd_exp_str }}</span
                        ><span
                          >{{ item.jd_place_data.city_name }}-{{
                            item.jd_place_data.district_name
                          }}</span
                        >
                      </p>
                      <div class="jd_salary">
                        {{ item.jd_salary_min }}- {{ item.jd_salary_max }}元
                      </div>
                      <div class="company">
                        {{ item.company_name }}
                      </div>
                    </div>
                  </div>

                  <div class="button_to">
                    <button
                      type="button"
                      class="el-button el-button--default"
                      @click="$router.push('/elite_position')"
                    >
                      <!----><!----><span>查看更多职位</span>
                    </button>
                  </div>
                </div>
                <div class="con_tuijian">
                  <div class="title">
                    <img
                      src="data:image/png;base64,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"
                      alt=""
                    />
                  </div>
                  <div class="float_con">
                    <div class="con_company">
                      <img
                        src="../../assets/images/index_com_img/index01.jpg"
                        alt=""
                      />
                      <div class="company"><span>得莱雅</span></div>
                    </div>
                    <div class="con_company">
                      <img
                        src="../../assets/images/index_com_img/index02.jpg"
                        alt=""
                      />
                      <div class="company"><span>兴荣纸业</span></div>
                    </div>
                    <div class="con_company">
                      <img
                        src="../../assets/images/index_com_img/index03.jpg"
                        alt=""
                      />
                      <div class="company"><span>山东家福</span></div>
                    </div>
                    <div class="con_company">
                      <img
                        src="../../assets/images/index_com_img/index04.jpg"
                        alt=""
                      />
                      <div class="company"><span>圣真无纺布</span></div>
                    </div>
                    <div class="con_company">
                      <img
                        src="../../assets/images/index_com_img/index05.jpg"
                        alt=""
                      />
                      <div class="company"><span>恒发</span></div>
                    </div>
                    <div class="con_company">
                      <img
                        src="../../assets/images/index_com_img/index06.jpg"
                        alt=""
                      />
                      <div class="company"><span>铭远</span></div>
                    </div>
                    <div class="con_company">
                      <img
                        src="../../assets/images/index_com_img/index07.jpg"
                        alt=""
                      />
                      <div class="company"><span>丽邦</span></div>
                    </div>
                    <div class="con_company">
                      <img
                        src="../../assets/images/index_com_img/index08.jpg"
                        alt=""
                      />
                      <div class="company"><span>绿纯纸业</span></div>
                    </div>
                    <div class="con_company">
                      <img
                        src="../../assets/images/index_com_img/index09.jpg"
                        alt=""
                      />
                      <div class="company"><span>贝石卫品</span></div>
                    </div>
                    <div class="con_company">
                      <img
                        src="../../assets/images/index_com_img/index10.jpg"
                        alt=""
                      />
                      <div class="company"><span>力达纸业</span></div>
                    </div>
                    <div class="con_company">
                      <img
                        src="../../assets/images/index_com_img/index11.jpg"
                        alt=""
                      />
                      <div class="company"><span>飞顺纸业</span></div>
                    </div>
                    <div class="con_company">
                      <img
                        src="../../assets/images/index_com_img/index12.jpg"
                        alt=""
                      />
                      <div class="company"><span>蓝漂</span></div>
                    </div>
                  </div>
                  <div class="button_to">
                    <button
                      type="button"
                      class="el-button el-button--default"
                      @click="$router.push('/elite_company')"
                    >
                      <!----><!----><span>查看更多企业</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer">
              <div class="f_cont">
                <div class="f_logo">
                  <div class="f_logoImg"></div>
                  <div class="tu left">
                    <div class="logo-bottom">
                      <img src="../../assets/images/images/qiye.jpg" alt="" />
                      <p>咖聘企业版</p>
                    </div>
                    <div class="logo-bottom">
                      <img
                        src="../../assets/images/images/jingying.jpg"
                        alt=""
                      />
                      <p>咖聘精英版</p>
                    </div>
                  </div>
                </div>
                <div class="f_flex">
                  <div class="title">
                    <div></div>
                  </div>
                  <div class="title">
                    <p class="mytitle">企业信息</p>
                    <div>
                      <p>
                        <a id="xkz_href" href="" target="_blank"
                          >人力资源服务许可证</a
                        >

                        <img
                          id="xkz_pic"
                          src="../../assets/images/images/1.jpg"
                          style="display: none"
                        />
                      </p>
                      <p>
                        <a id="yyzz_href" href="" target="_blank">营业执照</a>
                        <img
                          id="yyzz_pic"
                          src="../../assets/images/images/2.jpg"
                          style="display: none"
                        />

                        
                        <a style="margin-left: 20px;" id="jyxkz_href" href="" target="_blank">经营许可证编号:冀B2-20230073</a>
                        <img
                          id="jyxkz_pic"
                          src="../../assets/images/images/3.jpg"
                          style="display: none"
                        />


                      </p>

                      <p>
                        <a href="https://beian.miit.gov.cn/" target="_blank"
                          >冀ICP备2020024363号</a
                        ><br />
                        
                      </p>
                    </div>
                  </div>
                  <div class="title">
                    <p class="mytitle">工作时间</p>
                    <div>
                      <p>周一 至 周五</p>
                      <p>8：30 - 17：30</p>
                      <p>联系电话：400-066-8191</p>
                      <p>联系邮箱：kapin@qq.com</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!---->
          </div>
        </div>
      </main>
    </section>
    <!---->
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import { pc_position_hot, pc_company_list } from "@/api/login.js";
import { showCity } from "@/api/me/index";

import $ from "jquery";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    return {
      weixin_nickname: sessionStorage.getItem("weixin_nickname"),
      weixin_pic: sessionStorage.getItem("weixin_pic"),

      city: ["130000", "130200", "130200"],
      optionsCity: [],
      place_id: 130000,
      place_name: "唐山市",
      imgindex: "0", //控制变量，默认显示第一张
      imagesUrl: [],
      flag: true,
      timer: 0, //定时器
      jd_Data: [],
      refs: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //退出登录
    tuichu: function () {
      sessionStorage.clear();
      this.$router.replace("/elite_login");
    },

    //城市选择
    handleChange(value) {
      // $("#get_show_city").show();
      // $("#show_city").hide();
      console.log(value);
      console.log($("#show_city"));

      this.place_id = Number(value[value.length - 1]);
      // this.currentpage = 1
      // this.searchType = 0
      // this.page = 0
      // this.list = []
      this.position_hot();
    },

    //跳转
    goto: function (url) {
      window.location.href = url;
    },

    //跳转到职位详情
    jd_details: function (item) {
      console.log(item);
    },
    set_img_src: function () {
      //这里存放数据
      console.log("sssssssss");
      let that = this;
      $("#header_imgs img").each(function () {
        // console.log(this);
        // console.log($(this).attr("src"));
        that.imagesUrl.push($(this).attr("src"));
      });
    },

    //下一张
    next: function () {
      if (this.imgindex == this.imagesUrl.length - 1) {
        this.imgindex = 0;
      } else {
        this.imgindex++;
      }
    },
    //上一张
    prev: function () {
      if (this.imgindex < 0) {
        this.imgindex = this.imagesUrl.length - 1;
      } else {
        this.imgindex--;
      }
    },

    select(index) {
      this.imgindex = index;
      //通过点击小圆点获取对应的索引，进行赋值；
    },

    // 鼠标移入view
    enter: function () {
      clearInterval(this.timer);
    },
    leave: function () {
      this.timer = setInterval(this.next.bind(this), 3000);
    },

    //获取热门职位
    position_hot: function () {
      let that = this;
      pc_position_hot({
        select_data: { page: 1, jd_place_id: that.place_id },
      }).then((res) => {
        console.log("获取热门职位");

        that.jd_Data = res.data.data;
        console.log(res);
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.timer = setInterval(this.next.bind(this), 4000);

    console.log("获取地区");
    showCity({}).then((res) => {
      console.log("sssssssssss");
      console.log(res);
      this.optionsCity = res.data;
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    $(function () {
      that.set_img_src();
    });

    //获取热门职位
    this.position_hot();
    //营业执照和许可证照片链接
    $("#xkz_href").attr("href", $("#xkz_pic").attr("src"));
    $("#yyzz_href").attr("href", $("#yyzz_pic").attr("src"));

    $("#jyxkz_href").attr("href", $("#jyxkz_pic").attr("src"));
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.body,
a,
font,
span,
b,
u,
em,
i,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
textarea,
p,
blockquote,
tr,
table,
tbody,
thead,
th,
td,
hr,
button,
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  margin: 0;
  padding: 0;
}
.body {
  width: 100%;
  max-width: 1920px;
  min-width: 1300px;
  margin: 0 auto;
  font: 16px/1.75 "微软雅黑", "Microsoft Yahei", Arial;
  color: #575757;
}
/* //@import url(); 引入公共css类 */
img {
  border: 0px;
  margin: 0;
  padding: 0;
}
ul,
ol {
  list-style-type: none;
  vertical-align: bottom;
}
em,
i,
u,
b {
  font-style: normal;
  list-style: none;
  font-weight: normal;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
input,
textarea,
select {
  font: 16px/1 "微软雅黑", "Microsoft Yahei", Arial;
  color: #575757;
  outline: 0;
}
textarea {
  resize: none;
  overflow: auto;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 16px;
}
a {
  text-decoration: none;
  cursor: pointer;
  color: #575757;
}
a:hover,
a:active {
  color: #ff8f00;
  text-decoration: none;
}
.clear {
  clear: both;
  font-size: 0px;
  line-height: 0px;
  height: 0px;
}
.clearfix:after {
  content: "";
  display: block;
  clear: both;
  font-size: 0px;
  line-height: 0px;
  height: 0px;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.hidden {
  display: none;
}
[nowrap] {
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}

/* 开始*/
.topNav {
  width: 100%;
  height: 100%;
  background: #fff;
}
.topNav .el-menu-item:hover {
  outline: 0 !important;
  background: #fff !important;
}
.topNav .el-menu-item.is-active {
  background: #fff !important;
}
.el-menu-demo {
  width: 1200px;
  margin: auto;
}
.logo {
  float: left;
  height: 44px;
  padding-top: 16px;
  margin-right: 20px;
}
.logo > img {
  height: 26px;
}
.menu_me {
  float: right;
  width: 365px;
}
.el-dropdown-link {
  float: right;
  height: 60px;
  overflow: hidden;
}
.el-dropdown-link img {
  display: block;
  float: left;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-top: 5px;
}
.el-dropdown-link span {
  display: block;
  float: left;
  height: 60px;
  line-height: 60px;
  padding: 0 12px;
  font-size: 16px;
  font-weight: 700;
}
.el-dropdown-link i {
  float: left;
  display: block;
  width: 20px;
  height: 50px;
  line-height: 50px;
  border-radius: 50%;
  margin-top: 5px;
}
.nav_con > p {
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.nav_con > p > a {
  color: #000;
}
.nav_con > p:hover,
.nav_con > p > a:hover {
  color: #f90;
}
.btn {
  background-color: rgba(253, 148, 15, 0.8) !important;
  border-radius: 6px;
}
.btn,
.btnZP {
  float: right;
  width: 100px;
  text-align: center;
  line-height: 38px;
  margin-top: 12px;
  margin-right: 20px;
  -webkit-box-shadow: hsla(0, 0%, 83.9%, 0.8) 2px 4px 1px 1px;
  box-shadow: 2px 4px 1px 1px hsla(0, 0%, 83.9%, 0.8);
  cursor: pointer;
}
.btnZP {
  border: 1px solid rgba(253, 148, 15, 0.8);
  border-radius: 6px;
}
.btn :hover,
.btnZP:hover {
  font-weight: 700;
  -webkit-box-shadow: hsla(0, 0%, 83.9%, 0.8) 2px 4px 1px 1px;
  box-shadow: 2px 4px 1px 1px hsla(0, 0%, 83.9%, 0.8);
}
.select_city {
  float: left;
  line-height: 61px;
  padding: 0 12px;
  font-size: 12px;
  color: #b47009;
  cursor: pointer;
}
.ziuzhiComponents {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
}
.zhiqiu {
  width: 436px;
  height: 276px;
  position: absolute;
  top: 50%;
  margin-top: -200px;
  left: 50%;
  margin-left: -230px;
  background: #fff;
  padding: 12px;
  border-radius: 12px;
}
.zhiqiu > .item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 40px;
}
.zhiqiu > .item > p {
  float: left;
  width: 200px;
  line-height: 40px;
  border-radius: 6px;
  border: 1px solid #e6e4e4;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  margin: 14px auto;
  color: #202020;
}
.zhiqiu > .item > .index,
.zhiqiu > .item > p:hover {
  font-weight: 700;
  border-color: #f5ae55;
}
.header {
  padding: 0 12px;
  margin-bottom: 25px;
}
.header h4 {
  margin: 0 0;
}
.header p {
  margin: 6px 0;
  font-size: 14px;
  color: #8d92a1;
}
.footer {
  text-align: right;
  padding-right: 20px;
}
.elite_layout {
  min-width: 1250px;
  position: relative;
}
.main {
  margin: auto;
}
.el-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 0;
  z-index: 10;
}
.el-main {
  padding: 0;
}
.el-message__closeBtn:focus,
.el-message__content:focus {
  outline-width: 0;
}
.el-message {
  min-width: 380px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: #ebeef5;
  position: fixed;
  left: 50%;
  top: 20px;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background-color: #edf2fc;
  -webkit-transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
  transition: opacity 0.3s, top 0.4s, -webkit-transform 0.4s;
  transition: opacity 0.3s, transform 0.4s, top 0.4s;
  transition: opacity 0.3s, transform 0.4s, top 0.4s, -webkit-transform 0.4s;
  overflow: hidden;
  padding: 15px 15px 15px 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.el-message.is-center {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.el-message.is-closable .el-message__content {
  padding-right: 16px;
}
.el-message p {
  margin: 0;
}
.el-message--info .el-message__content {
  color: #909399;
}
.el-message--success {
  background-color: #f0f9eb;
  border-color: #e1f3d8;
}
.el-message--success .el-message__content {
  color: #67c23a;
}
.el-message--warning {
  background-color: #fdf6ec;
  border-color: #faecd8;
}
.el-message--warning .el-message__content {
  color: #e6a23c;
}
.el-message--error {
  background-color: #fef0f0;
  border-color: #fde2e2;
}
.el-message--error .el-message__content {
  color: #f56c6c;
}
.el-message__icon {
  margin-right: 10px;
}
.el-message__content {
  padding: 0;
  font-size: 14px;
  line-height: 1;
}
.el-message__closeBtn {
  position: absolute;
  top: 50%;
  right: 15px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
  color: #c0c4cc;
  font-size: 16px;
}
.el-message__closeBtn:hover {
  color: #909399;
}
.el-message .el-icon-success {
  color: #67c23a;
}
.el-message .el-icon-error {
  color: #f56c6c;
}
.el-message .el-icon-info {
  color: #909399;
}
.el-message .el-icon-warning {
  color: #e6a23c;
}
.el-message-fade-enter,
.el-message-fade-leave-active {
  opacity: 0;
  -webkit-transform: translate(-50%, -100%);
  transform: translate(-50%, -100%);
}
.el-notification {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 330px;
  padding: 14px 26px 14px 13px;
  border-radius: 8px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
  position: fixed;
  background-color: #fff;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  -webkit-transition: opacity 0.3s, left 0.3s, right 0.3s, top 0.4s, bottom 0.3s,
    -webkit-transform 0.3s;
  transition: opacity 0.3s, left 0.3s, right 0.3s, top 0.4s, bottom 0.3s,
    -webkit-transform 0.3s;
  transition: opacity 0.3s, transform 0.3s, left 0.3s, right 0.3s, top 0.4s,
    bottom 0.3s;
  transition: opacity 0.3s, transform 0.3s, left 0.3s, right 0.3s, top 0.4s,
    bottom 0.3s, -webkit-transform 0.3s;
  overflow: hidden;
}
.el-notification.right {
  right: 16px;
}
.el-notification.left {
  left: 16px;
}
.el-notification__group {
  margin-left: 13px;
  margin-right: 8px;
}
.el-notification__title {
  font-weight: 700;
  font-size: 16px;
  color: #303133;
  margin: 0;
}
.el-notification__content {
  font-size: 14px;
  line-height: 21px;
  margin: 6px 0 0;
  color: #606266;
  text-align: justify;
}
.el-notification__content p {
  margin: 0;
}
.el-notification__icon {
  height: 24px;
  width: 24px;
  font-size: 24px;
}
.el-notification__closeBtn {
  position: absolute;
  top: 18px;
  right: 15px;
  cursor: pointer;
  color: #909399;
  font-size: 16px;
}
.el-notification__closeBtn:hover {
  color: #606266;
}
.el-notification .el-icon-success {
  color: #67c23a;
}
.el-notification .el-icon-error {
  color: #f56c6c;
}
.el-notification .el-icon-info {
  color: #909399;
}
.el-notification .el-icon-warning {
  color: #e6a23c;
}
.el-notification-fade-enter.right {
  right: 0;
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
}
.el-notification-fade-enter.left {
  left: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
}
.el-notification-fade-leave-active {
  opacity: 0;
}

.el-message-box,
.el-popup-parent--hidden {
  overflow: hidden;
}
.el-message-box {
  display: inline-block;
  width: 420px;
  padding-bottom: 10px;
  vertical-align: middle;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.el-message-box__wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
}
.el-message-box__wrapper:after {
  content: "";
  display: inline-block;
  height: 100%;
  width: 0;
  vertical-align: middle;
}
.el-message-box__header {
  position: relative;
  padding: 15px 15px 10px;
}
.el-message-box__title {
  padding-left: 0;
  margin-bottom: 0;
  font-size: 18px;
  line-height: 1;
  color: #303133;
}
.el-message-box__headerbtn {
  position: absolute;
  top: 15px;
  right: 15px;
  padding: 0;
  border: none;
  outline: 0;
  background: 0 0;
  font-size: 16px;
  cursor: pointer;
}
.el-message-box__headerbtn .el-message-box__close {
  color: #909399;
}
.el-message-box__headerbtn:focus .el-message-box__close,
.el-message-box__headerbtn:hover .el-message-box__close {
  color: #409eff;
}
.el-message-box__content {
  padding: 10px 15px;
  color: #606266;
  font-size: 14px;
}
.el-message-box__container {
  position: relative;
}
.el-message-box__input {
  padding-top: 15px;
}
.el-message-box__input input.invalid,
.el-message-box__input input.invalid:focus {
  border-color: #f56c6c;
}
.el-message-box__status {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 24px !important;
}
.el-message-box__status:before {
  padding-left: 1px;
}
.el-message-box__status + .el-message-box__message {
  padding-left: 36px;
  padding-right: 12px;
}
.el-message-box__status.el-icon-success {
  color: #67c23a;
}
.el-message-box__status.el-icon-info {
  color: #909399;
}
.el-message-box__status.el-icon-warning {
  color: #e6a23c;
}
.el-message-box__status.el-icon-error {
  color: #f56c6c;
}
.el-message-box__message {
  margin: 0;
}
.el-message-box__message p {
  margin: 0;
  line-height: 24px;
}
.el-message-box__errormsg {
  color: #f56c6c;
  font-size: 12px;
  min-height: 18px;
  margin-top: 2px;
}
.el-message-box__btns {
  padding: 5px 15px 0;
  text-align: right;
}
.el-message-box__btns button:nth-child(2) {
  margin-left: 10px;
}
.el-message-box__btns-reverse {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
}
.el-message-box--center {
  padding-bottom: 30px;
}
.el-message-box--center .el-message-box__header {
  padding-top: 30px;
}
.el-message-box--center .el-message-box__title {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.el-message-box--center .el-message-box__status {
  position: relative;
  top: auto;
  padding-right: 5px;
  text-align: center;
  -webkit-transform: translateY(-1px);
  transform: translateY(-1px);
}
.el-message-box--center .el-message-box__message {
  margin-left: 0;
}
.el-message-box--center .el-message-box__btns,
.el-message-box--center .el-message-box__content {
  text-align: center;
}
.el-message-box--center .el-message-box__content {
  padding-left: 27px;
  padding-right: 27px;
}
.msgbox-fade-enter-active {
  -webkit-animation: msgbox-fade-in 0.3s;
  animation: msgbox-fade-in 0.3s;
}
.msgbox-fade-leave-active {
  -webkit-animation: msgbox-fade-out 0.3s;
  animation: msgbox-fade-out 0.3s;
}
@-webkit-keyframes msgbox-fade-in {
  0% {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}
@keyframes msgbox-fade-in {
  0% {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}
@-webkit-keyframes msgbox-fade-out {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
  to {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}
@keyframes msgbox-fade-out {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
  to {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}
.el-loading-parent--relative {
  position: relative !important;
}
.el-loading-parent--hidden {
  overflow: hidden !important;
}
.el-loading-mask {
  position: absolute;
  z-index: 2000;
  background-color: hsla(0, 0%, 100%, 0.9);
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
}
.el-loading-mask.is-fullscreen {
  position: fixed;
}
.el-loading-mask.is-fullscreen .el-loading-spinner {
  margin-top: -25px;
}
.el-loading-mask.is-fullscreen .el-loading-spinner .circular {
  height: 50px;
  width: 50px;
}
.el-loading-spinner {
  top: 50%;
  margin-top: -21px;
  width: 100%;
  text-align: center;
  position: absolute;
}
.el-loading-spinner .el-loading-text {
  color: #409eff;
  margin: 3px 0;
  font-size: 14px;
}
.el-loading-spinner .circular {
  height: 42px;
  width: 42px;
  -webkit-animation: loading-rotate 2s linear infinite;
  animation: loading-rotate 2s linear infinite;
}
.el-loading-spinner .path {
  -webkit-animation: loading-dash 1.5s ease-in-out infinite;
  animation: loading-dash 1.5s ease-in-out infinite;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
  stroke: #409eff;
  stroke-linecap: round;
}
.el-loading-spinner i {
  color: #409eff;
}
.el-loading-fade-enter,
.el-loading-fade-leave-active {
  opacity: 0;
}
@-webkit-keyframes loading-rotate {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
@keyframes loading-rotate {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
@-webkit-keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px;
  }
  to {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px;
  }
}
@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px;
  }
  to {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px;
  }
}
.el-image__error,
.el-image__placeholder {
  background: #f5f7fa;
}
.el-image__error,
.el-image__inner,
.el-image__placeholder {
  width: 100%;
  height: 100%;
}
.el-image {
  position: relative;
  display: inline-block;
  overflow: hidden;
}
.el-image__inner {
  vertical-align: top;
}
.el-image__inner--center {
  position: relative;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  display: block;
}
.el-image__error {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 14px;
  color: #c0c4cc;
  vertical-align: middle;
}
.el-image__preview {
  cursor: pointer;
}
.el-image-viewer__wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.el-image-viewer__btn {
  position: absolute;
  z-index: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 50%;
  opacity: 0.8;
  cursor: pointer;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.el-image-viewer__close {
  top: 40px;
  right: 40px;
  width: 40px;
  height: 40px;
  font-size: 24px;
  color: #fff;
  background-color: #606266;
}
.el-image-viewer__canvas {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.el-image-viewer__actions {
  left: 50%;
  bottom: 30px;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 282px;
  height: 44px;
  padding: 0 23px;
  background-color: #606266;
  border-color: #fff;
  border-radius: 22px;
}
.el-image-viewer__actions__inner {
  width: 100%;
  height: 100%;
  text-align: justify;
  cursor: default;
  font-size: 23px;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: distribute;
  justify-content: space-around;
}
.el-image-viewer__next,
.el-image-viewer__prev {
  top: 50%;
  width: 44px;
  height: 44px;
  font-size: 24px;
  color: #fff;
  background-color: #606266;
  border-color: #fff;
}
.el-image-viewer__prev {
  left: 40px;
}
.el-image-viewer__next,
.el-image-viewer__prev {
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.el-image-viewer__next {
  right: 40px;
  text-indent: 2px;
}
.el-image-viewer__mask {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.5;
  background: #000;
}
.viewer-fade-enter-active {
  -webkit-animation: viewer-fade-in 0.3s;
  animation: viewer-fade-in 0.3s;
}
.viewer-fade-leave-active {
  -webkit-animation: viewer-fade-out 0.3s;
  animation: viewer-fade-out 0.3s;
}
@-webkit-keyframes viewer-fade-in {
  0% {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}
@keyframes viewer-fade-in {
  0% {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}
@-webkit-keyframes viewer-fade-out {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
  to {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}
@keyframes viewer-fade-out {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
  to {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}
.el-divider {
  background-color: #dcdfe6;
  position: relative;
}
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 24px 0;
}
.el-divider--vertical {
  display: inline-block;
  width: 1px;
  height: 1em;
  margin: 0 8px;
  vertical-align: middle;
  position: relative;
}
.el-divider__text {
  position: absolute;
  background-color: #fff;
  padding: 0 20px;
  font-weight: 500;
  color: #303133;
  font-size: 14px;
}
.el-divider__text.is-left {
  left: 20px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.el-divider__text.is-center {
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}
.el-divider__text.is-right {
  right: 20px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.el-main {
  display: block;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
  overflow: auto;
  padding: 20px;
}
.el-header,
.el-main {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-header {
  padding: 0 20px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
.el-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  min-width: 0;
}
.el-container.is-vertical {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.el-checkbox.is-bordered,
.el-tag {
  border-radius: 4px;
  -webkit-box-sizing: border-box;
}
.el-checkbox-button__inner,
.el-radio {
  font-weight: 500;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.el-radio,
.el-radio__input {
  line-height: 1;
  white-space: nowrap;
  outline: 0;
}
.el-radio,
.el-radio__inner,
.el-radio__input {
  position: relative;
  display: inline-block;
}
.el-radio,
.el-radio--medium.is-bordered .el-radio__label {
  font-size: 14px;
}
.el-radio {
  color: #606266;
  cursor: pointer;
  margin-right: 30px;
}
.el-cascader-node > .el-radio,
.el-radio:last-child {
  margin-right: 0;
}
.el-radio.is-bordered {
  padding: 12px 20px 0 10px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 40px;
}
.el-radio.is-bordered.is-checked {
  border-color: #409eff;
}
.el-radio.is-bordered.is-disabled {
  cursor: not-allowed;
  border-color: #ebeef5;
}
.el-radio__input.is-disabled .el-radio__inner,
.el-radio__input.is-disabled.is-checked .el-radio__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
}
.el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 10px;
}
.el-radio--medium.is-bordered {
  padding: 10px 20px 0 10px;
  border-radius: 4px;
  height: 36px;
}
.el-radio--mini.is-bordered .el-radio__label,
.el-radio--small.is-bordered .el-radio__label {
  font-size: 12px;
}
.el-radio--medium.is-bordered .el-radio__inner {
  height: 14px;
  width: 14px;
}
.el-radio--small.is-bordered {
  padding: 8px 15px 0 10px;
  border-radius: 3px;
  height: 32px;
}
.el-radio--small.is-bordered .el-radio__inner {
  height: 12px;
  width: 12px;
}
.el-radio--mini.is-bordered {
  padding: 6px 15px 0 10px;
  border-radius: 3px;
  height: 28px;
}
.el-radio--mini.is-bordered .el-radio__inner {
  height: 12px;
  width: 12px;
}
.el-radio__input {
  cursor: pointer;
  vertical-align: middle;
}
.el-radio__input.is-disabled .el-radio__inner {
  cursor: not-allowed;
}
.el-radio__input.is-disabled .el-radio__inner:after {
  cursor: not-allowed;
  background-color: #f5f7fa;
}
.el-radio__input.is-disabled .el-radio__inner + .el-radio__label {
  cursor: not-allowed;
}
.el-radio__input.is-disabled.is-checked .el-radio__inner:after {
  background-color: #c0c4cc;
}
.el-radio__input.is-disabled + span.el-radio__label {
  color: #c0c4cc;
  cursor: not-allowed;
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: #409eff;
  background: #409eff;
}
.el-radio__input.is-checked .el-radio__inner:after {
  -webkit-transform: translate(-50%, -50%) scale(1);
  transform: translate(-50%, -50%) scale(1);
}
.el-radio__input.is-checked + .el-radio__label {
  color: #409eff;
}
.el-radio__input.is-focus .el-radio__inner {
  border-color: #409eff;
}
.el-radio__inner {
  border: 1px solid #dcdfe6;
  border-radius: 100%;
  width: 14px;
  height: 14px;
  background-color: #fff;
  cursor: pointer;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-radio__inner:hover {
  border-color: #409eff;
}
.el-radio__inner:after {
  width: 4px;
  height: 4px;
  border-radius: 100%;
  background-color: #fff;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%) scale(0);
  transform: translate(-50%, -50%) scale(0);
  -webkit-transition: -webkit-transform 0.15s ease-in;
  transition: -webkit-transform 0.15s ease-in;
  transition: transform 0.15s ease-in;
  transition: transform 0.15s ease-in, -webkit-transform 0.15s ease-in;
}
.el-radio__original {
  opacity: 0;
  outline: 0;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
}
.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  -webkit-box-shadow: 0 0 2px 2px #409eff;
  box-shadow: 0 0 2px 2px #409eff;
}
.el-radio__label {
  font-size: 14px;
  padding-left: 10px;
}
.el-cascader-panel {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-radius: 4px;
  font-size: 14px;
}
.el-cascader-panel.is-bordered {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}
.el-cascader-menu {
  min-width: 180px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  border-right: 1px solid #e4e7ed;
}
.el-cascader-menu:last-child {
  border-right: none;
}
.el-cascader-menu:last-child .el-cascader-node {
  padding-right: 20px;
}
.el-cascader-menu__wrap {
  height: 204px;
}
.el-cascader-menu__list {
  position: relative;
  min-height: 100%;
  margin: 0;
  padding: 6px 0;
  list-style: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-cascader-menu__hover-zone {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.el-cascader-menu__empty-text {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
  color: #c0c4cc;
}
.el-cascader-node {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 30px 0 20px;
  height: 34px;
  line-height: 34px;
  outline: 0;
}
.el-cascader-node.is-selectable.in-active-path {
  color: #606266;
}
.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #409eff;
  font-weight: 700;
}
.el-cascader-node:not(.is-disabled) {
  cursor: pointer;
}
.el-cascader-node:not(.is-disabled):focus,
.el-cascader-node:not(.is-disabled):hover {
  background: #f5f7fa;
}
.el-cascader-node.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}
.el-cascader-node__prefix {
  position: absolute;
  left: 10px;
}
.el-cascader-node__postfix {
  position: absolute;
  right: 10px;
}
.el-cascader-node__label {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-cascader-node > .el-radio .el-radio__label {
  padding-left: 0;
}
.el-cascader {
  display: inline-block;
  position: relative;
  font-size: 14px;
  line-height: 40px;
}
.el-cascader:not(.is-disabled):hover .el-input__inner {
  cursor: pointer;
  border-color: #c0c4cc;
}
.el-cascader .el-input .el-input__inner:focus,
.el-cascader .el-input.is-focus .el-input__inner {
  border-color: #409eff;
}
.el-cascader .el-input {
  cursor: pointer;
}
.el-cascader .el-input .el-input__inner {
  text-overflow: ellipsis;
}
.el-cascader .el-input .el-icon-arrow-down {
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  font-size: 14px;
}
.el-cascader .el-input .el-icon-arrow-down.is-reverse {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.el-cascader .el-input .el-icon-circle-close:hover {
  color: #909399;
}
.el-cascader--medium {
  font-size: 14px;
  line-height: 36px;
}
.el-cascader--small {
  font-size: 13px;
  line-height: 32px;
}
.el-cascader--mini {
  font-size: 12px;
  line-height: 28px;
}
.el-cascader.is-disabled .el-cascader__label {
  z-index: 2;
  color: #c0c4cc;
}
.el-cascader__dropdown {
  margin: 5px 0;
  font-size: 14px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.el-cascader__tags {
  position: absolute;
  left: 0;
  right: 30px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  line-height: normal;
  text-align: left;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-cascader__tags .el-tag {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-width: 100%;
  margin: 2px 0 2px 6px;
  text-overflow: ellipsis;
  background: #f0f2f5;
}
.el-cascader__tags .el-tag:not(.is-hit) {
  border-color: transparent;
}
.el-cascader__tags .el-tag > span {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-cascader__tags .el-tag .el-icon-close {
  -webkit-box-flex: 0;
  -ms-flex: none;
  flex: none;
  background-color: #c0c4cc;
  color: #fff;
}
.el-cascader__tags .el-tag .el-icon-close:hover {
  background-color: #909399;
}
.el-cascader__suggestion-panel {
  border-radius: 4px;
}
.el-cascader__suggestion-list {
  max-height: 204px;
  margin: 0;
  padding: 6px 0;
  font-size: 14px;
  color: #606266;
  text-align: center;
}
.el-cascader__suggestion-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 34px;
  padding: 0 15px;
  text-align: left;
  outline: 0;
  cursor: pointer;
}
.el-cascader__suggestion-item:focus,
.el-cascader__suggestion-item:hover {
  background: #f5f7fa;
}
.el-cascader__suggestion-item.is-checked {
  color: #409eff;
  font-weight: 700;
}
.el-cascader__suggestion-item > span {
  margin-right: 10px;
}
.el-cascader__empty-text {
  margin: 10px 0;
  color: #c0c4cc;
}
.el-cascader__search-input {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 24px;
  min-width: 60px;
  margin: 2px 0 2px 15px;
  padding: 0;
  color: #606266;
  border: none;
  outline: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-cascader__search-input::-webkit-input-placeholder {
  color: #c0c4cc;
}
.el-cascader__search-input:-ms-input-placeholder {
  color: #c0c4cc;
}
.el-cascader__search-input::-ms-input-placeholder {
  color: #c0c4cc;
}
.el-cascader__search-input::-moz-placeholder {
  color: #c0c4cc;
}
.el-cascader__search-input::placeholder {
  color: #c0c4cc;
}
.el-carousel__item,
.el-carousel__mask {
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
}
.el-carousel__item {
  width: 100%;
  display: inline-block;
  overflow: hidden;
  z-index: 0;
}
.el-carousel__item.is-active {
  z-index: 2;
}
.el-carousel__item--card,
.el-carousel__item.is-animating {
  -webkit-transition: -webkit-transform 0.4s ease-in-out;
  transition: -webkit-transform 0.4s ease-in-out;
  transition: transform 0.4s ease-in-out;
  transition: transform 0.4s ease-in-out, -webkit-transform 0.4s ease-in-out;
}
.el-carousel__item--card {
  width: 50%;
}
.el-carousel__item--card.is-in-stage {
  cursor: pointer;
  z-index: 1;
}
.el-carousel__item--card.is-in-stage.is-hover .el-carousel__mask,
.el-carousel__item--card.is-in-stage:hover .el-carousel__mask {
  opacity: 0.12;
}
.el-carousel__item--card.is-active {
  z-index: 2;
}
.el-carousel__mask {
  width: 100%;
  background-color: #fff;
  opacity: 0.24;
  -webkit-transition: 0.2s;
  transition: 0.2s;
}
.el-carousel {
  position: relative;
}
.el-carousel--horizontal {
  overflow-x: hidden;
}
.el-carousel--vertical {
  overflow-y: hidden;
}
.el-carousel__container {
  position: relative;
  height: 300px;
}
.el-carousel__arrow {
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  height: 36px;
  width: 36px;
  cursor: pointer;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  border-radius: 50%;
  background-color: rgba(31, 45, 61, 0.11);
  color: #fff;
  position: absolute;
  top: 50%;
  z-index: 10;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  text-align: center;
  font-size: 12px;
}
.el-carousel__arrow--left {
  left: 16px;
}
.el-carousel__arrow--right {
  right: 16px;
}
.el-carousel__arrow:hover {
  background-color: rgba(31, 45, 61, 0.23);
}
.el-carousel__arrow i {
  cursor: pointer;
}
.el-carousel__indicators {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  z-index: 2;
}
.el-carousel__indicators--horizontal {
  bottom: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
.el-carousel__indicators--vertical {
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.el-carousel__indicators--outside {
  bottom: 26px;
  text-align: center;
  position: static;
  -webkit-transform: none;
  transform: none;
}
.el-carousel__indicators--outside .el-carousel__indicator:hover button {
  opacity: 0.64;
}
.el-carousel__indicators--outside button {
  background-color: #c0c4cc;
  opacity: 0.24;
}
.el-carousel__indicators--labels {
  left: 0;
  right: 0;
  -webkit-transform: none;
  transform: none;
  text-align: center;
}
.el-carousel__indicators--labels .el-carousel__button {
  height: auto;
  width: auto;
  padding: 2px 18px;
  font-size: 12px;
}
.el-carousel__indicators--labels .el-carousel__indicator {
  padding: 6px 4px;
}
.el-carousel__indicator {
  background-color: transparent;
  cursor: pointer;
}
.el-carousel__indicator:hover button {
  opacity: 0.72;
}
.el-carousel__indicator--horizontal {
  display: inline-block;
  padding: 12px 4px;
}
.el-carousel__indicator--vertical {
  padding: 4px 12px;
}
.el-carousel__indicator--vertical .el-carousel__button {
  width: 2px;
  height: 15px;
}
.el-carousel__indicator.is-active button {
  opacity: 1;
}
.el-carousel__button {
  display: block;
  opacity: 0.48;
  width: 30px;
  height: 2px;
  background-color: #fff;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.carousel-arrow-left-enter,
.carousel-arrow-left-leave-active {
  -webkit-transform: translateY(-50%) translateX(-10px);
  transform: translateY(-50%) translateX(-10px);
  opacity: 0;
}
.carousel-arrow-right-enter,
.carousel-arrow-right-leave-active {
  -webkit-transform: translateY(-50%) translateX(10px);
  transform: translateY(-50%) translateX(10px);
  opacity: 0;
}
.el-card {
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.el-card__header {
  padding: 18px 20px;
  border-bottom: 1px solid #ebeef5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-card__body {
  padding: 20px;
}
.el-badge {
  position: relative;
  vertical-align: middle;
  display: inline-block;
}
.el-badge__content {
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #fff;
}
.el-badge__content.is-fixed {
  position: absolute;
  top: 0;
  right: 10px;
  -webkit-transform: translateY(-50%) translateX(100%);
  transform: translateY(-50%) translateX(100%);
}
.el-badge__content.is-fixed.is-dot {
  right: 5px;
}
.el-badge__content.is-dot {
  height: 8px;
  width: 8px;
  padding: 0;
  right: 0;
  border-radius: 50%;
}
.el-badge__content--primary {
  background-color: #409eff;
}
.el-badge__content--success {
  background-color: #67c23a;
}
.el-badge__content--warning {
  background-color: #e6a23c;
}
.el-badge__content--info {
  background-color: #909399;
}
.el-badge__content--danger {
  background-color: #f56c6c;
}
.el-upload-cover__title,
.el-upload-list__item-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-progress {
  position: relative;
  line-height: 1;
}
.el-progress__text {
  font-size: 14px;
  color: #606266;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  line-height: 1;
}
.el-progress__text i {
  vertical-align: middle;
  display: block;
}
.el-progress--circle,
.el-progress--dashboard {
  display: inline-block;
}
.el-progress--circle .el-progress__text,
.el-progress--dashboard .el-progress__text {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  text-align: center;
  margin: 0;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.el-progress--circle .el-progress__text i,
.el-progress--dashboard .el-progress__text i {
  vertical-align: middle;
  display: inline-block;
}
.el-progress--without-text .el-progress__text {
  display: none;
}
.el-progress--without-text .el-progress-bar {
  padding-right: 0;
  margin-right: 0;
  display: block;
}
.el-progress--text-inside .el-progress-bar {
  padding-right: 0;
  margin-right: 0;
}
.el-progress.is-success .el-progress-bar__inner {
  background-color: #67c23a;
}
.el-progress.is-success .el-progress__text {
  color: #67c23a;
}
.el-progress.is-warning .el-progress-bar__inner {
  background-color: #e6a23c;
}
.el-progress.is-warning .el-progress__text {
  color: #e6a23c;
}
.el-progress.is-exception .el-progress-bar__inner {
  background-color: #f56c6c;
}
.el-progress.is-exception .el-progress__text {
  color: #f56c6c;
}
.el-progress-bar {
  padding-right: 50px;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  margin-right: -55px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-upload--picture-card,
.el-upload-dragger {
  -webkit-box-sizing: border-box;
  cursor: pointer;
}
.el-progress-bar__outer {
  height: 6px;
  border-radius: 100px;
  background-color: #ebeef5;
  overflow: hidden;
  position: relative;
  vertical-align: middle;
}
.el-progress-bar__inner {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #409eff;
  text-align: right;
  border-radius: 100px;
  line-height: 1;
  white-space: nowrap;
  -webkit-transition: width 0.6s ease;
  transition: width 0.6s ease;
}
.el-progress-bar__inner:after {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}
.el-progress-bar__innerText {
  display: inline-block;
  vertical-align: middle;
  color: #fff;
  font-size: 12px;
  margin: 0 5px;
}
@-webkit-keyframes progress {
  0% {
    background-position: 0 0;
  }
  to {
    background-position: 32px 0;
  }
}
@keyframes progress {
  0% {
    background-position: 0 0;
  }
  to {
    background-position: 32px 0;
  }
}
.el-upload {
  display: inline-block;
  text-align: center;
  cursor: pointer;
  outline: 0;
}
.el-upload__input {
  display: none;
}
.el-upload__tip {
  font-size: 12px;
  color: #606266;
  margin-top: 7px;
}
.el-upload iframe {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  opacity: 0;
}
.el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  line-height: 146px;
  vertical-align: top;
}
.el-upload--picture-card i {
  font-size: 28px;
  color: #8c939d;
}
.el-upload--picture-card:hover,
.el-upload:focus {
  border-color: #409eff;
  color: #409eff;
}
.el-upload:focus .el-upload-dragger {
  border-color: #409eff;
}
.el-upload-dragger {
  background-color: #fff;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 360px;
  height: 180px;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.el-upload-dragger .el-icon-upload {
  font-size: 67px;
  color: #c0c4cc;
  margin: 40px 0 16px;
  line-height: 50px;
}
.el-upload-dragger + .el-upload__tip {
  text-align: center;
}
.el-upload-dragger ~ .el-upload__files {
  border-top: 1px solid #dcdfe6;
  margin-top: 7px;
  padding-top: 5px;
}
.el-upload-dragger .el-upload__text {
  color: #606266;
  font-size: 14px;
  text-align: center;
}
.el-upload-dragger .el-upload__text em {
  color: #409eff;
  font-style: normal;
}
.el-upload-dragger:hover {
  border-color: #409eff;
}
.el-upload-dragger.is-dragover {
  background-color: rgba(32, 159, 255, 0.06);
  border: 2px dashed #409eff;
}
.el-upload-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.el-upload-list__item {
  -webkit-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
  font-size: 14px;
  color: #606266;
  line-height: 1.8;
  margin-top: 5px;
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 4px;
  width: 100%;
}
.el-upload-list__item .el-progress {
  position: absolute;
  top: 20px;
  width: 100%;
}
.el-upload-list__item .el-progress__text {
  position: absolute;
  right: 0;
  top: -13px;
}
.el-upload-list__item .el-progress-bar {
  margin-right: 0;
  padding-right: 0;
}
.el-upload-list__item:first-child {
  margin-top: 10px;
}
.el-upload-list__item .el-icon-upload-success {
  color: #67c23a;
}
.el-upload-list__item .el-icon-close {
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  opacity: 0.75;
  color: #606266;
}
.el-upload-list__item .el-icon-close:hover {
  opacity: 1;
}
.el-upload-list__item .el-icon-close-tip {
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 12px;
  cursor: pointer;
  opacity: 1;
  color: #409eff;
}
.el-upload-list__item:hover {
  background-color: #f5f7fa;
}
.el-upload-list__item:hover .el-icon-close {
  display: inline-block;
}
.el-upload-list__item:hover .el-progress__text {
  display: none;
}
.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: block;
}
.el-upload-list__item.is-success .el-upload-list__item-name:focus,
.el-upload-list__item.is-success .el-upload-list__item-name:hover {
  color: #409eff;
  cursor: pointer;
}
.el-upload-list__item.is-success:focus:not(:hover) .el-icon-close-tip {
  display: inline-block;
}
.el-upload-list__item.is-success:active,
.el-upload-list__item.is-success:not(.focusing):focus {
  outline-width: 0;
}
.el-upload-list__item.is-success:active .el-icon-close-tip,
.el-upload-list__item.is-success:focus .el-upload-list__item-status-label,
.el-upload-list__item.is-success:hover .el-upload-list__item-status-label,
.el-upload-list__item.is-success:not(.focusing):focus .el-icon-close-tip {
  display: none;
}
.el-upload-list.is-disabled
  .el-upload-list__item:hover
  .el-upload-list__item-status-label {
  display: block;
}
.el-upload-list__item-name {
  color: #606266;
  display: block;
  margin-right: 40px;
  padding-left: 4px;
  -webkit-transition: color 0.3s;
  transition: color 0.3s;
}
.el-upload-list__item-name [class^="el-icon"] {
  height: 100%;
  margin-right: 7px;
  color: #909399;
  line-height: inherit;
}
.el-upload-list__item-status-label {
  position: absolute;
  right: 5px;
  top: 0;
  line-height: inherit;
  display: none;
}
.el-upload-list__item-delete {
  position: absolute;
  right: 10px;
  top: 0;
  font-size: 12px;
  color: #606266;
  display: none;
}
.el-upload-list__item-delete:hover {
  color: #409eff;
}
.el-upload-list--picture-card {
  margin: 0;
  display: inline;
  vertical-align: top;
}
.el-upload-list--picture-card .el-upload-list__item {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  margin: 0 8px 8px 0;
  display: inline-block;
}
.el-upload-list--picture-card .el-upload-list__item .el-icon-check,
.el-upload-list--picture-card .el-upload-list__item .el-icon-circle-check {
  color: #fff;
}
.el-upload-list--picture-card .el-upload-list__item .el-icon-close,
.el-upload-list--picture-card
  .el-upload-list__item:hover
  .el-upload-list__item-status-label {
  display: none;
}
.el-upload-list--picture-card .el-upload-list__item:hover .el-progress__text {
  display: block;
}
.el-upload-list--picture-card .el-upload-list__item-name {
  display: none;
}
.el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 100%;
  height: 100%;
}
.el-upload-list--picture-card .el-upload-list__item-status-label {
  position: absolute;
  right: -15px;
  top: -6px;
  width: 40px;
  height: 24px;
  background: #13ce66;
  text-align: center;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  -webkit-box-shadow: 0 0 1pc 1px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 1pc 1px rgba(0, 0, 0, 0.2);
}
.el-upload-list--picture-card .el-upload-list__item-status-label i {
  font-size: 12px;
  margin-top: 11px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.el-upload-list--picture-card .el-upload-list__item-actions {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
}
.el-upload-list--picture-card .el-upload-list__item-actions:after {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}
.el-upload-list--picture-card .el-upload-list__item-actions span {
  display: none;
  cursor: pointer;
}
.el-upload-list--picture-card .el-upload-list__item-actions span + span {
  margin-left: 15px;
}
.el-upload-list--picture-card
  .el-upload-list__item-actions
  .el-upload-list__item-delete {
  position: static;
  font-size: inherit;
  color: inherit;
}
.el-upload-list--picture-card .el-upload-list__item-actions:hover {
  opacity: 1;
}
.el-upload-list--picture-card .el-upload-list__item-actions:hover span {
  display: inline-block;
}
.el-upload-list--picture-card .el-progress {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  bottom: auto;
  width: 126px;
}
.el-upload-list--picture-card .el-progress .el-progress__text {
  top: 50%;
}
.el-upload-list--picture .el-upload-list__item {
  overflow: hidden;
  z-index: 0;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: 10px;
  padding: 10px 10px 10px 90px;
  height: 92px;
}
.el-upload-list--picture .el-upload-list__item .el-icon-check,
.el-upload-list--picture .el-upload-list__item .el-icon-circle-check {
  color: #fff;
}
.el-upload-list--picture
  .el-upload-list__item:hover
  .el-upload-list__item-status-label {
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  top: -2px;
  right: -12px;
}
.el-upload-list--picture .el-upload-list__item:hover .el-progress__text {
  display: block;
}
.el-upload-list--picture
  .el-upload-list__item.is-success
  .el-upload-list__item-name {
  line-height: 70px;
  margin-top: 0;
}
.el-upload-list--picture
  .el-upload-list__item.is-success
  .el-upload-list__item-name
  i {
  display: none;
}
.el-upload-list--picture .el-upload-list__item-thumbnail {
  vertical-align: middle;
  display: inline-block;
  width: 70px;
  height: 70px;
  float: left;
  position: relative;
  z-index: 1;
  margin-left: -80px;
  background-color: #fff;
}
.el-upload-list--picture .el-upload-list__item-name {
  display: block;
  margin-top: 20px;
}
.el-upload-list--picture .el-upload-list__item-name i {
  font-size: 70px;
  line-height: 1;
  position: absolute;
  left: 9px;
  top: 10px;
}
.el-upload-list--picture .el-upload-list__item-status-label {
  position: absolute;
  right: -17px;
  top: -7px;
  width: 46px;
  height: 26px;
  background: #13ce66;
  text-align: center;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  -webkit-box-shadow: 0 1px 1px #ccc;
  box-shadow: 0 1px 1px #ccc;
}
.el-upload-list--picture .el-upload-list__item-status-label i {
  font-size: 12px;
  margin-top: 12px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.el-upload-list--picture .el-progress {
  position: relative;
  top: -7px;
}
.el-upload-cover {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 10;
  cursor: default;
}
.el-upload-cover:after {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}
.el-upload-cover img {
  display: block;
  width: 100%;
  height: 100%;
}
.el-upload-cover__label {
  position: absolute;
  right: -15px;
  top: -6px;
  width: 40px;
  height: 24px;
  background: #13ce66;
  text-align: center;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  -webkit-box-shadow: 0 0 1pc 1px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 1pc 1px rgba(0, 0, 0, 0.2);
}
.el-upload-cover__label i {
  font-size: 12px;
  margin-top: 11px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  color: #fff;
}
.el-upload-cover__progress {
  display: inline-block;
  vertical-align: middle;
  position: static;
  width: 243px;
}
.el-upload-cover__progress + .el-upload__inner {
  opacity: 0;
}
.el-upload-cover__content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.el-upload-cover__interact {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.72);
  text-align: center;
}
.el-upload-cover__interact .btn {
  display: inline-block;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  vertical-align: middle;
  -webkit-transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  margin-top: 60px;
}
.el-upload-cover__interact .btn span {
  opacity: 0;
  -webkit-transition: opacity 0.15s linear;
  transition: opacity 0.15s linear;
}
.el-upload-cover__interact .btn:not(:first-child) {
  margin-left: 35px;
}
.el-upload-cover__interact .btn:hover {
  -webkit-transform: translateY(-13px);
  transform: translateY(-13px);
}
.el-upload-cover__interact .btn:hover span {
  opacity: 1;
}
.el-upload-cover__interact .btn i {
  color: #fff;
  display: block;
  font-size: 24px;
  line-height: inherit;
  margin: 0 auto 5px;
}
.el-upload-cover__title {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #fff;
  height: 36px;
  width: 100%;
  font-weight: 400;
  text-align: left;
  padding: 0 10px;
  margin: 0;
  line-height: 36px;
  font-size: 14px;
  color: #303133;
}
.el-upload-cover + .el-upload__inner {
  opacity: 0;
  position: relative;
  z-index: 1;
}
@font-face {
  font-family: element-icons;
  src: url(../../assets/fonts/element-icons.woff) format("woff"),
    url(../../assets/fonts/element-icons.ttf) format("truetype");
  font-weight: 400;
  font-display: auto;
  font-style: normal;
}
[class*=" el-icon-"],
[class^="el-icon-"] {
  font-family: element-icons !important;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-icon-ice-cream-round:before {
  content: "\e6a0";
}
.el-icon-ice-cream-square:before {
  content: "\e6a3";
}
.el-icon-lollipop:before {
  content: "\e6a4";
}
.el-icon-potato-strips:before {
  content: "\e6a5";
}
.el-icon-milk-tea:before {
  content: "\e6a6";
}
.el-icon-ice-drink:before {
  content: "\e6a7";
}
.el-icon-ice-tea:before {
  content: "\e6a9";
}
.el-icon-coffee:before {
  content: "\e6aa";
}
.el-icon-orange:before {
  content: "\e6ab";
}
.el-icon-pear:before {
  content: "\e6ac";
}
.el-icon-apple:before {
  content: "\e6ad";
}
.el-icon-cherry:before {
  content: "\e6ae";
}
.el-icon-watermelon:before {
  content: "\e6af";
}
.el-icon-grape:before {
  content: "\e6b0";
}
.el-icon-refrigerator:before {
  content: "\e6b1";
}
.el-icon-goblet-square-full:before {
  content: "\e6b2";
}
.el-icon-goblet-square:before {
  content: "\e6b3";
}
.el-icon-goblet-full:before {
  content: "\e6b4";
}
.el-icon-goblet:before {
  content: "\e6b5";
}
.el-icon-cold-drink:before {
  content: "\e6b6";
}
.el-icon-coffee-cup:before {
  content: "\e6b8";
}
.el-icon-water-cup:before {
  content: "\e6b9";
}
.el-icon-hot-water:before {
  content: "\e6ba";
}
.el-icon-ice-cream:before {
  content: "\e6bb";
}
.el-icon-dessert:before {
  content: "\e6bc";
}
.el-icon-sugar:before {
  content: "\e6bd";
}
.el-icon-tableware:before {
  content: "\e6be";
}
.el-icon-burger:before {
  content: "\e6bf";
}
.el-icon-knife-fork:before {
  content: "\e6c1";
}
.el-icon-fork-spoon:before {
  content: "\e6c2";
}
.el-icon-chicken:before {
  content: "\e6c3";
}
.el-icon-food:before {
  content: "\e6c4";
}
.el-icon-dish-1:before {
  content: "\e6c5";
}
.el-icon-dish:before {
  content: "\e6c6";
}
.el-icon-moon-night:before {
  content: "\e6ee";
}
.el-icon-moon:before {
  content: "\e6f0";
}
.el-icon-cloudy-and-sunny:before {
  content: "\e6f1";
}
.el-icon-partly-cloudy:before {
  content: "\e6f2";
}
.el-icon-cloudy:before {
  content: "\e6f3";
}
.el-icon-sunny:before {
  content: "\e6f6";
}
.el-icon-sunset:before {
  content: "\e6f7";
}
.el-icon-sunrise-1:before {
  content: "\e6f8";
}
.el-icon-sunrise:before {
  content: "\e6f9";
}
.el-icon-heavy-rain:before {
  content: "\e6fa";
}
.el-icon-lightning:before {
  content: "\e6fb";
}
.el-icon-light-rain:before {
  content: "\e6fc";
}
.el-icon-wind-power:before {
  content: "\e6fd";
}
.el-icon-baseball:before {
  content: "\e712";
}
.el-icon-soccer:before {
  content: "\e713";
}
.el-icon-football:before {
  content: "\e715";
}
.el-icon-basketball:before {
  content: "\e716";
}
.el-icon-ship:before {
  content: "\e73f";
}
.el-icon-truck:before {
  content: "\e740";
}
.el-icon-bicycle:before {
  content: "\e741";
}
.el-icon-mobile-phone:before {
  content: "\e6d3";
}
.el-icon-service:before {
  content: "\e6d4";
}
.el-icon-key:before {
  content: "\e6e2";
}
.el-icon-unlock:before {
  content: "\e6e4";
}
.el-icon-lock:before {
  content: "\e6e5";
}
.el-icon-watch:before {
  content: "\e6fe";
}
.el-icon-watch-1:before {
  content: "\e6ff";
}
.el-icon-timer:before {
  content: "\e702";
}
.el-icon-alarm-clock:before {
  content: "\e703";
}
.el-icon-map-location:before {
  content: "\e704";
}
.el-icon-delete-location:before {
  content: "\e705";
}
.el-icon-add-location:before {
  content: "\e706";
}
.el-icon-location-information:before {
  content: "\e707";
}
.el-icon-location-outline:before {
  content: "\e708";
}
.el-icon-location:before {
  content: "\e79e";
}
.el-icon-place:before {
  content: "\e709";
}
.el-icon-discover:before {
  content: "\e70a";
}
.el-icon-first-aid-kit:before {
  content: "\e70b";
}
.el-icon-trophy-1:before {
  content: "\e70c";
}
.el-icon-trophy:before {
  content: "\e70d";
}
.el-icon-medal:before {
  content: "\e70e";
}
.el-icon-medal-1:before {
  content: "\e70f";
}
.el-icon-stopwatch:before {
  content: "\e710";
}
.el-icon-mic:before {
  content: "\e711";
}
.el-icon-copy-document:before {
  content: "\e718";
}
.el-icon-full-screen:before {
  content: "\e719";
}
.el-icon-switch-button:before {
  content: "\e71b";
}
.el-icon-aim:before {
  content: "\e71c";
}
.el-icon-crop:before {
  content: "\e71d";
}
.el-icon-odometer:before {
  content: "\e71e";
}
.el-icon-time:before {
  content: "\e71f";
}
.el-icon-bangzhu:before {
  content: "\e724";
}
.el-icon-close-notification:before {
  content: "\e726";
}
.el-icon-microphone:before {
  content: "\e727";
}
.el-icon-turn-off-microphone:before {
  content: "\e728";
}
.el-icon-position:before {
  content: "\e729";
}
.el-icon-postcard:before {
  content: "\e72a";
}
.el-icon-message:before {
  content: "\e72b";
}
.el-icon-chat-line-square:before {
  content: "\e72d";
}
.el-icon-chat-dot-square:before {
  content: "\e72e";
}
.el-icon-chat-dot-round:before {
  content: "\e72f";
}
.el-icon-chat-square:before {
  content: "\e730";
}
.el-icon-chat-line-round:before {
  content: "\e731";
}
.el-icon-chat-round:before {
  content: "\e732";
}
.el-icon-set-up:before {
  content: "\e733";
}
.el-icon-turn-off:before {
  content: "\e734";
}
.el-icon-open:before {
  content: "\e735";
}
.el-icon-connection:before {
  content: "\e736";
}
.el-icon-link:before {
  content: "\e737";
}
.el-icon-cpu:before {
  content: "\e738";
}
.el-icon-thumb:before {
  content: "\e739";
}
.el-icon-female:before {
  content: "\e73a";
}
.el-icon-male:before {
  content: "\e73b";
}
.el-icon-guide:before {
  content: "\e73c";
}
.el-icon-news:before {
  content: "\e73e";
}
.el-icon-price-tag:before {
  content: "\e744";
}
.el-icon-discount:before {
  content: "\e745";
}
.el-icon-wallet:before {
  content: "\e747";
}
.el-icon-coin:before {
  content: "\e748";
}
.el-icon-money:before {
  content: "\e749";
}
.el-icon-bank-card:before {
  content: "\e74a";
}
.el-icon-box:before {
  content: "\e74b";
}
.el-icon-present:before {
  content: "\e74c";
}
.el-icon-sell:before {
  content: "\e6d5";
}
.el-icon-sold-out:before {
  content: "\e6d6";
}
.el-icon-shopping-bag-2:before {
  content: "\e74d";
}
.el-icon-shopping-bag-1:before {
  content: "\e74e";
}
.el-icon-shopping-cart-2:before {
  content: "\e74f";
}
.el-icon-shopping-cart-1:before {
  content: "\e750";
}
.el-icon-shopping-cart-full:before {
  content: "\e751";
}
.el-icon-smoking:before {
  content: "\e752";
}
.el-icon-no-smoking:before {
  content: "\e753";
}
.el-icon-house:before {
  content: "\e754";
}
.el-icon-table-lamp:before {
  content: "\e755";
}
.el-icon-school:before {
  content: "\e756";
}
.el-icon-office-building:before {
  content: "\e757";
}
.el-icon-toilet-paper:before {
  content: "\e758";
}
.el-icon-notebook-2:before {
  content: "\e759";
}
.el-icon-notebook-1:before {
  content: "\e75a";
}
.el-icon-files:before {
  content: "\e75b";
}
.el-icon-collection:before {
  content: "\e75c";
}
.el-icon-receiving:before {
  content: "\e75d";
}
.el-icon-suitcase-1:before {
  content: "\e760";
}
.el-icon-suitcase:before {
  content: "\e761";
}
.el-icon-film:before {
  content: "\e763";
}
.el-icon-collection-tag:before {
  content: "\e765";
}
.el-icon-data-analysis:before {
  content: "\e766";
}
.el-icon-pie-chart:before {
  content: "\e767";
}
.el-icon-data-board:before {
  content: "\e768";
}
.el-icon-data-line:before {
  content: "\e76d";
}
.el-icon-reading:before {
  content: "\e769";
}
.el-icon-magic-stick:before {
  content: "\e76a";
}
.el-icon-coordinate:before {
  content: "\e76b";
}
.el-icon-mouse:before {
  content: "\e76c";
}
.el-icon-brush:before {
  content: "\e76e";
}
.el-icon-headset:before {
  content: "\e76f";
}
.el-icon-umbrella:before {
  content: "\e770";
}
.el-icon-scissors:before {
  content: "\e771";
}
.el-icon-mobile:before {
  content: "\e773";
}
.el-icon-attract:before {
  content: "\e774";
}
.el-icon-monitor:before {
  content: "\e775";
}
.el-icon-search:before {
  content: "\e778";
}
.el-icon-takeaway-box:before {
  content: "\e77a";
}
.el-icon-paperclip:before {
  content: "\e77d";
}
.el-icon-printer:before {
  content: "\e77e";
}
.el-icon-document-add:before {
  content: "\e782";
}
.el-icon-document:before {
  content: "\e785";
}
.el-icon-document-checked:before {
  content: "\e786";
}
.el-icon-document-copy:before {
  content: "\e787";
}
.el-icon-document-delete:before {
  content: "\e788";
}
.el-icon-document-remove:before {
  content: "\e789";
}
.el-icon-tickets:before {
  content: "\e78b";
}
.el-icon-folder-checked:before {
  content: "\e77f";
}
.el-icon-folder-delete:before {
  content: "\e780";
}
.el-icon-folder-remove:before {
  content: "\e781";
}
.el-icon-folder-add:before {
  content: "\e783";
}
.el-icon-folder-opened:before {
  content: "\e784";
}
.el-icon-folder:before {
  content: "\e78a";
}
.el-icon-edit-outline:before {
  content: "\e764";
}
.el-icon-edit:before {
  content: "\e78c";
}
.el-icon-date:before {
  content: "\e78e";
}
.el-icon-c-scale-to-original:before {
  content: "\e7c6";
}
.el-icon-view:before {
  content: "\e6ce";
}
.el-icon-loading:before {
  content: "\e6cf";
}
.el-icon-rank:before {
  content: "\e6d1";
}
.el-icon-sort-down:before {
  content: "\e7c4";
}
.el-icon-sort-up:before {
  content: "\e7c5";
}
.el-icon-sort:before {
  content: "\e6d2";
}
.el-icon-finished:before {
  content: "\e6cd";
}
.el-icon-refresh-left:before {
  content: "\e6c7";
}
.el-icon-refresh-right:before {
  content: "\e6c8";
}
.el-icon-refresh:before {
  content: "\e6d0";
}
.el-icon-video-play:before {
  content: "\e7c0";
}
.el-icon-video-pause:before {
  content: "\e7c1";
}
.el-icon-d-arrow-right:before {
  content: "\e6dc";
}
.el-icon-d-arrow-left:before {
  content: "\e6dd";
}
.el-icon-arrow-up:before {
  content: "\e6e1";
}
.el-icon-arrow-down:before {
  content: "\e6df";
}
.el-icon-arrow-right:before {
  content: "\e6e0";
}
.el-icon-arrow-left:before {
  content: "\e6de";
}
.el-icon-top-right:before {
  content: "\e6e7";
}
.el-icon-top-left:before {
  content: "\e6e8";
}
.el-icon-top:before {
  content: "\e6e6";
}
.el-icon-bottom:before {
  content: "\e6eb";
}
.el-icon-right:before {
  content: "\e6e9";
}
.el-icon-back:before {
  content: "\e6ea";
}
.el-icon-bottom-right:before {
  content: "\e6ec";
}
.el-icon-bottom-left:before {
  content: "\e6ed";
}
.el-icon-caret-top:before {
  content: "\e78f";
}
.el-icon-caret-bottom:before {
  content: "\e790";
}
.el-icon-caret-right:before {
  content: "\e791";
}
.el-icon-caret-left:before {
  content: "\e792";
}
.el-icon-d-caret:before {
  content: "\e79a";
}
.el-icon-share:before {
  content: "\e793";
}
.el-icon-menu:before {
  content: "\e798";
}
.el-icon-s-grid:before {
  content: "\e7a6";
}
.el-icon-s-check:before {
  content: "\e7a7";
}
.el-icon-s-data:before {
  content: "\e7a8";
}
.el-icon-s-opportunity:before {
  content: "\e7aa";
}
.el-icon-s-custom:before {
  content: "\e7ab";
}
.el-icon-s-claim:before {
  content: "\e7ad";
}
.el-icon-s-finance:before {
  content: "\e7ae";
}
.el-icon-s-comment:before {
  content: "\e7af";
}
.el-icon-s-flag:before {
  content: "\e7b0";
}
.el-icon-s-marketing:before {
  content: "\e7b1";
}
.el-icon-s-shop:before {
  content: "\e7b4";
}
.el-icon-s-open:before {
  content: "\e7b5";
}
.el-icon-s-management:before {
  content: "\e7b6";
}
.el-icon-s-ticket:before {
  content: "\e7b7";
}
.el-icon-s-release:before {
  content: "\e7b8";
}
.el-icon-s-home:before {
  content: "\e7b9";
}
.el-icon-s-promotion:before {
  content: "\e7ba";
}
.el-icon-s-operation:before {
  content: "\e7bb";
}
.el-icon-s-unfold:before {
  content: "\e7bc";
}
.el-icon-s-fold:before {
  content: "\e7a9";
}
.el-icon-s-platform:before {
  content: "\e7bd";
}
.el-icon-s-order:before {
  content: "\e7be";
}
.el-icon-s-cooperation:before {
  content: "\e7bf";
}
.el-icon-bell:before {
  content: "\e725";
}
.el-icon-message-solid:before {
  content: "\e799";
}
.el-icon-video-camera:before {
  content: "\e772";
}
.el-icon-video-camera-solid:before {
  content: "\e796";
}
.el-icon-camera:before {
  content: "\e779";
}
.el-icon-camera-solid:before {
  content: "\e79b";
}
.el-icon-download:before {
  content: "\e77c";
}
.el-icon-upload2:before {
  content: "\e77b";
}
.el-icon-upload:before {
  content: "\e7c3";
}
.el-icon-picture-outline-round:before {
  content: "\e75f";
}
.el-icon-picture-outline:before {
  content: "\e75e";
}
.el-icon-picture:before {
  content: "\e79f";
}
.el-icon-close:before {
  content: "\e6db";
}
.el-icon-check:before {
  content: "\e6da";
}
.el-icon-plus:before {
  content: "\e6d9";
}
.el-icon-minus:before {
  content: "\e6d8";
}
.el-icon-help:before {
  content: "\e73d";
}
.el-icon-s-help:before {
  content: "\e7b3";
}
.el-icon-circle-close:before {
  content: "\e78d";
}
.el-icon-circle-check:before {
  content: "\e720";
}
.el-icon-circle-plus-outline:before {
  content: "\e723";
}
.el-icon-remove-outline:before {
  content: "\e722";
}
.el-icon-zoom-out:before {
  content: "\e776";
}
.el-icon-zoom-in:before {
  content: "\e777";
}
.el-icon-error:before {
  content: "\e79d";
}
.el-icon-success:before {
  content: "\e79c";
}
.el-icon-circle-plus:before {
  content: "\e7a0";
}
.el-icon-remove:before {
  content: "\e7a2";
}
.el-icon-info:before {
  content: "\e7a1";
}
.el-icon-question:before {
  content: "\e7a4";
}
.el-icon-warning-outline:before {
  content: "\e6c9";
}
.el-icon-warning:before {
  content: "\e7a3";
}
.el-icon-goods:before {
  content: "\e7c2";
}
.el-icon-s-goods:before {
  content: "\e7b2";
}
.el-icon-star-off:before {
  content: "\e717";
}
.el-icon-star-on:before {
  content: "\e797";
}
.el-icon-more-outline:before {
  content: "\e6cc";
}
.el-icon-more:before {
  content: "\e794";
}
.el-icon-phone-outline:before {
  content: "\e6cb";
}
.el-icon-phone:before {
  content: "\e795";
}
.el-icon-user:before {
  content: "\e6e3";
}
.el-icon-user-solid:before {
  content: "\e7a5";
}
.el-icon-setting:before {
  content: "\e6ca";
}
.el-icon-s-tools:before {
  content: "\e7ac";
}
.el-icon-delete:before {
  content: "\e6d7";
}
.el-icon-delete-solid:before {
  content: "\e7c9";
}
.el-icon-eleme:before {
  content: "\e7c7";
}
.el-icon-platform-eleme:before {
  content: "\e7ca";
}
.el-icon-loading {
  -webkit-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;
}
.el-icon--right {
  margin-left: 5px;
}
.el-icon--left {
  margin-right: 5px;
}
@-webkit-keyframes rotating {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
@keyframes rotating {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 15px;
}
.el-tabs__active-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  background-color: #409eff;
  z-index: 1;
  -webkit-transition: -webkit-transform 0.3s
    cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  list-style: none;
}
.el-tabs__new-tab {
  float: right;
  border: 1px solid #d3dce6;
  height: 18px;
  width: 18px;
  line-height: 18px;
  margin: 12px 0 9px 10px;
  border-radius: 3px;
  text-align: center;
  font-size: 12px;
  color: #d3dce6;
  cursor: pointer;
  -webkit-transition: all 0.15s;
  transition: all 0.15s;
}
.el-tabs__new-tab .el-icon-plus {
  -webkit-transform: scale(0.8);
  transform: scale(0.8);
}
.el-tabs__new-tab:hover {
  color: #409eff;
}
.el-tabs__nav-wrap {
  overflow: hidden;
  margin-bottom: -1px;
  position: relative;
}
.el-tabs__nav-wrap:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: #e4e7ed;
  z-index: 1;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__nav-wrap:after,
.el-tabs--card > .el-tabs__header .el-tabs__nav-wrap:after {
  content: none;
}
.el-tabs__nav-wrap.is-scrollable {
  padding: 0 20px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-tabs__nav-scroll {
  overflow: hidden;
}
.el-tabs__nav-next,
.el-tabs__nav-prev {
  position: absolute;
  cursor: pointer;
  line-height: 44px;
  font-size: 12px;
  color: #909399;
}
.el-tabs__nav-next {
  right: 0;
}
.el-tabs__nav-prev {
  left: 0;
}
.el-tabs__nav {
  white-space: nowrap;
  position: relative;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  float: left;
  z-index: 2;
}
.el-tabs__nav.is-stretch {
  min-width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.el-tabs__nav.is-stretch > * {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: center;
}
.el-tabs__item {
  padding: 0 20px;
  height: 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 40px;
  display: inline-block;
  list-style: none;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  position: relative;
}
.el-tabs__item:focus,
.el-tabs__item:focus:active {
  outline: 0;
}
.el-tabs__item:focus.is-active.is-focus:not(:active) {
  -webkit-box-shadow: 0 0 2px 2px #409eff inset;
  box-shadow: inset 0 0 2px 2px #409eff;
  border-radius: 3px;
}
.el-tabs__item .el-icon-close {
  border-radius: 50%;
  text-align: center;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  margin-left: 5px;
}
.el-tabs__item .el-icon-close:before {
  -webkit-transform: scale(0.9);
  transform: scale(0.9);
  display: inline-block;
}
.el-tabs__item .el-icon-close:hover {
  background-color: #c0c4cc;
  color: #fff;
}
.el-tabs__item.is-active {
  color: #409eff;
}
.el-tabs__item:hover {
  color: #409eff;
  cursor: pointer;
}
.el-tabs__item.is-disabled {
  color: #c0c4cc;
  cursor: default;
}
.el-tabs__content {
  overflow: hidden;
  position: relative;
}
.el-tabs--card > .el-tabs__header {
  border-bottom: 1px solid #e4e7ed;
}
.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 1px solid #e4e7ed;
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-tabs--card > .el-tabs__header .el-tabs__active-bar {
  display: none;
}
.el-tabs--card > .el-tabs__header .el-tabs__item .el-icon-close {
  position: relative;
  font-size: 12px;
  width: 0;
  height: 14px;
  vertical-align: middle;
  line-height: 15px;
  overflow: hidden;
  top: -1px;
  right: -2px;
  -webkit-transform-origin: 100% 50%;
  transform-origin: 100% 50%;
}
.el-tabs--card
  > .el-tabs__header
  .el-tabs__item.is-active.is-closable
  .el-icon-close,
.el-tabs--card
  > .el-tabs__header
  .el-tabs__item.is-closable:hover
  .el-icon-close {
  width: 14px;
}
.el-tabs--card > .el-tabs__header .el-tabs__item {
  border-bottom: 1px solid transparent;
  border-left: 1px solid #e4e7ed;
  -webkit-transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.el-tabs--card > .el-tabs__header .el-tabs__item:first-child {
  border-left: none;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-closable:hover {
  padding-left: 13px;
  padding-right: 13px;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #fff;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active.is-closable {
  padding-left: 20px;
  padding-right: 20px;
}
.el-tabs--border-card {
  background: #fff;
  border: 1px solid #dcdfe6;
  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
    0 0 6px 0 rgba(0, 0, 0, 0.04);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}
.el-tabs--border-card > .el-tabs__content {
  padding: 15px;
}
.el-tabs--border-card > .el-tabs__header {
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  margin: 0;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  border: 1px solid transparent;
  margin-top: -1px;
  color: #909399;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item + .el-tabs__item,
.el-tabs--border-card > .el-tabs__header .el-tabs__item:first-child {
  margin-left: -1px;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #409eff;
  background-color: #fff;
  border-right-color: #dcdfe6;
  border-left-color: #dcdfe6;
}
.el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  color: #409eff;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-disabled {
  color: #c0c4cc;
}
.el-tabs--border-card
  > .el-tabs__header
  .is-scrollable
  .el-tabs__item:first-child {
  margin-left: 0;
}
.el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2),
.el-tabs--bottom .el-tabs__item.is-top:nth-child(2),
.el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
.el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 0;
}
.el-tabs--bottom .el-tabs__item.is-bottom:last-child,
.el-tabs--bottom .el-tabs__item.is-top:last-child,
.el-tabs--top .el-tabs__item.is-bottom:last-child,
.el-tabs--top .el-tabs__item.is-top:last-child {
  padding-right: 0;
}
.el-tabs--bottom .el-tabs--left > .el-tabs__header .el-tabs__item:nth-child(2),
.el-tabs--bottom .el-tabs--right > .el-tabs__header .el-tabs__item:nth-child(2),
.el-tabs--bottom.el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:nth-child(2),
.el-tabs--bottom.el-tabs--card > .el-tabs__header .el-tabs__item:nth-child(2),
.el-tabs--top .el-tabs--left > .el-tabs__header .el-tabs__item:nth-child(2),
.el-tabs--top .el-tabs--right > .el-tabs__header .el-tabs__item:nth-child(2),
.el-tabs--top.el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:nth-child(2),
.el-tabs--top.el-tabs--card > .el-tabs__header .el-tabs__item:nth-child(2) {
  padding-left: 20px;
}
.el-tabs--bottom .el-tabs--left > .el-tabs__header .el-tabs__item:last-child,
.el-tabs--bottom .el-tabs--right > .el-tabs__header .el-tabs__item:last-child,
.el-tabs--bottom.el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:last-child,
.el-tabs--bottom.el-tabs--card > .el-tabs__header .el-tabs__item:last-child,
.el-tabs--top .el-tabs--left > .el-tabs__header .el-tabs__item:last-child,
.el-tabs--top .el-tabs--right > .el-tabs__header .el-tabs__item:last-child,
.el-tabs--top.el-tabs--border-card > .el-tabs__header .el-tabs__item:last-child,
.el-tabs--top.el-tabs--card > .el-tabs__header .el-tabs__item:last-child {
  padding-right: 20px;
}
.el-tabs--bottom .el-tabs__header.is-bottom {
  margin-bottom: 0;
  margin-top: 10px;
}
.el-tabs--bottom.el-tabs--border-card .el-tabs__header.is-bottom {
  border-bottom: 0;
  border-top: 1px solid #dcdfe6;
}
.el-tabs--bottom.el-tabs--border-card .el-tabs__nav-wrap.is-bottom {
  margin-top: -1px;
  margin-bottom: 0;
}
.el-tabs--bottom.el-tabs--border-card .el-tabs__item.is-bottom:not(.is-active) {
  border: 1px solid transparent;
}
.el-tabs--bottom.el-tabs--border-card .el-tabs__item.is-bottom {
  margin: 0 -1px -1px;
}
.el-tabs--left,
.el-tabs--right {
  overflow: hidden;
}
.el-tabs--left .el-tabs__header.is-left,
.el-tabs--left .el-tabs__header.is-right,
.el-tabs--left .el-tabs__nav-scroll,
.el-tabs--left .el-tabs__nav-wrap.is-left,
.el-tabs--left .el-tabs__nav-wrap.is-right,
.el-tabs--right .el-tabs__header.is-left,
.el-tabs--right .el-tabs__header.is-right,
.el-tabs--right .el-tabs__nav-scroll,
.el-tabs--right .el-tabs__nav-wrap.is-left,
.el-tabs--right .el-tabs__nav-wrap.is-right {
  height: 100%;
}
.el-tabs--left .el-tabs__active-bar.is-left,
.el-tabs--left .el-tabs__active-bar.is-right,
.el-tabs--right .el-tabs__active-bar.is-left,
.el-tabs--right .el-tabs__active-bar.is-right {
  top: 0;
  bottom: auto;
  width: 2px;
  height: auto;
}
.el-tabs--left .el-tabs__nav-wrap.is-left,
.el-tabs--left .el-tabs__nav-wrap.is-right,
.el-tabs--right .el-tabs__nav-wrap.is-left,
.el-tabs--right .el-tabs__nav-wrap.is-right {
  margin-bottom: 0;
}
.el-tabs--left .el-tabs__nav-wrap.is-left > .el-tabs__nav-next,
.el-tabs--left .el-tabs__nav-wrap.is-left > .el-tabs__nav-prev,
.el-tabs--left .el-tabs__nav-wrap.is-right > .el-tabs__nav-next,
.el-tabs--left .el-tabs__nav-wrap.is-right > .el-tabs__nav-prev,
.el-tabs--right .el-tabs__nav-wrap.is-left > .el-tabs__nav-next,
.el-tabs--right .el-tabs__nav-wrap.is-left > .el-tabs__nav-prev,
.el-tabs--right .el-tabs__nav-wrap.is-right > .el-tabs__nav-next,
.el-tabs--right .el-tabs__nav-wrap.is-right > .el-tabs__nav-prev {
  height: 30px;
  line-height: 30px;
  width: 100%;
  text-align: center;
  cursor: pointer;
}
.el-tabs--left .el-tabs__nav-wrap.is-left > .el-tabs__nav-next i,
.el-tabs--left .el-tabs__nav-wrap.is-left > .el-tabs__nav-prev i,
.el-tabs--left .el-tabs__nav-wrap.is-right > .el-tabs__nav-next i,
.el-tabs--left .el-tabs__nav-wrap.is-right > .el-tabs__nav-prev i,
.el-tabs--right .el-tabs__nav-wrap.is-left > .el-tabs__nav-next i,
.el-tabs--right .el-tabs__nav-wrap.is-left > .el-tabs__nav-prev i,
.el-tabs--right .el-tabs__nav-wrap.is-right > .el-tabs__nav-next i,
.el-tabs--right .el-tabs__nav-wrap.is-right > .el-tabs__nav-prev i {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
.el-tabs--left .el-tabs__nav-wrap.is-left > .el-tabs__nav-prev,
.el-tabs--left .el-tabs__nav-wrap.is-right > .el-tabs__nav-prev,
.el-tabs--right .el-tabs__nav-wrap.is-left > .el-tabs__nav-prev,
.el-tabs--right .el-tabs__nav-wrap.is-right > .el-tabs__nav-prev {
  left: auto;
  top: 0;
}
.el-tabs--left .el-tabs__nav-wrap.is-left > .el-tabs__nav-next,
.el-tabs--left .el-tabs__nav-wrap.is-right > .el-tabs__nav-next,
.el-tabs--right .el-tabs__nav-wrap.is-left > .el-tabs__nav-next,
.el-tabs--right .el-tabs__nav-wrap.is-right > .el-tabs__nav-next {
  right: auto;
  bottom: 0;
}
.el-tabs--left .el-tabs__active-bar.is-left,
.el-tabs--left .el-tabs__nav-wrap.is-left:after {
  right: 0;
  left: auto;
}
.el-tabs--left .el-tabs__nav-wrap.is-left.is-scrollable,
.el-tabs--left .el-tabs__nav-wrap.is-right.is-scrollable,
.el-tabs--right .el-tabs__nav-wrap.is-left.is-scrollable,
.el-tabs--right .el-tabs__nav-wrap.is-right.is-scrollable {
  padding: 30px 0;
}
.el-tabs--left .el-tabs__nav-wrap.is-left:after,
.el-tabs--left .el-tabs__nav-wrap.is-right:after,
.el-tabs--right .el-tabs__nav-wrap.is-left:after,
.el-tabs--right .el-tabs__nav-wrap.is-right:after {
  height: 100%;
  width: 2px;
  bottom: auto;
  top: 0;
}
.el-tabs--left .el-tabs__nav.is-left,
.el-tabs--left .el-tabs__nav.is-right,
.el-tabs--right .el-tabs__nav.is-left,
.el-tabs--right .el-tabs__nav.is-right {
  float: none;
}
.el-tabs--left .el-tabs__item.is-left,
.el-tabs--left .el-tabs__item.is-right,
.el-tabs--right .el-tabs__item.is-left,
.el-tabs--right .el-tabs__item.is-right {
  display: block;
}
.el-tabs--left.el-tabs--card .el-tabs__active-bar.is-left,
.el-tabs--right.el-tabs--card .el-tabs__active-bar.is-right {
  display: none;
}
.el-tabs--left .el-tabs__header.is-left {
  float: left;
  margin-bottom: 0;
  margin-right: 10px;
}
.el-tabs--left .el-tabs__nav-wrap.is-left {
  margin-right: -1px;
}
.el-tabs--left .el-tabs__item.is-left {
  text-align: right;
}
.el-tabs--left.el-tabs--card .el-tabs__item.is-left {
  border-left: none;
  border-right: 1px solid #e4e7ed;
  border-bottom: none;
  border-top: 1px solid #e4e7ed;
  text-align: left;
}
.el-tabs--left.el-tabs--card .el-tabs__item.is-left:first-child {
  border-right: 1px solid #e4e7ed;
  border-top: none;
}
.el-tabs--left.el-tabs--card .el-tabs__item.is-left.is-active {
  border: 1px solid #e4e7ed;
  border-right-color: #fff;
  border-left: none;
  border-bottom: none;
}
.el-tabs--left.el-tabs--card .el-tabs__item.is-left.is-active:first-child {
  border-top: none;
}
.el-tabs--left.el-tabs--card .el-tabs__item.is-left.is-active:last-child {
  border-bottom: none;
}
.el-tabs--left.el-tabs--card .el-tabs__nav {
  border-radius: 4px 0 0 4px;
  border-bottom: 1px solid #e4e7ed;
  border-right: none;
}
.el-tabs--left.el-tabs--card .el-tabs__new-tab {
  float: none;
}
.el-tabs--left.el-tabs--border-card .el-tabs__header.is-left {
  border-right: 1px solid #dfe4ed;
}
.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left {
  border: 1px solid transparent;
  margin: -1px 0 -1px -1px;
}
.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left.is-active {
  border-color: #d1dbe5 transparent;
}
.el-tabs--right .el-tabs__header.is-right {
  float: right;
  margin-bottom: 0;
  margin-left: 10px;
}
.el-tabs--right .el-tabs__nav-wrap.is-right {
  margin-left: -1px;
}
.el-tabs--right .el-tabs__nav-wrap.is-right:after {
  left: 0;
  right: auto;
}
.el-tabs--right .el-tabs__active-bar.is-right {
  left: 0;
}
.el-tabs--right.el-tabs--card .el-tabs__item.is-right {
  border-bottom: none;
  border-top: 1px solid #e4e7ed;
}
.el-tabs--right.el-tabs--card .el-tabs__item.is-right:first-child {
  border-left: 1px solid #e4e7ed;
  border-top: none;
}
.el-tabs--right.el-tabs--card .el-tabs__item.is-right.is-active {
  border: 1px solid #e4e7ed;
  border-left-color: #fff;
  border-right: none;
  border-bottom: none;
}
.el-tabs--right.el-tabs--card .el-tabs__item.is-right.is-active:first-child {
  border-top: none;
}
.el-tabs--right.el-tabs--card .el-tabs__item.is-right.is-active:last-child {
  border-bottom: none;
}
.el-tabs--right.el-tabs--card .el-tabs__nav {
  border-radius: 0 4px 4px 0;
  border-bottom: 1px solid #e4e7ed;
  border-left: none;
}
.el-tabs--right.el-tabs--border-card .el-tabs__header.is-right {
  border-left: 1px solid #dfe4ed;
}
.el-tabs--right.el-tabs--border-card .el-tabs__item.is-right {
  border: 1px solid transparent;
  margin: -1px -1px -1px 0;
}
.el-tabs--right.el-tabs--border-card .el-tabs__item.is-right.is-active {
  border-color: #d1dbe5 transparent;
}
.slideInLeft-transition,
.slideInRight-transition {
  display: inline-block;
}
.slideInRight-enter {
  -webkit-animation: slideInRight-enter 0.3s;
  animation: slideInRight-enter 0.3s;
}
.slideInRight-leave {
  position: absolute;
  left: 0;
  right: 0;
  -webkit-animation: slideInRight-leave 0.3s;
  animation: slideInRight-leave 0.3s;
}
.slideInLeft-enter {
  -webkit-animation: slideInLeft-enter 0.3s;
  animation: slideInLeft-enter 0.3s;
}
.slideInLeft-leave {
  position: absolute;
  left: 0;
  right: 0;
  -webkit-animation: slideInLeft-leave 0.3s;
  animation: slideInLeft-leave 0.3s;
}
@-webkit-keyframes slideInRight-enter {
  0% {
    opacity: 0;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
@keyframes slideInRight-enter {
  0% {
    opacity: 0;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
@-webkit-keyframes slideInRight-leave {
  0% {
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  to {
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    opacity: 0;
  }
}
@keyframes slideInRight-leave {
  0% {
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  to {
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    opacity: 0;
  }
}
@-webkit-keyframes slideInLeft-enter {
  0% {
    opacity: 0;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
  to {
    opacity: 1;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
@keyframes slideInLeft-enter {
  0% {
    opacity: 0;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
  to {
    opacity: 1;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
@-webkit-keyframes slideInLeft-leave {
  0% {
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  to {
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
    opacity: 0;
  }
}
@keyframes slideInLeft-leave {
  0% {
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  to {
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
    opacity: 0;
  }
}
.el-form--inline .el-form-item,
.el-form--inline .el-form-item__content {
  display: inline-block;
  vertical-align: top;
}
.el-form-item:after,
.el-form-item__content:after {
  clear: both;
}
.el-form--label-left .el-form-item__label {
  text-align: left;
}
.el-form--label-top .el-form-item__label {
  float: none;
  display: inline-block;
  text-align: left;
  padding: 0 0 10px;
}
.el-form--inline .el-form-item {
  margin-right: 10px;
}
.el-form--inline .el-form-item__label {
  float: none;
  display: inline-block;
}
.el-form--inline.el-form--label-top .el-form-item__content {
  display: block;
}
.el-form-item {
  margin-bottom: 22px;
}
.el-form-item:after,
.el-form-item:before {
  display: table;
  content: "";
}
.el-form-item .el-form-item {
  margin-bottom: 0;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 18px;
}
.el-form-item .el-input__validateIcon {
  display: none;
}
.el-form-item--medium .el-form-item__content,
.el-form-item--medium .el-form-item__label {
  line-height: 36px;
}
.el-form-item--small .el-form-item__content,
.el-form-item--small .el-form-item__label {
  line-height: 32px;
}
.el-form-item--small .el-form-item__error {
  padding-top: 2px;
}
.el-form-item--mini .el-form-item__content,
.el-form-item--mini .el-form-item__label {
  line-height: 28px;
}
.el-form-item--mini .el-form-item__error {
  padding-top: 1px;
}
.el-form-item__label-wrap {
  float: left;
}
.el-form-item__label-wrap .el-form-item__label {
  display: inline-block;
  float: none;
}
.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-form-item__content {
  line-height: 40px;
  position: relative;
  font-size: 14px;
}
.el-form-item__content:after,
.el-form-item__content:before {
  display: table;
  content: "";
}
.el-form-item__content .el-input-group {
  vertical-align: top;
}
.el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}
.el-form-item__error--inline {
  position: relative;
  top: auto;
  left: auto;
  display: inline-block;
  margin-left: 10px;
}
.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
.el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-input__inner:focus,
.el-form-item.is-error .el-textarea__inner,
.el-form-item.is-error .el-textarea__inner:focus {
  border-color: #f56c6c;
}
.el-form-item.is-error .el-input-group__append .el-input__inner,
.el-form-item.is-error .el-input-group__prepend .el-input__inner {
  border-color: transparent;
}
.el-form-item.is-error .el-input__validateIcon {
  color: #f56c6c;
}
.el-form-item--feedback .el-input__validateIcon {
  display: inline-block;
}
.el-breadcrumb {
  font-size: 14px;
  line-height: 1;
}
.el-breadcrumb:after,
.el-breadcrumb:before {
  display: table;
  content: "";
}
.el-breadcrumb:after {
  clear: both;
}
.el-breadcrumb__separator {
  margin: 0 9px;
  font-weight: 700;
  color: #c0c4cc;
}
.el-breadcrumb__separator[class*="icon"] {
  margin: 0 6px;
  font-weight: 400;
}
.el-breadcrumb__item {
  float: left;
}
.el-breadcrumb__inner {
  color: #606266;
}
.el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link {
  font-weight: 700;
  text-decoration: none;
  -webkit-transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  color: #303133;
}
.el-breadcrumb__inner a:hover,
.el-breadcrumb__inner.is-link:hover {
  color: #409eff;
  cursor: pointer;
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 400;
  color: #606266;
  cursor: text;
}
.el-breadcrumb__item:last-child .el-breadcrumb__separator {
  display: none;
}
.el-popover {
  position: absolute;
  background: #fff;
  min-width: 150px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  padding: 12px;
  z-index: 2000;
  color: #606266;
  line-height: 1.4;
  text-align: justify;
  font-size: 14px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  word-break: break-all;
}
.el-popover--plain {
  padding: 18px 20px;
}
.el-popover__title {
  color: #303133;
  font-size: 16px;
  line-height: 1;
  margin-bottom: 12px;
}
.el-popover:focus,
.el-popover:focus:active,
.el-popover__reference:focus:hover,
.el-popover__reference:focus:not(.focusing) {
  outline-width: 0;
}
.el-date-table td.in-range div,
.el-date-table td.in-range div:hover,
.el-date-table.is-week-mode .el-date-table__row.current div,
.el-date-table.is-week-mode .el-date-table__row:hover div {
  background-color: #f2f6fc;
}
.el-date-table {
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.el-date-table.is-week-mode .el-date-table__row:hover td.available:hover {
  color: #606266;
}
.el-date-table.is-week-mode .el-date-table__row:hover td:first-child div {
  margin-left: 5px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.el-date-table.is-week-mode .el-date-table__row:hover td:last-child div {
  margin-right: 5px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.el-date-table td {
  width: 32px;
  padding: 4px 0;
  text-align: center;
  cursor: pointer;
  position: relative;
}
.el-date-table td,
.el-date-table td div {
  height: 30px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-date-table td div {
  padding: 3px 0;
}
.el-date-table td span {
  width: 24px;
  height: 24px;
  display: block;
  margin: 0 auto;
  line-height: 24px;
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  border-radius: 50%;
}
.el-date-table td.next-month,
.el-date-table td.prev-month {
  color: #c0c4cc;
}
.el-date-table td.today {
  position: relative;
}
.el-date-table td.today span {
  color: #409eff;
  font-weight: 700;
}
.el-date-table td.today.end-date span,
.el-date-table td.today.start-date span {
  color: #fff;
}
.el-date-table td.available:hover {
  color: #409eff;
}
.el-date-table td.current:not(.disabled) span {
  color: #fff;
  background-color: #409eff;
}
.el-date-table td.end-date div,
.el-date-table td.start-date div {
  color: #fff;
}
.el-date-table td.end-date span,
.el-date-table td.start-date span {
  background-color: #409eff;
}
.el-date-table td.start-date div {
  margin-left: 5px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.el-date-table td.end-date div {
  margin-right: 5px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.el-date-table td.disabled div {
  background-color: #f5f7fa;
  opacity: 1;
  cursor: not-allowed;
  color: #c0c4cc;
}
.el-date-table td.selected div {
  margin-left: 5px;
  margin-right: 5px;
  background-color: #f2f6fc;
  border-radius: 15px;
}
.el-date-table td.selected div:hover {
  background-color: #f2f6fc;
}
.el-date-table td.selected span {
  background-color: #409eff;
  color: #fff;
  border-radius: 15px;
}
.el-date-table td.week {
  font-size: 80%;
  color: #606266;
}
.el-date-table th {
  padding: 5px;
  color: #606266;
  font-weight: 400;
  border-bottom: 1px solid #ebeef5;
}
.el-month-table {
  font-size: 12px;
  margin: -1px;
  border-collapse: collapse;
}
.el-month-table td {
  text-align: center;
  padding: 8px 0;
  cursor: pointer;
}
.el-month-table td div {
  height: 48px;
  padding: 6px 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-month-table td.today .cell {
  color: #409eff;
  font-weight: 700;
}
.el-month-table td.today.end-date .cell,
.el-month-table td.today.start-date .cell {
  color: #fff;
}
.el-month-table td.disabled .cell {
  background-color: #f5f7fa;
  cursor: not-allowed;
  color: #c0c4cc;
}
.el-month-table td.disabled .cell:hover {
  color: #c0c4cc;
}
.el-month-table td .cell {
  width: 60px;
  height: 36px;
  display: block;
  line-height: 36px;
  color: #606266;
  margin: 0 auto;
  border-radius: 18px;
}
.el-month-table td .cell:hover {
  color: #409eff;
}
.el-month-table td.in-range div,
.el-month-table td.in-range div:hover {
  background-color: #f2f6fc;
}
.el-month-table td.end-date div,
.el-month-table td.start-date div {
  color: #fff;
}
.el-month-table td.end-date .cell,
.el-month-table td.start-date .cell {
  color: #fff;
  background-color: #409eff;
}
.el-month-table td.start-date div {
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
}
.el-month-table td.end-date div {
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
}
.el-month-table td.current:not(.disabled) .cell {
  color: #409eff;
}
.el-year-table {
  font-size: 12px;
  margin: -1px;
  border-collapse: collapse;
}
.el-year-table .el-icon {
  color: #303133;
}
.el-year-table td {
  text-align: center;
  padding: 20px 3px;
  cursor: pointer;
}
.el-year-table td.today .cell {
  color: #409eff;
  font-weight: 700;
}
.el-year-table td.disabled .cell {
  background-color: #f5f7fa;
  cursor: not-allowed;
  color: #c0c4cc;
}
.el-year-table td.disabled .cell:hover {
  color: #c0c4cc;
}
.el-year-table td .cell {
  width: 48px;
  height: 32px;
  display: block;
  line-height: 32px;
  color: #606266;
  margin: 0 auto;
}
.el-year-table td .cell:hover,
.el-year-table td.current:not(.disabled) .cell {
  color: #409eff;
}
.el-time-spinner.has-seconds .el-time-spinner__wrapper {
  width: 33.3%;
}
.el-time-spinner__wrapper {
  max-height: 190px;
  overflow: auto;
  display: inline-block;
  width: 50%;
  vertical-align: top;
  position: relative;
}
.el-time-spinner__wrapper
  .el-scrollbar__wrap:not(.el-scrollbar__wrap--hidden-default) {
  padding-bottom: 15px;
}
.el-time-spinner__wrapper.is-arrow {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
}
.el-time-spinner__wrapper.is-arrow .el-time-spinner__list {
  -webkit-transform: translateY(-32px);
  transform: translateY(-32px);
}
.el-time-spinner__wrapper.is-arrow
  .el-time-spinner__item:hover:not(.disabled):not(.active) {
  background: #fff;
  cursor: default;
}
.el-time-spinner__arrow {
  font-size: 12px;
  color: #909399;
  position: absolute;
  left: 0;
  width: 100%;
  z-index: 1;
  text-align: center;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}
.el-time-spinner__arrow:hover {
  color: #409eff;
}
.el-time-spinner__arrow.el-icon-arrow-up {
  top: 10px;
}
.el-time-spinner__arrow.el-icon-arrow-down {
  bottom: 10px;
}
.el-time-spinner__input.el-input {
  width: 70%;
}
.el-time-spinner__input.el-input .el-input__inner,
.el-time-spinner__list {
  padding: 0;
  text-align: center;
}
.el-time-spinner__list {
  margin: 0;
  list-style: none;
}
.el-time-spinner__list:after,
.el-time-spinner__list:before {
  content: "";
  display: block;
  width: 100%;
  height: 80px;
}
.el-time-spinner__item {
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  color: #606266;
}
.el-time-spinner__item:hover:not(.disabled):not(.active) {
  background: #f5f7fa;
  cursor: pointer;
}
.el-time-spinner__item.active:not(.disabled) {
  color: #303133;
  font-weight: 700;
}
.el-time-spinner__item.disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}
.el-date-editor {
  position: relative;
  display: inline-block;
  text-align: left;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 220px;
}
.el-date-editor--monthrange.el-input,
.el-date-editor--monthrange.el-input__inner {
  width: 300px;
}
.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 350px;
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 400px;
}
.el-date-editor--dates .el-input__inner {
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-date-editor .el-icon-circle-close {
  cursor: pointer;
}
.el-date-editor .el-range__icon {
  font-size: 14px;
  margin-left: -5px;
  color: #c0c4cc;
  float: left;
  line-height: 32px;
}
.el-date-editor .el-range-input,
.el-date-editor .el-range-separator {
  height: 100%;
  margin: 0;
  text-align: center;
  display: inline-block;
  font-size: 14px;
}
.el-date-editor .el-range-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  outline: 0;
  padding: 0;
  width: 39%;
  color: #606266;
}
.el-date-editor .el-range-input::-webkit-input-placeholder {
  color: #c0c4cc;
}
.el-date-editor .el-range-input:-ms-input-placeholder {
  color: #c0c4cc;
}
.el-date-editor .el-range-input::-ms-input-placeholder {
  color: #c0c4cc;
}
.el-date-editor .el-range-input::-moz-placeholder {
  color: #c0c4cc;
}
.el-date-editor .el-range-input::placeholder {
  color: #c0c4cc;
}
.el-date-editor .el-range-separator {
  padding: 0 5px;
  line-height: 32px;
  width: 5%;
  color: #303133;
}
.el-date-editor .el-range__close-icon {
  font-size: 14px;
  color: #c0c4cc;
  width: 25px;
  display: inline-block;
  float: right;
  line-height: 32px;
}
.el-range-editor.el-input__inner {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 3px 10px;
}
.el-range-editor .el-range-input {
  line-height: 1;
}
.el-range-editor.is-active,
.el-range-editor.is-active:hover {
  border-color: #409eff;
}
.el-range-editor--medium.el-input__inner {
  height: 36px;
}
.el-range-editor--medium .el-range-separator {
  line-height: 28px;
  font-size: 14px;
}
.el-range-editor--medium .el-range-input {
  font-size: 14px;
}
.el-range-editor--medium .el-range__close-icon,
.el-range-editor--medium .el-range__icon {
  line-height: 28px;
}
.el-range-editor--small.el-input__inner {
  height: 32px;
}
.el-range-editor--small .el-range-separator {
  line-height: 24px;
  font-size: 13px;
}
.el-range-editor--small .el-range-input {
  font-size: 13px;
}
.el-range-editor--small .el-range__close-icon,
.el-range-editor--small .el-range__icon {
  line-height: 24px;
}
.el-range-editor--mini.el-input__inner {
  height: 28px;
}
.el-range-editor--mini .el-range-separator {
  line-height: 20px;
  font-size: 12px;
}
.el-range-editor--mini .el-range-input {
  font-size: 12px;
}
.el-range-editor--mini .el-range__close-icon,
.el-range-editor--mini .el-range__icon {
  line-height: 20px;
}
.el-range-editor.is-disabled {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}
.el-range-editor.is-disabled:focus,
.el-range-editor.is-disabled:hover {
  border-color: #e4e7ed;
}
.el-range-editor.is-disabled input {
  background-color: #f5f7fa;
  color: #c0c4cc;
  cursor: not-allowed;
}
.el-range-editor.is-disabled input::-webkit-input-placeholder {
  color: #c0c4cc;
}
.el-range-editor.is-disabled input:-ms-input-placeholder {
  color: #c0c4cc;
}
.el-range-editor.is-disabled input::-ms-input-placeholder {
  color: #c0c4cc;
}
.el-range-editor.is-disabled input::-moz-placeholder {
  color: #c0c4cc;
}
.el-range-editor.is-disabled input::placeholder {
  color: #c0c4cc;
}
.el-range-editor.is-disabled .el-range-separator {
  color: #c0c4cc;
}
.el-picker-panel {
  color: #606266;
  border: 1px solid #e4e7ed;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  background: #fff;
  border-radius: 4px;
  line-height: 30px;
  margin: 5px 0;
}
.el-picker-panel__body-wrapper:after,
.el-picker-panel__body:after {
  content: "";
  display: table;
  clear: both;
}
.el-picker-panel__content {
  position: relative;
  margin: 15px;
}
.el-picker-panel__footer {
  border-top: 1px solid #e4e4e4;
  padding: 4px;
  text-align: right;
  background-color: #fff;
  position: relative;
  font-size: 0;
}
.el-picker-panel__shortcut {
  display: block;
  width: 100%;
  border: 0;
  background-color: transparent;
  line-height: 28px;
  font-size: 14px;
  color: #606266;
  padding-left: 12px;
  text-align: left;
  outline: 0;
  cursor: pointer;
}
.el-picker-panel__shortcut:hover {
  color: #409eff;
}
.el-picker-panel__shortcut.active {
  background-color: #e6f1fe;
  color: #409eff;
}
.el-picker-panel__btn {
  border: 1px solid #dcdcdc;
  color: #333;
  line-height: 24px;
  border-radius: 2px;
  padding: 0 20px;
  cursor: pointer;
  background-color: transparent;
  outline: 0;
  font-size: 12px;
}
.el-picker-panel__btn[disabled] {
  color: #ccc;
  cursor: not-allowed;
}
.el-picker-panel__icon-btn {
  font-size: 12px;
  color: #303133;
  border: 0;
  background: 0 0;
  cursor: pointer;
  outline: 0;
  margin-top: 8px;
}
.el-picker-panel__icon-btn:hover {
  color: #409eff;
}
.el-picker-panel__icon-btn.is-disabled {
  color: #bbb;
}
.el-picker-panel__icon-btn.is-disabled:hover {
  cursor: not-allowed;
}
.el-picker-panel__link-btn {
  vertical-align: middle;
}
.el-picker-panel [slot="sidebar"],
.el-picker-panel__sidebar {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 110px;
  border-right: 1px solid #e4e4e4;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 6px;
  background-color: #fff;
  overflow: auto;
}
.el-picker-panel [slot="sidebar"] + .el-picker-panel__body,
.el-picker-panel__sidebar + .el-picker-panel__body {
  margin-left: 110px;
}
.el-date-picker {
  width: 322px;
}
.el-date-picker.has-sidebar.has-time {
  width: 434px;
}
.el-date-picker.has-sidebar {
  width: 438px;
}
.el-date-picker.has-time .el-picker-panel__body-wrapper {
  position: relative;
}
.el-date-picker .el-picker-panel__content {
  width: 292px;
}
.el-date-picker table {
  table-layout: fixed;
  width: 100%;
}
.el-date-picker__editor-wrap {
  position: relative;
  display: table-cell;
  padding: 0 5px;
}
.el-date-picker__time-header {
  position: relative;
  border-bottom: 1px solid #e4e4e4;
  font-size: 12px;
  padding: 8px 5px 5px;
  display: table;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-date-picker__header {
  margin: 12px;
  text-align: center;
}
.el-date-picker__header--bordered {
  margin-bottom: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
}
.el-date-picker__header--bordered + .el-picker-panel__content {
  margin-top: 0;
}
.el-date-picker__header-label {
  font-size: 16px;
  font-weight: 500;
  padding: 0 5px;
  line-height: 22px;
  text-align: center;
  cursor: pointer;
  color: #606266;
}
.el-date-picker__header-label.active,
.el-date-picker__header-label:hover {
  color: #409eff;
}
.el-date-picker__prev-btn {
  float: left;
}
.el-date-picker__next-btn {
  float: right;
}
.el-date-picker__time-wrap {
  padding: 10px;
  text-align: center;
}
.el-date-picker__time-label {
  float: left;
  cursor: pointer;
  line-height: 30px;
  margin-left: 10px;
}
.el-date-range-picker {
  width: 646px;
}
.el-date-range-picker.has-sidebar {
  width: 756px;
}
.el-date-range-picker table {
  table-layout: fixed;
  width: 100%;
}
.el-date-range-picker .el-picker-panel__body {
  min-width: 513px;
}
.el-date-range-picker .el-picker-panel__content {
  margin: 0;
}
.el-date-range-picker__header {
  position: relative;
  text-align: center;
  height: 28px;
}
.el-date-range-picker__header [class*="arrow-left"] {
  float: left;
}
.el-date-range-picker__header [class*="arrow-right"] {
  float: right;
}
.el-date-range-picker__header div {
  font-size: 16px;
  font-weight: 500;
  margin-right: 50px;
}
.el-date-range-picker__content {
  float: left;
  width: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 16px;
}
.el-date-range-picker__content.is-left {
  border-right: 1px solid #e4e4e4;
}
.el-date-range-picker__content .el-date-range-picker__header div {
  margin-left: 50px;
  margin-right: 50px;
}
.el-date-range-picker__editors-wrap {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: table-cell;
}
.el-date-range-picker__editors-wrap.is-right {
  text-align: right;
}
.el-date-range-picker__time-header {
  position: relative;
  border-bottom: 1px solid #e4e4e4;
  font-size: 12px;
  padding: 8px 5px 5px;
  display: table;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-date-range-picker__time-header > .el-icon-arrow-right {
  font-size: 20px;
  vertical-align: middle;
  display: table-cell;
  color: #303133;
}
.el-date-range-picker__time-picker-wrap {
  position: relative;
  display: table-cell;
  padding: 0 5px;
}
.el-date-range-picker__time-picker-wrap .el-picker-panel {
  position: absolute;
  top: 13px;
  right: 0;
  z-index: 1;
  background: #fff;
}
.el-time-range-picker {
  width: 354px;
  overflow: visible;
}
.el-time-range-picker__content {
  position: relative;
  text-align: center;
  padding: 10px;
}
.el-time-range-picker__cell {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 4px 7px 7px;
  width: 50%;
  display: inline-block;
}
.el-time-range-picker__header {
  margin-bottom: 5px;
  text-align: center;
  font-size: 14px;
}
.el-time-panel,
.el-time-range-picker__body {
  border-radius: 2px;
  border: 1px solid #e4e7ed;
}
.el-time-panel {
  margin: 5px 0;
  background-color: #fff;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  width: 180px;
  left: 0;
  z-index: 1000;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.el-time-panel__content {
  font-size: 0;
  position: relative;
  overflow: hidden;
}
.el-time-panel__content:after,
.el-time-panel__content:before {
  content: "";
  top: 50%;
  position: absolute;
  margin-top: -15px;
  height: 32px;
  z-index: -1;
  left: 0;
  right: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 6px;
  text-align: left;
  border-top: 1px solid #e4e7ed;
  border-bottom: 1px solid #e4e7ed;
}
.el-time-panel__content:after {
  left: 50%;
  margin-left: 12%;
  margin-right: 12%;
}
.el-time-panel__content:before {
  padding-left: 50%;
  margin-right: 12%;
  margin-left: 12%;
}
.el-time-panel__content.has-seconds:after {
  left: 66.66667%;
}
.el-time-panel__content.has-seconds:before {
  padding-left: 33.33333%;
}
.el-time-panel__footer {
  border-top: 1px solid #e4e4e4;
  padding: 4px;
  height: 36px;
  line-height: 25px;
  text-align: right;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-time-panel__btn {
  border: none;
  line-height: 28px;
  padding: 0 5px;
  margin: 0 5px;
  cursor: pointer;
  background-color: transparent;
  outline: 0;
  font-size: 12px;
  color: #303133;
}
.el-time-panel__btn.confirm {
  font-weight: 800;
  color: #409eff;
}
.el-checkbox-button__inner,
.el-tag {
  -webkit-box-sizing: border-box;
  white-space: nowrap;
}
.el-table-column--selection .cell {
  padding-left: 14px;
  padding-right: 14px;
}
.el-table-filter {
  border: 1px solid #ebeef5;
  border-radius: 2px;
  background-color: #fff;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 2px 0;
}
.el-table-filter__list {
  padding: 5px 0;
  margin: 0;
  list-style: none;
  min-width: 100px;
}
.el-table-filter__list-item {
  line-height: 36px;
  padding: 0 10px;
  cursor: pointer;
  font-size: 14px;
}
.el-table-filter__list-item:hover {
  background-color: #ecf5ff;
  color: #66b1ff;
}
.el-table-filter__list-item.is-active {
  background-color: #409eff;
  color: #fff;
}
.el-table-filter__content {
  min-width: 100px;
}
.el-table-filter__bottom {
  border-top: 1px solid #ebeef5;
  padding: 8px;
}
.el-table-filter__bottom button {
  background: 0 0;
  border: none;
  color: #606266;
  cursor: pointer;
  font-size: 13px;
  padding: 0 3px;
}
.el-table-filter__bottom button:hover {
  color: #409eff;
}
.el-table-filter__bottom button:focus {
  outline: 0;
}
.el-table-filter__bottom button.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}
.el-table-filter__wrap {
  max-height: 280px;
}
.el-table-filter__checkbox-group {
  padding: 10px;
}
.el-table-filter__checkbox-group label.el-checkbox {
  display: block;
  margin-right: 5px;
  margin-bottom: 8px;
  margin-left: 5px;
}
.el-table-filter__checkbox-group .el-checkbox:last-child {
  margin-bottom: 0;
}
.el-checkbox,
.el-checkbox__input {
  white-space: nowrap;
}
.el-table,
.el-table__append-wrapper {
  overflow: hidden;
}
.el-table td.is-hidden > *,
.el-table th.is-hidden > *,
.el-table--hidden {
  visibility: hidden;
}
.el-checkbox-button__inner,
.el-table th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.el-checkbox-button__inner,
.el-checkbox__input {
  outline: 0;
  vertical-align: middle;
}
.el-checkbox-button__inner {
  white-space: nowrap;
}
.el-tooltip:focus:hover,
.el-tooltip:focus:not(.focusing) {
  outline-width: 0;
}
.el-tooltip__popper {
  position: absolute;
  border-radius: 4px;
  padding: 10px;
  z-index: 2000;
  font-size: 12px;
  line-height: 1.2;
  min-width: 10px;
  word-wrap: break-word;
}
.el-tooltip__popper .popper__arrow,
.el-tooltip__popper .popper__arrow:after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.el-tooltip__popper .popper__arrow {
  border-width: 6px;
}
.el-tooltip__popper .popper__arrow:after {
  content: " ";
  border-width: 5px;
}
.el-tooltip__popper[x-placement^="top"] {
  margin-bottom: 12px;
}
.el-tooltip__popper[x-placement^="top"] .popper__arrow {
  bottom: -6px;
  border-top-color: #303133;
  border-bottom-width: 0;
}
.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
  bottom: 1px;
  margin-left: -5px;
  border-top-color: #303133;
  border-bottom-width: 0;
}
.el-tooltip__popper[x-placement^="bottom"] {
  margin-top: 12px;
}
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  top: -6px;
  border-top-width: 0;
  border-bottom-color: #303133;
}
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow:after {
  top: 1px;
  margin-left: -5px;
  border-top-width: 0;
  border-bottom-color: #303133;
}
.el-tooltip__popper[x-placement^="right"] {
  margin-left: 12px;
}
.el-tooltip__popper[x-placement^="right"] .popper__arrow {
  left: -6px;
  border-right-color: #303133;
  border-left-width: 0;
}
.el-tooltip__popper[x-placement^="right"] .popper__arrow:after {
  bottom: -5px;
  left: 1px;
  border-right-color: #303133;
  border-left-width: 0;
}
.el-tooltip__popper[x-placement^="left"] {
  margin-right: 12px;
}
.el-tooltip__popper[x-placement^="left"] .popper__arrow {
  right: -6px;
  border-right-width: 0;
  border-left-color: #303133;
}
.el-tooltip__popper[x-placement^="left"] .popper__arrow:after {
  right: 1px;
  bottom: -5px;
  margin-left: -5px;
  border-right-width: 0;
  border-left-color: #303133;
}
.el-tooltip__popper.is-dark {
  background: #303133;
  color: #fff;
}
.el-table,
.el-table__expanded-cell {
  background-color: #fff;
}
.el-tooltip__popper.is-light {
  background: #fff;
  border: 1px solid #303133;
}
.el-tooltip__popper.is-light[x-placement^="top"] .popper__arrow {
  border-top-color: #303133;
}
.el-tooltip__popper.is-light[x-placement^="top"] .popper__arrow:after {
  border-top-color: #fff;
}
.el-tooltip__popper.is-light[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #303133;
}
.el-tooltip__popper.is-light[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: #fff;
}
.el-tooltip__popper.is-light[x-placement^="left"] .popper__arrow {
  border-left-color: #303133;
}
.el-tooltip__popper.is-light[x-placement^="left"] .popper__arrow:after {
  border-left-color: #fff;
}
.el-tooltip__popper.is-light[x-placement^="right"] .popper__arrow {
  border-right-color: #303133;
}
.el-tooltip__popper.is-light[x-placement^="right"] .popper__arrow:after {
  border-right-color: #fff;
}
.el-table {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 100%;
  max-width: 100%;
  font-size: 14px;
  color: #606266;
}
.el-table--mini,
.el-table--small,
.el-table__expand-icon {
  font-size: 12px;
}
.el-table__empty-block {
  min-height: 60px;
  text-align: center;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.el-table__empty-text {
  line-height: 60px;
  width: 50%;
  color: #909399;
}
.el-table__expand-column .cell {
  padding: 0;
  text-align: center;
}
.el-table__expand-icon {
  position: relative;
  cursor: pointer;
  color: #666;
  -webkit-transition: -webkit-transform 0.2s ease-in-out;
  transition: -webkit-transform 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
  height: 20px;
}
.el-table__expand-icon--expanded {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
.el-table__expand-icon > .el-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -5px;
  margin-top: -5px;
}
.el-table__expanded-cell[class*="cell"] {
  padding: 20px 50px;
}
.el-table__expanded-cell:hover {
  background-color: transparent !important;
}
.el-table__placeholder {
  display: inline-block;
  width: 20px;
}
.el-table--fit {
  border-right: 0;
  border-bottom: 0;
}
.el-table--fit td.gutter,
.el-table--fit th.gutter {
  border-right-width: 1px;
}
.el-table--scrollable-x .el-table__body-wrapper {
  overflow-x: auto;
}
.el-table--scrollable-y .el-table__body-wrapper {
  overflow-y: auto;
}
.el-table thead {
  color: #909399;
  font-weight: 500;
}
.el-table thead.is-group th {
  background: #f5f7fa;
}
.el-table th,
.el-table tr {
  background-color: #fff;
}
.el-table td,
.el-table th {
  padding: 12px 0;
  min-width: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
  text-align: left;
}
.el-table td.is-center,
.el-table th.is-center {
  text-align: center;
}
.el-table td.is-right,
.el-table th.is-right {
  text-align: right;
}
.el-table td.gutter,
.el-table th.gutter {
  width: 15px;
  border-right-width: 0;
  border-bottom-width: 0;
  padding: 0;
}
.el-table--medium td,
.el-table--medium th {
  padding: 10px 0;
}
.el-table--small td,
.el-table--small th {
  padding: 8px 0;
}
.el-table--mini td,
.el-table--mini th {
  padding: 6px 0;
}
.el-table .cell,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding-left: 10px;
}
.el-table tr input[type="checkbox"] {
  margin: 0;
}
.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid #ebeef5;
}
.el-table th.is-sortable {
  cursor: pointer;
}
.el-table th {
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.el-table th > .cell {
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
}
.el-table th > .cell.highlight {
  color: #409eff;
}
.el-table th.required > div:before {
  display: inline-block;
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ff4d51;
  margin-right: 5px;
  vertical-align: middle;
}
.el-table td div {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-table td.gutter {
  width: 0;
}
.el-table .cell {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding-right: 10px;
}
.el-table .cell.el-tooltip {
  white-space: nowrap;
  min-width: 50px;
}
.el-table--border,
.el-table--group {
  border: 1px solid #ebeef5;
}
.el-table--border:after,
.el-table--group:after,
.el-table:before {
  content: "";
  position: absolute;
  background-color: #ebeef5;
  z-index: 1;
}
.el-table--border:after,
.el-table--group:after {
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
}
.el-table:before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
}
.el-table--border {
  border-right: none;
  border-bottom: none;
}
.el-table--border.el-loading-parent--relative {
  border-color: transparent;
}
.el-table--border td,
.el-table--border th,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right: 1px solid #ebeef5;
}
.el-table--border th.gutter:last-of-type {
  border-bottom: 1px solid #ebeef5;
  border-bottom-width: 1px;
}
.el-table--border th,
.el-table__fixed-right-patch {
  border-bottom: 1px solid #ebeef5;
}
.el-table__fixed,
.el-table__fixed-right {
  position: absolute;
  top: 0;
  left: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
}
.el-table__fixed-right:before,
.el-table__fixed:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: #ebeef5;
  z-index: 4;
}
.el-table__fixed-right-patch {
  position: absolute;
  top: -1px;
  right: 0;
  background-color: #fff;
}
.el-table__fixed-right {
  top: 0;
  left: auto;
  right: 0;
}
.el-table__fixed-right .el-table__fixed-body-wrapper,
.el-table__fixed-right .el-table__fixed-footer-wrapper,
.el-table__fixed-right .el-table__fixed-header-wrapper {
  left: auto;
  right: 0;
}
.el-table__fixed-header-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
}
.el-table__fixed-footer-wrapper {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 3;
}
.el-table__fixed-footer-wrapper tbody td {
  border-top: 1px solid #ebeef5;
  background-color: #f5f7fa;
  color: #606266;
}
.el-table__fixed-body-wrapper {
  position: absolute;
  left: 0;
  top: 37px;
  overflow: hidden;
  z-index: 3;
}
.el-table__body-wrapper,
.el-table__footer-wrapper,
.el-table__header-wrapper {
  width: 100%;
}
.el-table__footer-wrapper {
  margin-top: -1px;
}
.el-table__footer-wrapper td {
  border-top: 1px solid #ebeef5;
}
.el-table__body,
.el-table__footer,
.el-table__header {
  table-layout: fixed;
  border-collapse: separate;
}
.el-table__footer-wrapper,
.el-table__header-wrapper {
  overflow: hidden;
}
.el-table__footer-wrapper tbody td,
.el-table__header-wrapper tbody td {
  background-color: #f5f7fa;
  color: #606266;
}
.el-table__body-wrapper {
  overflow: hidden;
  position: relative;
}
.el-table__body-wrapper.is-scrolling-left ~ .el-table__fixed,
.el-table__body-wrapper.is-scrolling-none ~ .el-table__fixed,
.el-table__body-wrapper.is-scrolling-none ~ .el-table__fixed-right,
.el-table__body-wrapper.is-scrolling-right ~ .el-table__fixed-right {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.el-table__body-wrapper
  .el-table--border.is-scrolling-right
  ~ .el-table__fixed-right {
  border-left: 1px solid #ebeef5;
}
.el-table .caret-wrapper {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 34px;
  width: 24px;
  vertical-align: middle;
  cursor: pointer;
  overflow: initial;
  position: relative;
}
.el-table .sort-caret {
  width: 0;
  height: 0;
  border: 5px solid transparent;
  position: absolute;
  left: 7px;
}
.el-table .sort-caret.ascending {
  border-bottom-color: #c0c4cc;
  top: 5px;
}
.el-table .sort-caret.descending {
  border-top-color: #c0c4cc;
  bottom: 7px;
}
.el-table .ascending .sort-caret.ascending {
  border-bottom-color: #409eff;
}
.el-table .descending .sort-caret.descending {
  border-top-color: #409eff;
}
.el-table .hidden-columns {
  visibility: hidden;
  position: absolute;
  z-index: -1;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fafafa;
}
.el-table--striped .el-table__body tr.el-table__row--striped.current-row td {
  background-color: #ecf5ff;
}
.el-table__body tr.hover-row.current-row > td,
.el-table__body tr.hover-row.el-table__row--striped.current-row > td,
.el-table__body tr.hover-row.el-table__row--striped > td,
.el-table__body tr.hover-row > td {
  background-color: #f5f7fa;
}
.el-table__body tr.current-row > td {
  background-color: #ecf5ff;
}
.el-table__column-resize-proxy {
  position: absolute;
  left: 200px;
  top: 0;
  bottom: 0;
  width: 0;
  border-left: 1px solid #ebeef5;
  z-index: 10;
}
.el-table__column-filter-trigger {
  display: inline-block;
  line-height: 34px;
  cursor: pointer;
}
.el-table__column-filter-trigger i {
  color: #909399;
  font-size: 12px;
  -webkit-transform: scale(0.75);
  transform: scale(0.75);
}
.el-table--enable-row-transition .el-table__body td {
  -webkit-transition: background-color 0.25s ease;
  transition: background-color 0.25s ease;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f5f7fa;
}
.el-table--fluid-height .el-table__fixed,
.el-table--fluid-height .el-table__fixed-right {
  bottom: 0;
  overflow: hidden;
}
.el-table [class*="el-table__row--level"] .el-table__expand-icon {
  display: inline-block;
  width: 20px;
  line-height: 20px;
  height: 20px;
  text-align: center;
  margin-right: 3px;
}
.el-select-dropdown__item,
.el-tag {
  white-space: nowrap;
  -webkit-box-sizing: border-box;
}
.el-switch {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  font-size: 14px;
  line-height: 20px;
  height: 20px;
  vertical-align: middle;
}
.el-switch.is-disabled .el-switch__core,
.el-switch.is-disabled .el-switch__label {
  cursor: not-allowed;
}
.el-switch__core,
.el-switch__label {
  display: inline-block;
  cursor: pointer;
  vertical-align: middle;
}
.el-switch__label {
  -webkit-transition: 0.2s;
  transition: 0.2s;
  height: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}
.el-switch__label.is-active {
  color: #409eff;
}
.el-switch__label--left {
  margin-right: 10px;
}
.el-switch__label--right {
  margin-left: 10px;
}
.el-switch__label * {
  line-height: 1;
  font-size: 14px;
  display: inline-block;
}
.el-switch__input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  margin: 0;
}
.el-switch__core {
  margin: 0;
  position: relative;
  width: 40px;
  height: 20px;
  border: 1px solid #dcdfe6;
  outline: 0;
  border-radius: 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #dcdfe6;
  -webkit-transition: border-color 0.3s, background-color 0.3s;
  transition: border-color 0.3s, background-color 0.3s;
}
.el-switch__core:after {
  content: "";
  position: absolute;
  top: 1px;
  left: 1px;
  border-radius: 100%;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  width: 16px;
  height: 16px;
  background-color: #fff;
}
.el-switch.is-checked .el-switch__core {
  border-color: #409eff;
  background-color: #409eff;
}
.el-switch.is-checked .el-switch__core:after {
  left: 100%;
  margin-left: -17px;
}
.el-switch.is-disabled {
  opacity: 0.6;
}
.el-switch--wide .el-switch__label.el-switch__label--left span {
  left: 10px;
}
.el-switch--wide .el-switch__label.el-switch__label--right span {
  right: 10px;
}
.el-switch .label-fade-enter,
.el-switch .label-fade-leave-active {
  opacity: 0;
}
.el-checkbox,
.el-checkbox__input {
  display: inline-block;
  position: relative;
}
.el-checkbox-button__inner,
.el-checkbox__input {
  white-space: nowrap;
  vertical-align: middle;
  outline: 0;
}
.el-checkbox {
  color: #606266;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-right: 30px;
}
.el-checkbox.is-bordered {
  padding: 9px 20px 9px 10px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: normal;
  height: 40px;
}
.el-checkbox.is-bordered.is-checked {
  border-color: #409eff;
}
.el-checkbox.is-bordered.is-disabled {
  border-color: #ebeef5;
  cursor: not-allowed;
}
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 10px;
}
.el-checkbox.is-bordered.el-checkbox--medium {
  padding: 7px 20px 7px 10px;
  border-radius: 4px;
  height: 36px;
}
.el-checkbox.is-bordered.el-checkbox--medium .el-checkbox__label {
  line-height: 17px;
  font-size: 14px;
}
.el-checkbox.is-bordered.el-checkbox--medium .el-checkbox__inner {
  height: 14px;
  width: 14px;
}
.el-checkbox.is-bordered.el-checkbox--small {
  padding: 5px 15px 5px 10px;
  border-radius: 3px;
  height: 32px;
}
.el-checkbox.is-bordered.el-checkbox--small .el-checkbox__label {
  line-height: 15px;
  font-size: 12px;
}
.el-checkbox.is-bordered.el-checkbox--small .el-checkbox__inner {
  height: 12px;
  width: 12px;
}
.el-checkbox.is-bordered.el-checkbox--small .el-checkbox__inner:after {
  height: 6px;
  width: 2px;
}
.el-checkbox.is-bordered.el-checkbox--mini {
  padding: 3px 15px 3px 10px;
  border-radius: 3px;
  height: 28px;
}
.el-checkbox.is-bordered.el-checkbox--mini .el-checkbox__label {
  line-height: 12px;
  font-size: 12px;
}
.el-checkbox.is-bordered.el-checkbox--mini .el-checkbox__inner {
  height: 12px;
  width: 12px;
}
.el-checkbox.is-bordered.el-checkbox--mini .el-checkbox__inner:after {
  height: 6px;
  width: 2px;
}
.el-checkbox__input {
  cursor: pointer;
  line-height: 1;
}
.el-checkbox__input.is-disabled .el-checkbox__inner {
  background-color: #edf2fc;
  border-color: #dcdfe6;
  cursor: not-allowed;
}
.el-checkbox__input.is-disabled .el-checkbox__inner:after {
  cursor: not-allowed;
  border-color: #c0c4cc;
}
.el-checkbox__input.is-disabled .el-checkbox__inner + .el-checkbox__label {
  cursor: not-allowed;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #f2f6fc;
  border-color: #dcdfe6;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner:after {
  border-color: #c0c4cc;
}
.el-checkbox__input.is-disabled.is-indeterminate .el-checkbox__inner {
  background-color: #f2f6fc;
  border-color: #dcdfe6;
}
.el-checkbox__input.is-disabled.is-indeterminate .el-checkbox__inner:before {
  background-color: #c0c4cc;
  border-color: #c0c4cc;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409eff;
  border-color: #409eff;
}
.el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #c0c4cc;
  cursor: not-allowed;
}
.el-checkbox__input.is-checked .el-checkbox__inner:after {
  -webkit-transform: rotate(45deg) scaleY(1);
  transform: rotate(45deg) scaleY(1);
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #409eff;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #409eff;
}
.el-checkbox__input.is-indeterminate .el-checkbox__inner:before {
  content: "";
  position: absolute;
  display: block;
  background-color: #fff;
  height: 2px;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
  left: 0;
  right: 0;
  top: 5px;
}
.el-checkbox__input.is-indeterminate .el-checkbox__inner:after {
  display: none;
}
.el-checkbox__inner {
  display: inline-block;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  background-color: #fff;
  z-index: 1;
  -webkit-transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}
.el-checkbox__inner:hover {
  border-color: #409eff;
}
.el-checkbox__inner:after {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  content: "";
  border: 1px solid #fff;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 4px;
  position: absolute;
  top: 1px;
  -webkit-transform: rotate(45deg) scaleY(0);
  transform: rotate(45deg) scaleY(0);
  width: 3px;
  -webkit-transition: -webkit-transform 0.15s ease-in 50ms;
  transition: -webkit-transform 0.15s ease-in 50ms;
  transition: transform 0.15s ease-in 50ms;
  transition: transform 0.15s ease-in 50ms, -webkit-transform 0.15s ease-in 50ms;
  -webkit-transform-origin: center;
  transform-origin: center;
}
.el-checkbox__original {
  opacity: 0;
  outline: 0;
  position: absolute;
  margin: 0;
  width: 0;
  height: 0;
  z-index: -1;
}
.el-checkbox-button,
.el-checkbox-button__inner {
  display: inline-block;
  position: relative;
}
.el-checkbox__label {
  display: inline-block;
  padding-left: 10px;
  line-height: 19px;
  font-size: 14px;
}
.el-checkbox:last-of-type {
  margin-right: 0;
}
.el-checkbox-button__inner {
  line-height: 1;
  font-weight: 500;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-left: 0;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 0;
}
.el-checkbox-button__inner.is-round {
  padding: 12px 20px;
}
.el-checkbox-button__inner:hover {
  color: #409eff;
}
.el-checkbox-button__inner [class*="el-icon-"] {
  line-height: 0.9;
}
.el-checkbox-button__inner [class*="el-icon-"] + span {
  margin-left: 5px;
}
.el-checkbox-button__original {
  opacity: 0;
  outline: 0;
  position: absolute;
  margin: 0;
  z-index: -1;
}
.el-checkbox-button.is-checked .el-checkbox-button__inner {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  -webkit-box-shadow: -1px 0 0 0 #8cc5ff;
  box-shadow: -1px 0 0 0 #8cc5ff;
}
.el-checkbox-button.is-checked:first-child .el-checkbox-button__inner {
  border-left-color: #409eff;
}
.el-checkbox-button.is-disabled .el-checkbox-button__inner {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border-color: #ebeef5;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.el-checkbox-button.is-disabled:first-child .el-checkbox-button__inner {
  border-left-color: #ebeef5;
}
.el-checkbox-button:first-child .el-checkbox-button__inner {
  border-left: 1px solid #dcdfe6;
  border-radius: 4px 0 0 4px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.el-checkbox-button.is-focus .el-checkbox-button__inner {
  border-color: #409eff;
}
.el-checkbox-button:last-child .el-checkbox-button__inner {
  border-radius: 0 4px 4px 0;
}
.el-checkbox-button--medium .el-checkbox-button__inner {
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 0;
}
.el-checkbox-button--medium .el-checkbox-button__inner.is-round {
  padding: 10px 20px;
}
.el-checkbox-button--small .el-checkbox-button__inner {
  padding: 9px 15px;
  font-size: 12px;
  border-radius: 0;
}
.el-checkbox-button--small .el-checkbox-button__inner.is-round {
  padding: 9px 15px;
}
.el-checkbox-button--mini .el-checkbox-button__inner {
  padding: 7px 15px;
  font-size: 12px;
  border-radius: 0;
}
.el-checkbox-button--mini .el-checkbox-button__inner.is-round {
  padding: 7px 15px;
}
.el-checkbox-group {
  font-size: 0;
}
.el-fade-in-enter,
.el-fade-in-leave-active,
.el-fade-in-linear-enter,
.el-fade-in-linear-leave,
.el-fade-in-linear-leave-active,
.fade-in-linear-enter,
.fade-in-linear-leave,
.fade-in-linear-leave-active {
  opacity: 0;
}
.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 200px;
}
.el-fade-in-linear-enter-active,
.el-fade-in-linear-leave-active,
.fade-in-linear-enter-active,
.fade-in-linear-leave-active {
  -webkit-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
}
.el-fade-in-enter-active,
.el-fade-in-leave-active,
.el-zoom-in-center-enter-active,
.el-zoom-in-center-leave-active {
  -webkit-transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
  transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
}
.el-zoom-in-center-enter,
.el-zoom-in-center-leave-active {
  opacity: 0;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
}
.el-zoom-in-top-enter-active,
.el-zoom-in-top-leave-active {
  opacity: 1;
  -webkit-transform: scaleY(1);
  transform: scaleY(1);
  -webkit-transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  -webkit-transform-origin: center top;
  transform-origin: center top;
}
.el-zoom-in-top-enter,
.el-zoom-in-top-leave-active {
  opacity: 0;
  -webkit-transform: scaleY(0);
  transform: scaleY(0);
}
.el-zoom-in-bottom-enter-active,
.el-zoom-in-bottom-leave-active {
  opacity: 1;
  -webkit-transform: scaleY(1);
  transform: scaleY(1);
  -webkit-transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  -webkit-transform-origin: center bottom;
  transform-origin: center bottom;
}
.el-zoom-in-bottom-enter,
.el-zoom-in-bottom-leave-active {
  opacity: 0;
  -webkit-transform: scaleY(0);
  transform: scaleY(0);
}
.el-zoom-in-left-enter-active,
.el-zoom-in-left-leave-active {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  -webkit-transform-origin: top left;
  transform-origin: top left;
}
.el-zoom-in-left-enter,
.el-zoom-in-left-leave-active {
  opacity: 0;
  -webkit-transform: scale(0.45);
  transform: scale(0.45);
}
.collapse-transition {
  -webkit-transition: height 0.3s ease-in-out, padding-top 0.3s ease-in-out,
    padding-bottom 0.3s ease-in-out;
  transition: height 0.3s ease-in-out, padding-top 0.3s ease-in-out,
    padding-bottom 0.3s ease-in-out;
}
.horizontal-collapse-transition {
  -webkit-transition: width 0.3s ease-in-out, padding-left 0.3s ease-in-out,
    padding-right 0.3s ease-in-out;
  transition: width 0.3s ease-in-out, padding-left 0.3s ease-in-out,
    padding-right 0.3s ease-in-out;
}
.el-list-enter-active,
.el-list-leave-active {
  -webkit-transition: all 1s;
  transition: all 1s;
}
.el-list-enter,
.el-list-leave-active {
  opacity: 0;
  -webkit-transform: translateY(-30px);
  transform: translateY(-30px);
}
.el-opacity-transition {
  -webkit-transition: opacity 0.3s cubic-bezier(0.55, 0, 0.1, 1);
  transition: opacity 0.3s cubic-bezier(0.55, 0, 0.1, 1);
}
.el-menu {
  border-right: 1px solid #e6e6e6;
  list-style: none;
  position: relative;
  margin: 0;
  padding-left: 0;
}
.el-menu,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: #fff;
}
.el-menu:after,
.el-menu:before {
  display: table;
  content: "";
}
.el-menu:after {
  clear: both;
}
.el-menu.el-menu--horizontal {
  border-bottom: 1px solid #e6e6e6;
}
.el-menu--horizontal {
  border-right: none;
}
.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 60px;
  line-height: 60px;
  margin: 0;
  border-bottom: 2px solid transparent;
  color: #909399;
}
.el-menu--horizontal > .el-menu-item a,
.el-menu--horizontal > .el-menu-item a:hover {
  color: inherit;
}
.el-menu--horizontal > .el-submenu {
  float: left;
}
.el-menu--horizontal > .el-submenu:focus,
.el-menu--horizontal > .el-submenu:hover {
  outline: 0;
}
.el-menu--horizontal > .el-submenu:focus .el-submenu__title,
.el-menu--horizontal > .el-submenu:hover .el-submenu__title {
  color: #303133;
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 2px solid #409eff;
  color: #303133;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 60px;
  line-height: 60px;
  border-bottom: 2px solid transparent;
  color: #909399;
}
.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  position: static;
  vertical-align: middle;
  margin-left: 8px;
  margin-top: -3px;
}
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  background-color: #fff;
  float: none;
  height: 36px;
  line-height: 36px;
  padding: 0 10px;
  color: #909399;
}
.el-menu--horizontal .el-menu .el-menu-item.is-active,
.el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title {
  color: #303133;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  outline: 0;
  color: #303133;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #409eff;
  color: #303133;
}
.el-menu--collapse {
  width: 64px;
}
.el-menu--collapse > .el-menu-item [class^="el-icon-"],
.el-menu--collapse > .el-submenu > .el-submenu__title [class^="el-icon-"] {
  margin: 0;
  vertical-align: middle;
  width: 24px;
  text-align: center;
}
.el-menu--collapse > .el-menu-item .el-submenu__icon-arrow,
.el-menu--collapse > .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
  display: none;
}
.el-menu--collapse > .el-menu-item span,
.el-menu--collapse > .el-submenu > .el-submenu__title span {
  height: 0;
  width: 0;
  overflow: hidden;
  visibility: hidden;
  display: inline-block;
}
.el-menu--collapse > .el-menu-item.is-active i {
  color: inherit;
}
.el-menu--collapse .el-submenu {
  position: relative;
}
.el-menu--collapse .el-submenu .el-menu {
  position: absolute;
  margin-left: 5px;
  top: 0;
  left: 100%;
  z-index: 10;
  border: 1px solid #e4e7ed;
  border-radius: 2px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.el-menu-item,
.el-submenu__title {
  height: 56px;
  line-height: 56px;
  list-style: none;
  position: relative;
  white-space: nowrap;
}
.el-menu--collapse
  .el-submenu.is-opened
  > .el-submenu__title
  .el-submenu__icon-arrow {
  -webkit-transform: none;
  transform: none;
}
.el-menu--popup {
  z-index: 100;
  border: none;
  padding: 5px 0;
  border-radius: 2px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.el-menu--popup-bottom-start {
  margin-top: 5px;
}
.el-menu--popup-right-start {
  margin-left: 5px;
  margin-right: 5px;
}
.el-menu-item {
  font-size: 14px;
  color: #303133;
  padding: 0 20px;
  cursor: pointer;
  -webkit-transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-menu-item * {
  vertical-align: middle;
}
.el-menu-item i {
  color: #909399;
}
.el-menu-item:focus,
.el-menu-item:hover {
  outline: 0;
  background-color: #ecf5ff;
}
.el-menu-item.is-disabled {
  opacity: 0.25;
  cursor: not-allowed;
  background: 0 0 !important;
}
.el-menu-item [class^="el-icon-"] {
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}
.el-menu-item.is-active {
  color: #409eff;
}
.el-menu-item.is-active i {
  color: inherit;
}
.el-submenu {
  list-style: none;
  margin: 0;
  padding-left: 0;
}
.el-submenu__title {
  font-size: 14px;
  color: #303133;
  padding: 0 20px;
  cursor: pointer;
  -webkit-transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-submenu__title * {
  vertical-align: middle;
}
.el-submenu__title i {
  color: #909399;
}
.el-submenu__title:focus,
.el-submenu__title:hover {
  outline: 0;
  background-color: #ecf5ff;
}
.el-submenu__title.is-disabled {
  opacity: 0.25;
  cursor: not-allowed;
  background: 0 0 !important;
}
.el-submenu__title:hover {
  background-color: #ecf5ff;
}
.el-submenu .el-menu {
  border: none;
}
.el-submenu .el-menu-item {
  height: 50px;
  line-height: 50px;
  padding: 0 45px;
  min-width: 200px;
}
.el-submenu__icon-arrow {
  position: absolute;
  top: 50%;
  right: 20px;
  margin-top: -7px;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  font-size: 12px;
}
.el-submenu.is-active .el-submenu__title {
  border-bottom-color: #409eff;
}
.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.el-submenu.is-disabled .el-menu-item,
.el-submenu.is-disabled .el-submenu__title {
  opacity: 0.25;
  cursor: not-allowed;
  background: 0 0 !important;
}
.el-submenu [class^="el-icon-"] {
  vertical-align: middle;
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
}
.el-menu-item-group > ul {
  padding: 0;
}
.el-menu-item-group__title {
  padding: 7px 0 7px 20px;
  line-height: normal;
  font-size: 12px;
  color: #909399;
}
.horizontal-collapse-transition .el-submenu__title .el-submenu__icon-arrow {
  -webkit-transition: 0.2s;
  transition: 0.2s;
  opacity: 0;
}
.el-button-group > .el-button.is-active,
.el-button-group > .el-button.is-disabled,
.el-button-group > .el-button:active,
.el-button-group > .el-button:focus,
.el-button-group > .el-button:hover {
  z-index: 1;
}
.el-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
}
.el-button + .el-button {
  margin-left: 10px;
}
.el-button:focus,
.el-button:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.el-button:active {
  color: #3a8ee6;
  border-color: #3a8ee6;
  outline: 0;
}
.el-button::-moz-focus-inner {
  border: 0;
}
.el-button [class*="el-icon-"] + span {
  margin-left: 5px;
}
.el-button.is-plain:focus,
.el-button.is-plain:hover {
  background: #fff;
  border-color: #409eff;
  color: #409eff;
}
.el-button.is-active,
.el-button.is-plain:active {
  color: #3a8ee6;
  border-color: #3a8ee6;
}
.el-button.is-plain:active {
  background: #fff;
  outline: 0;
}
.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border-color: #ebeef5;
}
.el-button.is-disabled.el-button--text {
  background-color: transparent;
}
.el-button.is-disabled.is-plain,
.el-button.is-disabled.is-plain:focus,
.el-button.is-disabled.is-plain:hover {
  background-color: #fff;
  border-color: #ebeef5;
  color: #c0c4cc;
}
.el-button.is-loading {
  position: relative;
  pointer-events: none;
}
.el-button.is-loading:before {
  pointer-events: none;
  content: "";
  position: absolute;
  left: -1px;
  top: -1px;
  right: -1px;
  bottom: -1px;
  border-radius: inherit;
  background-color: hsla(0, 0%, 100%, 0.35);
}
.el-button.is-round {
  border-radius: 20px;
  padding: 12px 23px;
}
.el-button.is-circle {
  border-radius: 50%;
  padding: 12px;
}
.el-button--primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
.el-button--primary:focus,
.el-button--primary:hover {
  background: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}
.el-button--primary.is-active,
.el-button--primary:active {
  background: #3a8ee6;
  border-color: #3a8ee6;
  color: #fff;
}
.el-button--primary:active {
  outline: 0;
}
.el-button--primary.is-disabled,
.el-button--primary.is-disabled:active,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:hover {
  color: #fff;
  background-color: #a0cfff;
  border-color: #a0cfff;
}
.el-button--primary.is-plain {
  color: #409eff;
  background: #ecf5ff;
  border-color: #b3d8ff;
}
.el-button--primary.is-plain:focus,
.el-button--primary.is-plain:hover {
  background: #409eff;
  border-color: #409eff;
  color: #fff;
}
.el-button--primary.is-plain:active {
  background: #3a8ee6;
  border-color: #3a8ee6;
  color: #fff;
  outline: 0;
}
.el-button--primary.is-plain.is-disabled,
.el-button--primary.is-plain.is-disabled:active,
.el-button--primary.is-plain.is-disabled:focus,
.el-button--primary.is-plain.is-disabled:hover {
  color: #8cc5ff;
  background-color: #ecf5ff;
  border-color: #d9ecff;
}
.el-button--success {
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
}
.el-button--success:focus,
.el-button--success:hover {
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}
.el-button--success.is-active,
.el-button--success:active {
  background: #5daf34;
  border-color: #5daf34;
  color: #fff;
}
.el-button--success:active {
  outline: 0;
}
.el-button--success.is-disabled,
.el-button--success.is-disabled:active,
.el-button--success.is-disabled:focus,
.el-button--success.is-disabled:hover {
  color: #fff;
  background-color: #b3e19d;
  border-color: #b3e19d;
}
.el-button--success.is-plain {
  color: #67c23a;
  background: #f0f9eb;
  border-color: #c2e7b0;
}
.el-button--success.is-plain:focus,
.el-button--success.is-plain:hover {
  background: #67c23a;
  border-color: #67c23a;
  color: #fff;
}
.el-button--success.is-plain:active {
  background: #5daf34;
  border-color: #5daf34;
  color: #fff;
  outline: 0;
}
.el-button--success.is-plain.is-disabled,
.el-button--success.is-plain.is-disabled:active,
.el-button--success.is-plain.is-disabled:focus,
.el-button--success.is-plain.is-disabled:hover {
  color: #a4da89;
  background-color: #f0f9eb;
  border-color: #e1f3d8;
}
.el-button--warning {
  color: #fff;
  background-color: #e6a23c;
  border-color: #e6a23c;
}
.el-button--warning:focus,
.el-button--warning:hover {
  background: #ebb563;
  border-color: #ebb563;
  color: #fff;
}
.el-button--warning.is-active,
.el-button--warning:active {
  background: #cf9236;
  border-color: #cf9236;
  color: #fff;
}
.el-button--warning:active {
  outline: 0;
}
.el-button--warning.is-disabled,
.el-button--warning.is-disabled:active,
.el-button--warning.is-disabled:focus,
.el-button--warning.is-disabled:hover {
  color: #fff;
  background-color: #f3d19e;
  border-color: #f3d19e;
}
.el-button--warning.is-plain {
  color: #e6a23c;
  background: #fdf6ec;
  border-color: #f5dab1;
}
.el-button--warning.is-plain:focus,
.el-button--warning.is-plain:hover {
  background: #e6a23c;
  border-color: #e6a23c;
  color: #fff;
}
.el-button--warning.is-plain:active {
  background: #cf9236;
  border-color: #cf9236;
  color: #fff;
  outline: 0;
}
.el-button--warning.is-plain.is-disabled,
.el-button--warning.is-plain.is-disabled:active,
.el-button--warning.is-plain.is-disabled:focus,
.el-button--warning.is-plain.is-disabled:hover {
  color: #f0c78a;
  background-color: #fdf6ec;
  border-color: #faecd8;
}
.el-button--danger {
  color: #fff;
  background-color: #f56c6c;
  border-color: #f56c6c;
}
.el-button--danger:focus,
.el-button--danger:hover {
  background: #f78989;
  border-color: #f78989;
  color: #fff;
}
.el-button--danger.is-active,
.el-button--danger:active {
  background: #dd6161;
  border-color: #dd6161;
  color: #fff;
}
.el-button--danger:active {
  outline: 0;
}
.el-button--danger.is-disabled,
.el-button--danger.is-disabled:active,
.el-button--danger.is-disabled:focus,
.el-button--danger.is-disabled:hover {
  color: #fff;
  background-color: #fab6b6;
  border-color: #fab6b6;
}
.el-button--danger.is-plain {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}
.el-button--danger.is-plain:focus,
.el-button--danger.is-plain:hover {
  background: #f56c6c;
  border-color: #f56c6c;
  color: #fff;
}
.el-button--danger.is-plain:active {
  background: #dd6161;
  border-color: #dd6161;
  color: #fff;
  outline: 0;
}
.el-button--danger.is-plain.is-disabled,
.el-button--danger.is-plain.is-disabled:active,
.el-button--danger.is-plain.is-disabled:focus,
.el-button--danger.is-plain.is-disabled:hover {
  color: #f9a7a7;
  background-color: #fef0f0;
  border-color: #fde2e2;
}
.el-button--info {
  color: #fff;
  background-color: #909399;
  border-color: #909399;
}
.el-button--info:focus,
.el-button--info:hover {
  background: #a6a9ad;
  border-color: #a6a9ad;
  color: #fff;
}
.el-button--info.is-active,
.el-button--info:active {
  background: #82848a;
  border-color: #82848a;
  color: #fff;
}
.el-button--info:active {
  outline: 0;
}
.el-button--info.is-disabled,
.el-button--info.is-disabled:active,
.el-button--info.is-disabled:focus,
.el-button--info.is-disabled:hover {
  color: #fff;
  background-color: #c8c9cc;
  border-color: #c8c9cc;
}
.el-button--info.is-plain {
  color: #909399;
  background: #f4f4f5;
  border-color: #d3d4d6;
}
.el-button--info.is-plain:focus,
.el-button--info.is-plain:hover {
  background: #909399;
  border-color: #909399;
  color: #fff;
}
.el-button--info.is-plain:active {
  background: #82848a;
  border-color: #82848a;
  color: #fff;
  outline: 0;
}
.el-button--info.is-plain.is-disabled,
.el-button--info.is-plain.is-disabled:active,
.el-button--info.is-plain.is-disabled:focus,
.el-button--info.is-plain.is-disabled:hover {
  color: #bcbec2;
  background-color: #f4f4f5;
  border-color: #e9e9eb;
}
.el-button--text,
.el-button--text.is-disabled,
.el-button--text.is-disabled:focus,
.el-button--text.is-disabled:hover,
.el-button--text:active {
  border-color: transparent;
}
.el-button--medium {
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 4px;
}
.el-button--mini,
.el-button--small {
  font-size: 12px;
  border-radius: 3px;
}
.el-button--medium.is-round {
  padding: 10px 20px;
}
.el-button--medium.is-circle {
  padding: 10px;
}
.el-button--small,
.el-button--small.is-round {
  padding: 9px 15px;
}
.el-button--small.is-circle {
  padding: 9px;
}
.el-button--mini,
.el-button--mini.is-round {
  padding: 7px 15px;
}
.el-button--mini.is-circle {
  padding: 7px;
}
.el-button--text {
  color: #409eff;
  background: 0 0;
  padding-left: 0;
  padding-right: 0;
}
.el-button--text:focus,
.el-button--text:hover {
  color: #66b1ff;
  border-color: transparent;
  background-color: transparent;
}
.el-button--text:active {
  color: #3a8ee6;
  background-color: transparent;
}
.el-button-group {
  display: inline-block;
  vertical-align: middle;
}
.el-button-group:after,
.el-button-group:before {
  display: table;
  content: "";
}
.el-button-group:after {
  clear: both;
}
.el-button-group > .el-button {
  float: left;
  position: relative;
}
.el-button-group > .el-button + .el-button {
  margin-left: 0;
}
.el-button-group > .el-button:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.el-button-group > .el-button:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.el-button-group > .el-button:first-child:last-child {
  border-radius: 4px;
}
.el-button-group > .el-button:first-child:last-child.is-round {
  border-radius: 20px;
}
.el-button-group > .el-button:first-child:last-child.is-circle {
  border-radius: 50%;
}
.el-button-group > .el-button:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.el-button-group > .el-button:not(:last-child) {
  margin-right: -1px;
}
.el-button-group > .el-dropdown > .el-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left-color: hsla(0, 0%, 100%, 0.5);
}
.el-button-group .el-button--primary:first-child {
  border-right-color: hsla(0, 0%, 100%, 0.5);
}
.el-button-group .el-button--primary:last-child {
  border-left-color: hsla(0, 0%, 100%, 0.5);
}
.el-button-group .el-button--primary:not(:first-child):not(:last-child) {
  border-left-color: hsla(0, 0%, 100%, 0.5);
  border-right-color: hsla(0, 0%, 100%, 0.5);
}
.el-button-group .el-button--success:first-child {
  border-right-color: hsla(0, 0%, 100%, 0.5);
}
.el-button-group .el-button--success:last-child {
  border-left-color: hsla(0, 0%, 100%, 0.5);
}
.el-button-group .el-button--success:not(:first-child):not(:last-child) {
  border-left-color: hsla(0, 0%, 100%, 0.5);
  border-right-color: hsla(0, 0%, 100%, 0.5);
}
.el-button-group .el-button--warning:first-child {
  border-right-color: hsla(0, 0%, 100%, 0.5);
}
.el-button-group .el-button--warning:last-child {
  border-left-color: hsla(0, 0%, 100%, 0.5);
}
.el-button-group .el-button--warning:not(:first-child):not(:last-child) {
  border-left-color: hsla(0, 0%, 100%, 0.5);
  border-right-color: hsla(0, 0%, 100%, 0.5);
}
.el-button-group .el-button--danger:first-child {
  border-right-color: hsla(0, 0%, 100%, 0.5);
}
.el-button-group .el-button--danger:last-child {
  border-left-color: hsla(0, 0%, 100%, 0.5);
}
.el-button-group .el-button--danger:not(:first-child):not(:last-child) {
  border-left-color: hsla(0, 0%, 100%, 0.5);
  border-right-color: hsla(0, 0%, 100%, 0.5);
}
.el-button-group .el-button--info:first-child {
  border-right-color: hsla(0, 0%, 100%, 0.5);
}
.el-button-group .el-button--info:last-child {
  border-left-color: hsla(0, 0%, 100%, 0.5);
}
.el-button-group .el-button--info:not(:first-child):not(:last-child) {
  border-left-color: hsla(0, 0%, 100%, 0.5);
  border-right-color: hsla(0, 0%, 100%, 0.5);
}
.el-dropdown {
  display: inline-block;
  position: relative;
  color: #606266;
  font-size: 14px;
}
.el-dropdown .el-button-group {
  display: block;
}
.el-dropdown .el-button-group .el-button {
  float: none;
}
.el-dropdown .el-dropdown__caret-button {
  padding-left: 5px;
  padding-right: 5px;
  position: relative;
  border-left: none;
}
.el-dropdown .el-dropdown__caret-button:before {
  content: "";
  position: absolute;
  display: block;
  width: 1px;
  top: 5px;
  bottom: 5px;
  left: 0;
  background: hsla(0, 0%, 100%, 0.5);
}
.el-dropdown .el-dropdown__caret-button.el-button--default:before {
  background: rgba(220, 223, 230, 0.5);
}
.el-dropdown .el-dropdown__caret-button:hover:before {
  top: 0;
  bottom: 0;
}
.el-dropdown .el-dropdown__caret-button .el-dropdown__icon {
  padding-left: 0;
}
.el-dropdown__icon {
  font-size: 12px;
  margin: 0 3px;
}
.el-dropdown .el-dropdown-selfdefine:focus:active,
.el-dropdown .el-dropdown-selfdefine:focus:not(.focusing) {
  outline-width: 0;
}
.el-dropdown-menu {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  padding: 10px 0;
  margin: 5px 0;
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.el-dropdown-menu__item {
  list-style: none;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  outline: 0;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #ecf5ff;
  color: #66b1ff;
}
.el-dropdown-menu__item i {
  margin-right: 5px;
}
.el-dropdown-menu__item--divided {
  position: relative;
  margin-top: 6px;
  border-top: 1px solid #ebeef5;
}
.el-dropdown-menu__item--divided:before {
  content: "";
  height: 6px;
  display: block;
  margin: 0 -20px;
  background-color: #fff;
}
.el-dropdown-menu__item.is-disabled {
  cursor: default;
  color: #bbb;
  pointer-events: none;
}
.el-dropdown-menu--medium {
  padding: 6px 0;
}
.el-dropdown-menu--medium .el-dropdown-menu__item {
  line-height: 30px;
  padding: 0 17px;
  font-size: 14px;
}
.el-dropdown-menu--medium
  .el-dropdown-menu__item.el-dropdown-menu__item--divided {
  margin-top: 6px;
}
.el-dropdown-menu--medium
  .el-dropdown-menu__item.el-dropdown-menu__item--divided:before {
  height: 6px;
  margin: 0 -17px;
}
.el-dropdown-menu--small {
  padding: 6px 0;
}
.el-dropdown-menu--small .el-dropdown-menu__item {
  line-height: 27px;
  padding: 0 15px;
  font-size: 13px;
}
.el-dropdown-menu--small
  .el-dropdown-menu__item.el-dropdown-menu__item--divided {
  margin-top: 4px;
}
.el-dropdown-menu--small
  .el-dropdown-menu__item.el-dropdown-menu__item--divided:before {
  height: 4px;
  margin: 0 -15px;
}
.el-dropdown-menu--mini {
  padding: 3px 0;
}
.el-dropdown-menu--mini .el-dropdown-menu__item {
  line-height: 24px;
  padding: 0 10px;
  font-size: 12px;
}
.el-dropdown-menu--mini
  .el-dropdown-menu__item.el-dropdown-menu__item--divided {
  margin-top: 3px;
}
.el-dropdown-menu--mini
  .el-dropdown-menu__item.el-dropdown-menu__item--divided:before {
  height: 3px;
  margin: 0 -10px;
}
.el-autocomplete {
  position: relative;
  display: inline-block;
}
.el-autocomplete-suggestion {
  margin: 5px 0;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #fff;
}
.el-autocomplete-suggestion__wrap {
  max-height: 280px;
  padding: 10px 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-autocomplete-suggestion__list {
  margin: 0;
  padding: 0;
}
.el-autocomplete-suggestion li {
  padding: 0 20px;
  margin: 0;
  line-height: 34px;
  cursor: pointer;
  color: #606266;
  font-size: 14px;
  list-style: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-autocomplete-suggestion li.highlighted,
.el-autocomplete-suggestion li:hover {
  background-color: #f5f7fa;
}
.el-autocomplete-suggestion li.divider {
  margin-top: 6px;
  border-top: 1px solid #000;
}
.el-autocomplete-suggestion li.divider:last-child {
  margin-bottom: -6px;
}
.el-autocomplete-suggestion.is-loading li {
  text-align: center;
  height: 100px;
  line-height: 100px;
  font-size: 20px;
  color: #999;
}
.el-autocomplete-suggestion.is-loading li:after {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}
.el-autocomplete-suggestion.is-loading li:hover {
  background-color: #fff;
}
.el-autocomplete-suggestion.is-loading .el-icon-loading {
  vertical-align: middle;
}
.v-modal-enter {
  -webkit-animation: v-modal-in 0.2s ease;
  animation: v-modal-in 0.2s ease;
}
.v-modal-leave {
  -webkit-animation: v-modal-out 0.2s ease forwards;
  animation: v-modal-out 0.2s ease forwards;
}
@-webkit-keyframes v-modal-in {
  0% {
    opacity: 0;
  }
}
@keyframes v-modal-in {
  0% {
    opacity: 0;
  }
}
@-webkit-keyframes v-modal-out {
  to {
    opacity: 0;
  }
}
@keyframes v-modal-out {
  to {
    opacity: 0;
  }
}
.v-modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
}
.el-popup-parent--hidden {
  overflow: hidden;
}
.el-dialog {
  position: relative;
  margin: 0 auto 50px;
  background: #fff;
  border-radius: 2px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 50%;
}
.el-dialog.is-fullscreen {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
  height: 100%;
  overflow: auto;
}
.el-dialog__wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}
.el-dialog__header {
  padding: 20px 20px 10px;
}
.el-dialog__headerbtn {
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
}
.el-dialog__headerbtn .el-dialog__close {
  color: #909399;
}
.el-dialog__headerbtn:focus .el-dialog__close,
.el-dialog__headerbtn:hover .el-dialog__close {
  color: #409eff;
}
.el-dialog__title {
  line-height: 24px;
  font-size: 18px;
  color: #303133;
}
.el-dialog__body {
  padding: 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.el-dialog__footer {
  padding: 10px 20px 20px;
  text-align: right;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-dialog--center {
  text-align: center;
}
.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 25px 25px 30px;
}
.el-dialog--center .el-dialog__footer {
  text-align: inherit;
}
.dialog-fade-enter-active {
  -webkit-animation: dialog-fade-in 0.3s;
  animation: dialog-fade-in 0.3s;
}
.dialog-fade-leave-active {
  -webkit-animation: dialog-fade-out 0.3s;
  animation: dialog-fade-out 0.3s;
}
@-webkit-keyframes dialog-fade-in {
  0% {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}
@keyframes dialog-fade-in {
  0% {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  to {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}
@-webkit-keyframes dialog-fade-out {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
  to {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}
@keyframes dialog-fade-out {
  0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
  to {
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}
.el-popper .popper__arrow,
.el-popper .popper__arrow:after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.el-popper .popper__arrow {
  border-width: 6px;
  -webkit-filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
  filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
}
.el-popper .popper__arrow:after {
  content: " ";
  border-width: 6px;
}
.el-popper[x-placement^="top"] {
  margin-bottom: 12px;
}
.el-popper[x-placement^="top"] .popper__arrow {
  bottom: -6px;
  left: 50%;
  margin-right: 3px;
  border-top-color: #ebeef5;
  border-bottom-width: 0;
}
.el-popper[x-placement^="top"] .popper__arrow:after {
  bottom: 1px;
  margin-left: -6px;
  border-top-color: #fff;
  border-bottom-width: 0;
}
.el-popper[x-placement^="bottom"] {
  margin-top: 12px;
}
.el-popper[x-placement^="bottom"] .popper__arrow {
  top: -6px;
  left: 50%;
  margin-right: 3px;
  border-top-width: 0;
  border-bottom-color: #ebeef5;
}
.el-popper[x-placement^="bottom"] .popper__arrow:after {
  top: 1px;
  margin-left: -6px;
  border-top-width: 0;
  border-bottom-color: #fff;
}
.el-popper[x-placement^="right"] {
  margin-left: 12px;
}
.el-popper[x-placement^="right"] .popper__arrow {
  top: 50%;
  left: -6px;
  margin-bottom: 3px;
  border-right-color: #ebeef5;
  border-left-width: 0;
}
.el-popper[x-placement^="right"] .popper__arrow:after {
  bottom: -6px;
  left: 1px;
  border-right-color: #fff;
  border-left-width: 0;
}
.el-popper[x-placement^="left"] {
  margin-right: 12px;
}
.el-popper[x-placement^="left"] .popper__arrow {
  top: 50%;
  right: -6px;
  margin-bottom: 3px;
  border-right-width: 0;
  border-left-color: #ebeef5;
}
.el-popper[x-placement^="left"] .popper__arrow:after {
  right: 1px;
  bottom: -6px;
  margin-left: -6px;
  border-right-width: 0;
  border-left-color: #fff;
}
.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fff;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 5px 0;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: #409eff;
  background-color: #fff;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover {
  background-color: #f5f7fa;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected:after {
  position: absolute;
  right: 20px;
  font-family: element-icons;
  content: "\e6da";
  font-size: 12px;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-select-dropdown .el-scrollbar.is-empty .el-select-dropdown__list {
  padding: 0;
}
.el-select-dropdown__empty {
  padding: 10px 0;
  margin: 0;
  text-align: center;
  color: #999;
  font-size: 14px;
}
.el-select-dropdown__wrap {
  max-height: 274px;
}
.el-select-dropdown__list {
  list-style: none;
  padding: 6px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-textarea {
  position: relative;
  display: inline-block;
  width: 100%;
  vertical-align: bottom;
  font-size: 14px;
}
.el-textarea__inner {
  display: block;
  resize: vertical;
  padding: 5px 15px;
  line-height: 1.5;
  box-sizing: border-box;
  width: 100%;
  font-size: inherit;
  color: #606266;
  background-color: #fff;
  background-image: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.el-input__inner,
.el-tag,
.el-textarea__inner {
  -webkit-box-sizing: border-box;
}
.el-textarea__inner::-webkit-input-placeholder {
  color: #c0c4cc;
}
.el-textarea__inner:-ms-input-placeholder {
  color: #c0c4cc;
}
.el-textarea__inner::-ms-input-placeholder {
  color: #c0c4cc;
}
.el-textarea__inner::-moz-placeholder {
  color: #c0c4cc;
}
.el-textarea__inner::placeholder {
  color: #c0c4cc;
}
.el-textarea__inner:hover {
  border-color: #c0c4cc;
}
.el-textarea__inner:focus {
  outline: 0;
  border-color: #409eff;
}
.el-textarea .el-input__count {
  color: #909399;
  background: #fff;
  position: absolute;
  font-size: 12px;
  bottom: 5px;
  right: 10px;
}
.el-textarea.is-disabled .el-textarea__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}
.el-textarea.is-disabled .el-textarea__inner::-webkit-input-placeholder {
  color: #c0c4cc;
}
.el-textarea.is-disabled .el-textarea__inner:-ms-input-placeholder {
  color: #c0c4cc;
}
.el-textarea.is-disabled .el-textarea__inner::-ms-input-placeholder {
  color: #c0c4cc;
}
.el-textarea.is-disabled .el-textarea__inner::-moz-placeholder {
  color: #c0c4cc;
}
.el-textarea.is-disabled .el-textarea__inner::placeholder {
  color: #c0c4cc;
}
.el-textarea.is-exceed .el-textarea__inner {
  border-color: #f56c6c;
}
.el-textarea.is-exceed .el-input__count {
  color: #f56c6c;
}
.el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 100%;
}
.el-input::-webkit-scrollbar {
  z-index: 11;
  width: 6px;
}
.el-input::-webkit-scrollbar:horizontal {
  height: 6px;
}
.el-input::-webkit-scrollbar-thumb {
  border-radius: 5px;
  width: 6px;
  background: #b4bccc;
}
.el-input::-webkit-scrollbar-corner,
.el-input::-webkit-scrollbar-track {
  background: #fff;
}
.el-input::-webkit-scrollbar-track-piece {
  background: #fff;
  width: 6px;
}
.el-input .el-input__clear {
  color: #c0c4cc;
  font-size: 14px;
  cursor: pointer;
  -webkit-transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.el-input .el-input__clear:hover {
  color: #909399;
}
.el-input .el-input__count {
  height: 100%;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #909399;
  font-size: 12px;
}
.el-input .el-input__count .el-input__count-inner {
  background: #fff;
  line-height: normal;
  display: inline-block;
  padding: 0 5px;
}
.el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 0px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
.el-input__prefix,
.el-input__suffix {
  position: absolute;
  top: 0;
  -webkit-transition: all 0.3s;
  height: 100%;
  color: #c0c4cc;
  text-align: center;
}
.el-input__inner::-ms-reveal {
  display: none;
}
.el-input__inner::-webkit-input-placeholder {
  color: #c0c4cc;
}
.el-input__inner:-ms-input-placeholder {
  color: #c0c4cc;
}
.el-input__inner::-ms-input-placeholder {
  color: #c0c4cc;
}
.el-input__inner::-moz-placeholder {
  color: #c0c4cc;
}
.el-input__inner::placeholder {
  color: #c0c4cc;
}
.el-input__inner:hover {
  border-color: #c0c4cc;
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #409eff;
  outline: 0;
}
.el-input__suffix {
  right: 5px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  pointer-events: none;
}
.el-input__suffix-inner {
  pointer-events: all;
}
.el-input__prefix {
  left: 5px;
}
.el-input__icon,
.el-input__prefix {
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
.el-input__icon {
  height: 100%;
  width: 25px;
  text-align: center;
  line-height: 40px;
}
.el-input__icon:after {
  content: "";
  height: 100%;
  width: 0;
  display: inline-block;
  vertical-align: middle;
}
.el-input__validateIcon {
  pointer-events: none;
}
.el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}
.el-input.is-disabled .el-input__inner::-webkit-input-placeholder {
  color: #c0c4cc;
}
.el-input.is-disabled .el-input__inner:-ms-input-placeholder {
  color: #c0c4cc;
}
.el-input.is-disabled .el-input__inner::-ms-input-placeholder {
  color: #c0c4cc;
}
.el-input.is-disabled .el-input__inner::-moz-placeholder {
  color: #c0c4cc;
}
.el-input.is-disabled .el-input__inner::placeholder {
  color: #c0c4cc;
}
.el-input.is-disabled .el-input__icon {
  cursor: not-allowed;
}
.el-input.is-exceed .el-input__inner {
  border-color: #f56c6c;
}
.el-input.is-exceed .el-input__suffix .el-input__count {
  color: #f56c6c;
}
.el-input--suffix .el-input__inner {
  padding-right: 30px;
}
.el-input--prefix .el-input__inner {
  padding-left: 30px;
}
.el-input--medium {
  font-size: 14px;
}
.el-input--medium .el-input__inner {
  height: 36px;
  line-height: 36px;
}
.el-input--medium .el-input__icon {
  line-height: 36px;
}
.el-input--small {
  font-size: 13px;
}
.el-input--small .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.el-input--small .el-input__icon {
  line-height: 32px;
}
.el-input--mini {
  font-size: 12px;
}
.el-input--mini .el-input__inner {
  height: 28px;
  line-height: 28px;
}
.el-input--mini .el-input__icon {
  line-height: 28px;
}
.el-input-group {
  line-height: normal;
  display: inline-table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.el-input-group > .el-input__inner {
  vertical-align: middle;
  display: table-cell;
}
.el-input-group__append,
.el-input-group__prepend {
  background-color: #f5f7fa;
  color: #909399;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 20px;
  width: 1px;
  white-space: nowrap;
}
.el-input-group--prepend .el-input__inner,
.el-input-group__append {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.el-input-group--append .el-input__inner,
.el-input-group__prepend {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.el-input-group__append:focus,
.el-input-group__prepend:focus {
  outline: 0;
}
.el-input-group__append .el-button,
.el-input-group__append .el-select,
.el-input-group__prepend .el-button,
.el-input-group__prepend .el-select {
  display: inline-block;
  margin: -10px -20px;
}
.el-input-group__append button.el-button,
.el-input-group__append div.el-select .el-input__inner,
.el-input-group__append div.el-select:hover .el-input__inner,
.el-input-group__prepend button.el-button,
.el-input-group__prepend div.el-select .el-input__inner,
.el-input-group__prepend div.el-select:hover .el-input__inner {
  border-color: transparent;
  background-color: transparent;
  color: inherit;
  border-top: 0;
  border-bottom: 0;
}
.el-input-group__append .el-button,
.el-input-group__append .el-input,
.el-input-group__prepend .el-button,
.el-input-group__prepend .el-input {
  font-size: inherit;
}
.el-input-group__prepend {
  border-right: 0;
}
.el-input-group__append {
  border-left: 0;
}
.el-input-group--append .el-select .el-input.is-focus .el-input__inner,
.el-input-group--prepend .el-select .el-input.is-focus .el-input__inner {
  border-color: transparent;
}
.el-input__inner::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}
.el-tag {
  background-color: #ecf5ff;
  border-color: #d9ecff;
  display: inline-block;
  height: 32px;
  padding: 0 10px;
  line-height: 30px;
  font-size: 12px;
  color: #409eff;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
}
.el-tag.is-hit {
  border-color: #409eff;
}
.el-tag .el-tag__close {
  color: #409eff;
}
.el-tag .el-tag__close:hover {
  color: #fff;
  background-color: #409eff;
}
.el-tag.el-tag--info {
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #909399;
}
.el-tag.el-tag--info.is-hit {
  border-color: #909399;
}
.el-tag.el-tag--info .el-tag__close {
  color: #909399;
}
.el-tag.el-tag--info .el-tag__close:hover {
  color: #fff;
  background-color: #909399;
}
.el-tag.el-tag--success {
  background-color: #f0f9eb;
  border-color: #e1f3d8;
  color: #67c23a;
}
.el-tag.el-tag--success.is-hit {
  border-color: #67c23a;
}
.el-tag.el-tag--success .el-tag__close {
  color: #67c23a;
}
.el-tag.el-tag--success .el-tag__close:hover {
  color: #fff;
  background-color: #67c23a;
}
.el-tag.el-tag--warning {
  background-color: #fdf6ec;
  border-color: #faecd8;
  color: #e6a23c;
}
.el-tag.el-tag--warning.is-hit {
  border-color: #e6a23c;
}
.el-tag.el-tag--warning .el-tag__close {
  color: #e6a23c;
}
.el-tag.el-tag--warning .el-tag__close:hover {
  color: #fff;
  background-color: #e6a23c;
}
.el-tag.el-tag--danger {
  background-color: #fef0f0;
  border-color: #fde2e2;
  color: #f56c6c;
}
.el-tag.el-tag--danger.is-hit {
  border-color: #f56c6c;
}
.el-tag.el-tag--danger .el-tag__close {
  color: #f56c6c;
}
.el-tag.el-tag--danger .el-tag__close:hover {
  color: #fff;
  background-color: #f56c6c;
}
.el-tag .el-icon-close {
  border-radius: 50%;
  text-align: center;
  position: relative;
  cursor: pointer;
  font-size: 12px;
  height: 16px;
  width: 16px;
  line-height: 16px;
  vertical-align: middle;
  top: -1px;
  right: -5px;
}
.el-tag .el-icon-close:before {
  display: block;
}
.el-tag--dark {
  background-color: #409eff;
  color: #fff;
}
.el-tag--dark,
.el-tag--dark.is-hit {
  border-color: #409eff;
}
.el-tag--dark .el-tag__close {
  color: #fff;
}
.el-tag--dark .el-tag__close:hover {
  color: #fff;
  background-color: #66b1ff;
}
.el-tag--dark.el-tag--info {
  background-color: #909399;
  border-color: #909399;
  color: #fff;
}
.el-tag--dark.el-tag--info.is-hit {
  border-color: #909399;
}
.el-tag--dark.el-tag--info .el-tag__close {
  color: #fff;
}
.el-tag--dark.el-tag--info .el-tag__close:hover {
  color: #fff;
  background-color: #a6a9ad;
}
.el-tag--dark.el-tag--success {
  background-color: #67c23a;
  border-color: #67c23a;
  color: #fff;
}
.el-tag--dark.el-tag--success.is-hit {
  border-color: #67c23a;
}
.el-tag--dark.el-tag--success .el-tag__close {
  color: #fff;
}
.el-tag--dark.el-tag--success .el-tag__close:hover {
  color: #fff;
  background-color: #85ce61;
}
.el-tag--dark.el-tag--warning {
  background-color: #e6a23c;
  border-color: #e6a23c;
  color: #fff;
}
.el-tag--dark.el-tag--warning.is-hit {
  border-color: #e6a23c;
}
.el-tag--dark.el-tag--warning .el-tag__close {
  color: #fff;
}
.el-tag--dark.el-tag--warning .el-tag__close:hover {
  color: #fff;
  background-color: #ebb563;
}
.el-tag--dark.el-tag--danger {
  background-color: #f56c6c;
  border-color: #f56c6c;
  color: #fff;
}
.el-tag--dark.el-tag--danger.is-hit {
  border-color: #f56c6c;
}
.el-tag--dark.el-tag--danger .el-tag__close {
  color: #fff;
}
.el-tag--dark.el-tag--danger .el-tag__close:hover {
  color: #fff;
  background-color: #f78989;
}
.el-tag--plain {
  background-color: #fff;
  border-color: #b3d8ff;
  color: #409eff;
}
.el-tag--plain.is-hit {
  border-color: #409eff;
}
.el-tag--plain .el-tag__close {
  color: #409eff;
}
.el-tag--plain .el-tag__close:hover {
  color: #fff;
  background-color: #409eff;
}
.el-tag--plain.el-tag--info {
  background-color: #fff;
  border-color: #d3d4d6;
  color: #909399;
}
.el-tag--plain.el-tag--info.is-hit {
  border-color: #909399;
}
.el-tag--plain.el-tag--info .el-tag__close {
  color: #909399;
}
.el-tag--plain.el-tag--info .el-tag__close:hover {
  color: #fff;
  background-color: #909399;
}
.el-tag--plain.el-tag--success {
  background-color: #fff;
  border-color: #c2e7b0;
  color: #67c23a;
}
.el-tag--plain.el-tag--success.is-hit {
  border-color: #67c23a;
}
.el-tag--plain.el-tag--success .el-tag__close {
  color: #67c23a;
}
.el-tag--plain.el-tag--success .el-tag__close:hover {
  color: #fff;
  background-color: #67c23a;
}
.el-tag--plain.el-tag--warning {
  background-color: #fff;
  border-color: #f5dab1;
  color: #e6a23c;
}
.el-tag--plain.el-tag--warning.is-hit {
  border-color: #e6a23c;
}
.el-tag--plain.el-tag--warning .el-tag__close {
  color: #e6a23c;
}
.el-tag--plain.el-tag--warning .el-tag__close:hover {
  color: #fff;
  background-color: #e6a23c;
}
.el-tag--plain.el-tag--danger {
  background-color: #fff;
  border-color: #fbc4c4;
  color: #f56c6c;
}
.el-tag--plain.el-tag--danger.is-hit {
  border-color: #f56c6c;
}
.el-tag--plain.el-tag--danger .el-tag__close {
  color: #f56c6c;
}
.el-tag--plain.el-tag--danger .el-tag__close:hover {
  color: #fff;
  background-color: #f56c6c;
}
.el-tag--medium {
  height: 28px;
  line-height: 26px;
}
.el-tag--medium .el-icon-close {
  -webkit-transform: scale(0.8);
  transform: scale(0.8);
}
.el-tag--small {
  height: 24px;
  padding: 0 8px;
  line-height: 22px;
}
.el-tag--small .el-icon-close {
  -webkit-transform: scale(0.8);
  transform: scale(0.8);
}
.el-tag--mini {
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
}
.el-tag--mini .el-icon-close {
  margin-left: -3px;
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
}
.el-select-dropdown__item {
  font-size: 14px;
  padding: 0 20px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #606266;
  height: 34px;
  line-height: 34px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}
.el-select-dropdown__item.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}
.el-select-dropdown__item.is-disabled:hover {
  background-color: #fff;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #f5f7fa;
}
.el-select-dropdown__item.selected {
  color: #409eff;
  font-weight: 700;
}
.el-select-group {
  margin: 0;
  padding: 0;
}
.el-select-group__wrap {
  position: relative;
  list-style: none;
  margin: 0;
  padding: 0;
}
.el-select-group__wrap:not(:last-of-type) {
  padding-bottom: 24px;
}
.el-select-group__wrap:not(:last-of-type):after {
  content: "";
  position: absolute;
  display: block;
  left: 20px;
  right: 20px;
  bottom: 12px;
  height: 1px;
  background: #e4e7ed;
}
.el-select-group__title {
  padding-left: 20px;
  font-size: 12px;
  color: #909399;
  line-height: 30px;
}
.el-select-group .el-select-dropdown__item {
  padding-left: 20px;
}
.el-scrollbar {
  overflow: hidden;
  position: relative;
}
.el-scrollbar:active > .el-scrollbar__bar,
.el-scrollbar:focus > .el-scrollbar__bar,
.el-scrollbar:hover > .el-scrollbar__bar {
  opacity: 1;
  -webkit-transition: opacity 0.34s ease-out;
  transition: opacity 0.34s ease-out;
}
.el-scrollbar__wrap {
  overflow: scroll;
  height: 100%;
}
.el-scrollbar__wrap--hidden-default {
  scrollbar-width: none;
}
.el-scrollbar__wrap--hidden-default::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.el-scrollbar__thumb {
  position: relative;
  display: block;
  width: 0;
  height: 0;
  cursor: pointer;
  border-radius: inherit;
  background-color: rgba(144, 147, 153, 0.3);
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
.el-scrollbar__thumb:hover {
  background-color: rgba(144, 147, 153, 0.5);
}
.el-scrollbar__bar {
  position: absolute;
  right: 2px;
  bottom: 2px;
  z-index: 1;
  border-radius: 4px;
  opacity: 0;
  -webkit-transition: opacity 0.12s ease-out;
  transition: opacity 0.12s ease-out;
}
.el-scrollbar__bar.is-vertical {
  width: 6px;
  top: 2px;
}
.el-scrollbar__bar.is-vertical > div {
  width: 100%;
}
.el-scrollbar__bar.is-horizontal {
  height: 6px;
  left: 2px;
}
.el-scrollbar__bar.is-horizontal > div {
  height: 100%;
}
.el-select {
  display: inline-block;
  position: relative;
}
.el-select .el-select__tags > span {
  display: contents;
}
.el-select:hover .el-input__inner {
  border-color: #c0c4cc;
}
.el-select .el-input__inner {
  cursor: pointer;
  padding-right: 35px;
}
.el-select .el-input__inner:focus {
  border-color: #409eff;
}
.el-select .el-input .el-select__caret {
  color: #c0c4cc;
  font-size: 14px;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
  cursor: pointer;
}
.el-select .el-input .el-select__caret.is-reverse {
  -webkit-transform: rotate(0);
  transform: rotate(0);
}
.el-select .el-input .el-select__caret.is-show-close {
  font-size: 14px;
  text-align: center;
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
  border-radius: 100%;
  color: #c0c4cc;
  -webkit-transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.el-select .el-input .el-select__caret.is-show-close:hover {
  color: #909399;
}
.el-select .el-input.is-disabled .el-input__inner {
  cursor: not-allowed;
}
.el-select .el-input.is-disabled .el-input__inner:hover {
  border-color: #e4e7ed;
}
.el-select .el-input.is-focus .el-input__inner {
  border-color: #409eff;
}
.el-select > .el-input {
  display: block;
  width: 100px;
}
.el-select__input {
  border: none;
  outline: 0;
  padding: 0;
  margin-left: 15px;
  color: #666;
  font-size: 14px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  height: 28px;
  background-color: transparent;
}
.el-select__input.is-mini {
  height: 14px;
}
.el-select__close {
  cursor: pointer;
  position: absolute;
  top: 8px;
  z-index: 1000;
  right: 25px;
  color: #c0c4cc;
  line-height: 18px;
  font-size: 14px;
}
.el-select__close:hover {
  color: #909399;
}
.el-select__tags {
  position: absolute;
  line-height: normal;
  white-space: normal;
  z-index: 1;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.el-select .el-tag__close {
  margin-top: -2px;
}
.el-select .el-tag {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-color: transparent;
  margin: 2px 0 2px 6px;
  background-color: #f0f2f5;
}
.el-select .el-tag__close.el-icon-close {
  background-color: #c0c4cc;
  right: -7px;
  top: 0;
  color: #fff;
}
.el-select .el-tag__close.el-icon-close:hover {
  background-color: #909399;
}
.el-select .el-tag__close.el-icon-close:before {
  display: block;
  -webkit-transform: translateY(0.5px);
  transform: translateY(0.5px);
}
.el-pagination {
  white-space: nowrap;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
}
.el-pagination:after,
.el-pagination:before {
  display: table;
  content: "";
}
.el-pagination:after {
  clear: both;
}
.el-pagination button,
.el-pagination span:not([class*="suffix"]) {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-pagination .el-input__inner {
  text-align: center;
  -moz-appearance: textfield;
  line-height: normal;
}
.el-pagination .el-input__suffix {
  right: 0;
  -webkit-transform: scale(0.8);
  transform: scale(0.8);
}
.el-pagination .el-select .el-input {
  width: 100px;
  margin: 0 5px;
}
.el-pagination .el-select .el-input .el-input__inner {
  padding-right: 25px;
  border-radius: 3px;
}
.el-pagination button {
  border: none;
  padding: 0 6px;
  background: 0 0;
}
.el-pagination button:focus {
  outline: 0;
}
.el-pagination button:hover {
  color: #409eff;
}
.el-pagination button:disabled {
  color: #c0c4cc;
  background-color: #fff;
  cursor: not-allowed;
}
.el-pagination .btn-next,
.el-pagination .btn-prev {
  background: 50% no-repeat #fff;
  background-size: 16px;
  cursor: pointer;
  margin: 0;
  color: #303133;
}
.el-pagination .btn-next .el-icon,
.el-pagination .btn-prev .el-icon {
  display: block;
  font-size: 12px;
  font-weight: 700;
}
.el-pagination .btn-prev {
  padding-right: 12px;
}
.el-pagination .btn-next {
  padding-left: 12px;
}
.el-pagination .el-pager li.disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}
.el-pager li,
.el-pager li.btn-quicknext:hover,
.el-pager li.btn-quickprev:hover {
  cursor: pointer;
}
.el-pagination--small .btn-next,
.el-pagination--small .btn-prev,
.el-pagination--small .el-pager li,
.el-pagination--small .el-pager li.btn-quicknext,
.el-pagination--small .el-pager li.btn-quickprev,
.el-pagination--small .el-pager li:last-child {
  border-color: transparent;
  font-size: 12px;
  line-height: 22px;
  height: 22px;
  min-width: 22px;
}
.el-pagination--small .arrow.disabled {
  visibility: hidden;
}
.el-pagination--small .more:before,
.el-pagination--small li.more:before {
  line-height: 24px;
}
.el-pagination--small button,
.el-pagination--small span:not([class*="suffix"]) {
  height: 22px;
  line-height: 22px;
}
.el-pagination--small .el-pagination__editor,
.el-pagination--small .el-pagination__editor.el-input .el-input__inner {
  height: 22px;
}
.el-pagination__sizes {
  margin: 0 10px 0 0;
  font-weight: 400;
  color: #606266;
}
.el-pagination__sizes .el-input .el-input__inner {
  font-size: 13px;
  padding-left: 8px;
}
.el-pagination__sizes .el-input .el-input__inner:hover {
  border-color: #409eff;
}
.el-pagination__total {
  margin-right: 10px;
  font-weight: 400;
  color: #606266;
}
.el-pagination__jump {
  margin-left: 24px;
  font-weight: 400;
  color: #606266;
}
.el-pagination__jump .el-input__inner {
  padding: 0 3px;
}
.el-pagination__rightwrapper {
  float: right;
}
.el-pagination__editor {
  line-height: 18px;
  padding: 0 2px;
  height: 28px;
  text-align: center;
  margin: 0 2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 3px;
}
.el-pager,
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  padding: 0;
}
.el-pagination__editor.el-input {
  width: 50px;
}
.el-pagination__editor.el-input .el-input__inner {
  height: 28px;
}
.el-pagination__editor .el-input__inner::-webkit-inner-spin-button,
.el-pagination__editor .el-input__inner::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #f4f4f5;
  color: #606266;
  min-width: 30px;
  border-radius: 2px;
}
.el-pagination.is-background .btn-next.disabled,
.el-pagination.is-background .btn-next:disabled,
.el-pagination.is-background .btn-prev.disabled,
.el-pagination.is-background .btn-prev:disabled,
.el-pagination.is-background .el-pager li.disabled {
  color: #c0c4cc;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #409eff;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #409eff;
  color: #fff;
}
.el-pagination.is-background.el-pagination--small .btn-next,
.el-pagination.is-background.el-pagination--small .btn-prev,
.el-pagination.is-background.el-pagination--small .el-pager li {
  margin: 0 3px;
  min-width: 22px;
}
.el-pager,
.el-pager li {
  vertical-align: top;
  display: inline-block;
  margin: 0;
}
.el-pager {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  list-style: none;
  font-size: 0;
}
.el-pager .more:before {
  line-height: 30px;
}
.el-pager li {
  padding: 0 4px;
  background: #fff;
  font-size: 13px;
  min-width: 35.5px;
  height: 28px;
  line-height: 28px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}
.el-pager li.btn-quicknext,
.el-pager li.btn-quickprev {
  line-height: 28px;
  color: #303133;
}
.el-pager li.btn-quicknext.disabled,
.el-pager li.btn-quickprev.disabled {
  color: #c0c4cc;
}
.el-pager li.active + li {
  border-left: 0;
}
.el-pager li:hover {
  color: #409eff;
}
.el-pager li.active {
  color: #409eff;
  cursor: default;
}
.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  z-index: 1;
}
.swiper-container-no-flexbox .swiper-slide {
  float: left;
}
.swiper-container-vertical > .swiper-wrapper {
  -webkit-box-orient: vertical;
  -ms-flex-direction: column;
  flex-direction: column;
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-transition-property: -webkit-transform;
  transition-property: -webkit-transform;
  transition-property: transform;
  transition-property: transform, -webkit-transform;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
.swiper-container-android .swiper-slide,
.swiper-wrapper {
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}
.swiper-container-multirow > .swiper-wrapper {
  -webkit-box-lines: multiple;
  -moz-box-lines: multiple;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.swiper-container-free-mode > .swiper-wrapper {
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
  margin: 0 auto;
}
.swiper-slide {
  -webkit-flex-shrink: 0;
  -ms-flex: 0 0 auto;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
}
.swiper-container-autoheight,
.swiper-container-autoheight .swiper-slide {
  height: auto;
}
.swiper-container-autoheight .swiper-wrapper {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-transition-property: -webkit-transform, height;
  -webkit-transition-property: height, -webkit-transform;
  transition-property: height, -webkit-transform;
  transition-property: transform, height;
  transition-property: transform, height, -webkit-transform;
}
.swiper-container .swiper-notification {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  opacity: 0;
  z-index: -1000;
}
.swiper-wp8-horizontal {
  -ms-touch-action: pan-y;
  touch-action: pan-y;
}
.swiper-wp8-vertical {
  -ms-touch-action: pan-x;
  touch-action: pan-x;
}
.swiper-button-next,
.swiper-button-prev {
  position: absolute;
  top: 50%;
  width: 27px;
  height: 44px;
  margin-top: -22px;
  z-index: 10;
  cursor: pointer;
  background-size: 27px 44px;
  background-position: 50%;
  background-repeat: no-repeat;
}
.swiper-button-next.swiper-button-disabled,
.swiper-button-prev.swiper-button-disabled {
  opacity: 0.35;
  cursor: auto;
  pointer-events: none;
}
.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23007aff'/%3E%3C/svg%3E");
  left: 10px;
  right: auto;
}
.swiper-button-prev.swiper-button-black,
.swiper-container-rtl .swiper-button-next.swiper-button-black {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z'/%3E%3C/svg%3E");
}
.swiper-button-prev.swiper-button-white,
.swiper-container-rtl .swiper-button-next.swiper-button-white {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23fff'/%3E%3C/svg%3E");
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23007aff'/%3E%3C/svg%3E");
  right: 10px;
  left: auto;
}
.swiper-button-next.swiper-button-black,
.swiper-container-rtl .swiper-button-prev.swiper-button-black {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z'/%3E%3C/svg%3E");
}
.swiper-button-next.swiper-button-white,
.swiper-container-rtl .swiper-button-prev.swiper-button-white {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23fff'/%3E%3C/svg%3E");
}
.swiper-pagination {
  position: absolute;
  text-align: center;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  z-index: 10;
}
.swiper-pagination.swiper-pagination-hidden {
  opacity: 0;
}
.swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 10px;
  left: 0;
  width: 100%;
}
.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #000;
  opacity: 0.2;
}
button.swiper-pagination-bullet {
  border: none;
  margin: 0;
  padding: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}
.swiper-pagination-clickable .swiper-pagination-bullet {
  cursor: pointer;
}
.swiper-pagination-white .swiper-pagination-bullet {
  background: #fff;
}
.swiper-pagination-bullet-active {
  opacity: 1;
  background: #007aff;
}
.swiper-pagination-white .swiper-pagination-bullet-active {
  background: #fff;
}
.swiper-pagination-black .swiper-pagination-bullet-active {
  background: #000;
}
.swiper-container-vertical > .swiper-pagination-bullets {
  right: 10px;
  top: 50%;
  -webkit-transform: translate3d(0, -50%, 0);
  transform: translate3d(0, -50%, 0);
}
.swiper-container-vertical
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 5px 0;
  display: block;
}
.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 5px;
}
.swiper-pagination-progress {
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
}
.swiper-pagination-progress .swiper-pagination-progressbar {
  background: #007aff;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  -webkit-transform: scale(0);
  transform: scale(0);
  -webkit-transform-origin: left top;
  transform-origin: left top;
}
.swiper-container-rtl
  .swiper-pagination-progress
  .swiper-pagination-progressbar {
  -webkit-transform-origin: right top;
  transform-origin: right top;
}
.swiper-container-horizontal > .swiper-pagination-progress {
  width: 100%;
  height: 4px;
  left: 0;
  top: 0;
}
.swiper-container-vertical > .swiper-pagination-progress {
  width: 4px;
  height: 100%;
  left: 0;
  top: 0;
}
.swiper-pagination-progress.swiper-pagination-white {
  background: hsla(0, 0%, 100%, 0.5);
}
.swiper-pagination-progress.swiper-pagination-white
  .swiper-pagination-progressbar {
  background: #fff;
}
.swiper-pagination-progress.swiper-pagination-black
  .swiper-pagination-progressbar {
  background: #000;
}
.swiper-container-3d {
  -webkit-perspective: 1200px;
  -o-perspective: 1200px;
  perspective: 1200px;
}
.swiper-container-3d .swiper-cube-shadow,
.swiper-container-3d .swiper-slide,
.swiper-container-3d .swiper-slide-shadow-bottom,
.swiper-container-3d .swiper-slide-shadow-left,
.swiper-container-3d .swiper-slide-shadow-right,
.swiper-container-3d .swiper-slide-shadow-top,
.swiper-container-3d .swiper-wrapper {
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
}
.swiper-container-3d .swiper-slide-shadow-bottom,
.swiper-container-3d .swiper-slide-shadow-left,
.swiper-container-3d .swiper-slide-shadow-right,
.swiper-container-3d .swiper-slide-shadow-top {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}
.swiper-container-3d .swiper-slide-shadow-left {
  background-image: -webkit-gradient(
    linear,
    right top,
    left top,
    from(rgba(0, 0, 0, 0.5)),
    to(transparent)
  );
  background-image: linear-gradient(270deg, rgba(0, 0, 0, 0.5), transparent);
}
.swiper-container-3d .swiper-slide-shadow-right {
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(rgba(0, 0, 0, 0.5)),
    to(transparent)
  );
  background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.5), transparent);
}
.swiper-container-3d .swiper-slide-shadow-top {
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    from(rgba(0, 0, 0, 0.5)),
    to(transparent)
  );
  background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.5), transparent);
}
.swiper-container-3d .swiper-slide-shadow-bottom {
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(0, 0, 0, 0.5)),
    to(transparent)
  );
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.5), transparent);
}
.swiper-container-coverflow .swiper-wrapper,
.swiper-container-flip .swiper-wrapper {
  -ms-perspective: 1200px;
}
.swiper-container-cube,
.swiper-container-flip {
  overflow: visible;
}
.swiper-container-cube .swiper-slide,
.swiper-container-flip .swiper-slide {
  pointer-events: none;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  z-index: 1;
}
.swiper-container-cube .swiper-slide .swiper-slide,
.swiper-container-flip .swiper-slide .swiper-slide {
  pointer-events: none;
}
.swiper-container-cube .swiper-slide-active,
.swiper-container-cube .swiper-slide-active .swiper-slide-active,
.swiper-container-flip .swiper-slide-active,
.swiper-container-flip .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}
.swiper-container-cube .swiper-slide-shadow-bottom,
.swiper-container-cube .swiper-slide-shadow-left,
.swiper-container-cube .swiper-slide-shadow-right,
.swiper-container-cube .swiper-slide-shadow-top,
.swiper-container-flip .swiper-slide-shadow-bottom,
.swiper-container-flip .swiper-slide-shadow-left,
.swiper-container-flip .swiper-slide-shadow-right,
.swiper-container-flip .swiper-slide-shadow-top {
  z-index: 0;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.swiper-container-cube .swiper-slide {
  visibility: hidden;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  width: 100%;
  height: 100%;
}
.swiper-container-cube.swiper-container-rtl .swiper-slide {
  -webkit-transform-origin: 100% 0;
  transform-origin: 100% 0;
}
.swiper-container-cube .swiper-slide-active,
.swiper-container-cube .swiper-slide-next,
.swiper-container-cube .swiper-slide-next + .swiper-slide,
.swiper-container-cube .swiper-slide-prev {
  pointer-events: auto;
  visibility: visible;
}
.swiper-container-cube .swiper-cube-shadow {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.6;
  -webkit-filter: blur(50px);
  filter: blur(50px);
  z-index: 0;
}
.swiper-container-fade.swiper-container-free-mode .swiper-slide {
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}
.swiper-container-fade .swiper-slide {
  pointer-events: none;
  -webkit-transition-property: opacity;
  transition-property: opacity;
}
.swiper-container-fade .swiper-slide .swiper-slide {
  pointer-events: none;
}
.swiper-container-fade .swiper-slide-active,
.swiper-container-fade .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}
.swiper-zoom-container {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
}
.swiper-zoom-container > canvas,
.swiper-zoom-container > img,
.swiper-zoom-container > svg {
  max-width: 100%;
  max-height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}
.swiper-scrollbar {
  border-radius: 10px;
  position: relative;
  -ms-touch-action: none;
  background: rgba(0, 0, 0, 0.1);
}
.swiper-container-horizontal > .swiper-scrollbar {
  position: absolute;
  left: 1%;
  bottom: 3px;
  z-index: 50;
  height: 5px;
  width: 98%;
}
.swiper-container-vertical > .swiper-scrollbar {
  position: absolute;
  right: 3px;
  top: 1%;
  z-index: 50;
  width: 5px;
  height: 98%;
}
.swiper-scrollbar-drag {
  height: 100%;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  left: 0;
  top: 0;
}
.swiper-scrollbar-cursor-drag {
  cursor: move;
}
.swiper-lazy-preloader {
  width: 42px;
  height: 42px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -21px;
  margin-top: -21px;
  z-index: 10;
  -webkit-transform-origin: 50%;
  transform-origin: 50%;
  -webkit-animation: swiper-preloader-spin 1s steps(12) infinite;
  animation: swiper-preloader-spin 1s steps(12) infinite;
}
.swiper-lazy-preloader:after {
  display: block;
  content: "";
  width: 100%;
  height: 100%;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%236c6c6c' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E");
  background-position: 50%;
  background-size: 100%;
  background-repeat: no-repeat;
}
.swiper-lazy-preloader-white:after {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%23fff' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E");
}
@-webkit-keyframes swiper-preloader-spin {
  to {
    -webkit-transform: rotate(1turn);
  }
}
@keyframes swiper-preloader-spin {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
.topNav {
  width: 100%;
  height: 100%;
  background: #fff;
}
.topNav .el-menu-item:hover {
  outline: 0 !important;
  background: #fff !important;
}
.topNav .el-menu-item.is-active {
  background: #fff !important;
}
.el-menu-demo {
  width: 1200px;
  margin: auto;
}
.logo {
  float: left;
  height: 44px;
  padding-top: 16px;
  margin-right: 20px;
}
.logo > img {
  height: 26px;
}
.menu_me {
  float: right;
  width: 365px;
}
.el-dropdown-link {
  float: right;
  height: 60px;
  overflow: hidden;
}
.el-dropdown-link img {
  display: block;
  float: left;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-top: 5px;
}
.el-dropdown-link span {
  display: block;
  float: left;
  height: 60px;
  line-height: 60px;
  padding: 0 12px;
  font-size: 16px;
  font-weight: 700;
}
.el-dropdown-link i {
  float: left;
  display: block;
  width: 20px;
  height: 50px;
  line-height: 50px;
  border-radius: 50%;
  margin-top: 5px;
}
.nav_con > p {
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.nav_con > p > a {
  color: #000;
}
.nav_con > p:hover,
.nav_con > p > a:hover {
  color: #f90;
}
.btn {
  background-color: rgba(253, 148, 15, 0.8) !important;
  border-radius: 6px;
}
.btn,
.btnZP {
  float: right;
  width: 100px;
  text-align: center;
  line-height: 38px;
  margin-top: 12px;
  margin-right: 20px;
  -webkit-box-shadow: hsla(0, 0%, 83.9%, 0.8) 2px 4px 1px 1px;
  box-shadow: 2px 4px 1px 1px hsla(0, 0%, 83.9%, 0.8);
  cursor: pointer;
}
.btnZP {
  border: 1px solid rgba(253, 148, 15, 0.8);
  border-radius: 6px;
}
.btn :hover,
.btnZP:hover {
  font-weight: 700;
  -webkit-box-shadow: hsla(0, 0%, 83.9%, 0.8) 2px 4px 1px 1px;
  box-shadow: 2px 4px 1px 1px hsla(0, 0%, 83.9%, 0.8);
}

.ziuzhiComponents {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
}
.zhiqiu {
  width: 436px;
  height: 276px;
  position: absolute;
  top: 50%;
  margin-top: -200px;
  left: 50%;
  margin-left: -230px;
  background: #fff;
  padding: 12px;
  border-radius: 12px;
}
.zhiqiu > .item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 40px;
}
.zhiqiu > .item > p {
  float: left;
  width: 200px;
  line-height: 40px;
  border-radius: 6px;
  border: 1px solid #e6e4e4;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  margin: 14px auto;
  color: #202020;
}
.zhiqiu > .item > .index,
.zhiqiu > .item > p:hover {
  font-weight: 700;
  border-color: #f5ae55;
}
.header {
  padding: 0 12px;
  margin-bottom: 25px;
}
.header h4 {
  margin: 0 0;
}
.header p {
  margin: 6px 0;
  font-size: 14px;
  color: #8d92a1;
}
.footer {
  text-align: right;
  padding-right: 20px;
}
.elite_layout {
  min-width: 1250px;
  position: relative;
}
.main {
  margin: auto;
}
.el-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 0;
  z-index: 10;
}
.el-main {
  padding: 0;
}
.swiper-slide img {
  width: 100%;
}
.wrapper .swiper-pagination-bullet-active {
  background-color: #fff !important;
}
.wrapper > img {
  width: 100%;
  height: 100%;
}
.comment {
  height: 40px;
  line-height: 40px;
  color: #fff;
  background-color: #c0c4cc;
  cursor: pointer;
  padding: 0 10px;
}
.bounce,
.comment {
  float: right;
  margin-right: 10px;
}
.get-btn .el-button.el-button--text {
  padding: 12px 10px;
  color: #fff;
}
.get-btn .el-button.el-button--text.el-dropdown__caret-button {
  padding: 12px 5px;
  color: #fff;
}
.bounce .el-button.el-button--text {
  padding: 12px 10px;
  color: #fff;
  background-color: #ceb461;
}
.bounce .el-button.el-button--text.el-dropdown__caret-button {
  padding: 12px 5px;
  color: #fff;
  background-color: #ceb461;
}
.city_BG {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
}
.city_select {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 500px;
  height: 528px;
  margin-left: -250px;
  margin-top: -264px;
  -webkit-box-sizing: border-box;
  background-color: #fff;
  box-sizing: border-box;
  position: relative;
}
.city_select .title {
  text-align: center;
  font-weight: 700;
  line-height: 40px;
  background: #ff8f00;
  color: #fff;
}
.city_select .title span {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 18px;
}
.city_select .conent {
  font-size: 16px;
  border-bottom: 2px solid #ececec;
  padding: 0 12px;
}
.city_select .conent > p {
  padding-left: 20px;
}
.city_select .diqu {
  padding: 20px;
}
.city_select .diqu .conentCity {
  height: 284px;
  margin-top: 12px;
  font-size: 14px;
}
.city_select .diqu .conentCity .phoneticOrdering {
  width: 460px;
  line-height: 30px;
  background: #f7e2d5;
}
.city_select .diqu .conentCity .phoneticOrdering > span {
  padding: 12px;
  cursor: pointer;
}
.city_select .diqu .conentCity .phoneticOrdering > .indexKey {
  color: #ff8f00;
  border-bottom: #ff8f00;
}
.city_select .diqu .conentCity .keyConent {
  width: 460px;
  height: 200px;
  overflow: auto;
  background: #fbf6f0;
  padding: 12px 0;
  min-height: 200px;
}
.city_select .diqu .conentCity .keyConent > span {
  display: block;
  float: left;
  padding: 1px 13px;
  border: 1px solid #ff9207;
  border-radius: 4px;
  margin: 5px;
  cursor: pointer;
}
.city_select .diqu .conentCity .keyConent .index,
.city_select .diqu .conentCity .keyConent > span:hover {
  background: #fcdeb7;
}
.city_select .diqu .conentCity .keyConent .kong {
  line-height: 200px;
  text-align: center;
  font-size: 20px;
  color: #949494;
}
.elite_index {
  position: relative;
}
.search {
  margin: 64px 0 20px;
  position: relative;
}
.search > .swiper {
  width: 1200px;
  margin: auto;
}
.search > .sousuo {
  width: 950px;
  margin: auto;
  overflow: hidden;
  position: absolute;
  top: 298px;
  left: 50%;
  margin-left: -475px;
  z-index: 5;
}
.search > .sousuo > div {
  float: left;
}
.search > div > div .el-input__inner {
  height: 56px;
  line-height: 56px;
  border-right: none;
  border-radius: 4px 0 0 4px;
  font-size: 18px;
}
.search > div > div .el-button {
  display: inline-block;
  width: 150px;
  line-height: 30px;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #f90;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 500;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 12px 20px;
  font-size: 18px;
  border-radius: 0;
}
.conent {
  width: 1200px;
  margin: auto;
  margin-top: 12px;
}
.index_swiper {
  padding: 12px;
  background: #fff;
  border-radius: 12px;
}
.with-cascader {
  width: 200px;
}
.title {
  text-align: center;
  height: 60px;
}
.float_con {
  width: 100%;
  overflow: hidden;
  padding: 12px 0 26px 0;
}
.con_tuijian {
  margin-bottom: 20px;
}
.con {
  position: relative;
  width: 382px;
  background: #fff;
  float: left;
  margin-right: 26px;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 20px;
  padding: 0 0 6px 0;
}
.con:nth-child(3n),
.con_company:nth-child(4n) {
  margin-right: 0;
}
.con > .title {
  font-size: 18px;
  font-weight: 700;
}
.con > .jd_name {
  font-size: 18px;
  padding: 6px 12px 6px 18px;
  margin: 0;
  color: #404040;
}
.con > .jd_salary {
  font-size: 18px;
  padding: 6px 12px;
  margin: 0;
  color: rgba(255, 30, 0, 0.8);
  position: absolute;
  top: 32px;
  right: 5px;
}
.info {
  font-size: 13px;
  padding-left: 10px;
  padding-bottom: 6px;
  margin: 6px 0;
  color: #818181;
  border-bottom: 1px solid rgba(226, 189, 141, 0.8);
}
.info > span {
  padding: 0 6px;
  border-right: 1px solid #ccc;
}
.info > span:last-child {
  border-right: none;
}
.con > .company {
  font-size: 14px;
  padding: 6px 12px;
  color: #1d1b1b;
}
.button_to {
  text-align: center;
}
.bar {
  width: 100%;
  height: 50px;
  background: #fff;
  line-height: 50px;
}
.bar_class {
  width: 11%;
  float: left;
  height: 48px;
  text-align: center;
  font-size: 14px;
  color: #aaa;
  cursor: pointer;
}
.action {
  color: #f90;
  border-bottom: 2px solid #f90;
  font-weight: 700;
}
.btn {
  width: 350px;
  background-color: rgba(253, 148, 15, 0.8) !important;
}
.con_company {
  width: 281px;
  height: 150px;
  background: #fff;
  float: left;
  margin-right: 25px;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 20px;
  padding: 20px 0;
}
.con_company img {
  display: block;
  width: 100px;
  height: 100px;
  border-radius: 16px;
  margin: auto;
  margin-bottom: 20px;
  border: 1px solid #d3d3d3;
}
.con_company div {
  text-align: center;
}
.con_company div span {
  font-weight: 700;
  color: #131212;
}
.footer {
  background: #060606;
  padding: 20px 0 20px;
  position: relative;
  min-width: 1200px;
}
.footer a {
  color: #cfc8c8;
}
.footer p {
  line-height: 30px;
}
.f_cont {
  width: 80%;
  height: 200px;
  margin: 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 12px;
  color: #cfc8c8;
  line-height: 15px;
}
.f_cont .tu {
  width: 449px;
}
.tu p {
  text-align: center;
}
.tu div {
  display: inline-block;
  margin-top: 30px;
}
.f_flex {
  width: 900px;
  right: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  color: #cfc8c8;
  margin-left: 300px;
}
.f_flex .title > p {
  margin-bottom: 30px;
}
div .swiper-wrapper {
  -webkit-transition-timing-function: linear;
  transition-timing-function: linear;
}
.logo-bottom {
  width: 120px;
  margin-left: 40px;
}
.logo-bottom img {
  width: 100%;
}
.m_title .el-input__inner {
  width: 280px;
  border-radius: 10px;
  height: 49px;
  background: #fff;
  border: none;
  -webkit-box-shadow: 2px -14px 64px 0 rgba(14, 20, 33, 0.2);
  box-shadow: 2px -14px 64px 0 rgba(14, 20, 33, 0.2);
  font-size: 17px;
  color: #666;
  padding: 0 32px;
}
.topNav {
  width: 100%;
  height: 100%;
  background: #fff;
}
.topNav .el-menu-item:hover {
  outline: 0 !important;
  background: #fff !important;
}
.topNav .el-menu-item.is-active {
  background: #fff !important;
}
.el-menu-demo {
  width: 1200px;
  margin: auto;
}
.logo {
  float: left;
  height: 44px;
  padding-top: 16px;
  margin-right: 20px;
}
.logo > img {
  height: 26px;
}
.menu_me {
  float: right;
  width: 365px;
}
.el-dropdown-link {
  float: right;
  height: 60px;
  overflow: hidden;
}
.el-dropdown-link img {
  display: block;
  float: left;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-top: 5px;
}
.el-dropdown-link span {
  display: block;
  float: left;
  height: 60px;
  line-height: 60px;
  padding: 0 12px;
  font-size: 16px;
  font-weight: 700;
}
.el-dropdown-link i {
  float: left;
  display: block;
  width: 20px;
  height: 50px;
  line-height: 50px;
  border-radius: 50%;
  margin-top: 5px;
}
.nav_con > p {
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.nav_con > p > a {
  color: #000;
}
.nav_con > p:hover,
.nav_con > p > a:hover {
  color: #f90;
}
.btn {
  background-color: rgba(253, 148, 15, 0.8) !important;
  border-radius: 6px;
}
.btn,
.btnZP {
  float: right;
  width: 100px;
  text-align: center;
  line-height: 38px;
  margin-top: 12px;
  margin-right: 20px;
  -webkit-box-shadow: hsla(0, 0%, 83.9%, 0.8) 2px 4px 1px 1px;
  box-shadow: 2px 4px 1px 1px hsla(0, 0%, 83.9%, 0.8);
  cursor: pointer;
}
.btnZP {
  border: 1px solid rgba(253, 148, 15, 0.8);
  border-radius: 6px;
}
.btn :hover,
.btnZP:hover {
  font-weight: 700;
  -webkit-box-shadow: hsla(0, 0%, 83.9%, 0.8) 2px 4px 1px 1px;
  box-shadow: 2px 4px 1px 1px hsla(0, 0%, 83.9%, 0.8);
}

.ziuzhiComponents {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
}
.zhiqiu {
  width: 436px;
  height: 276px;
  position: absolute;
  top: 50%;
  margin-top: -200px;
  left: 50%;
  margin-left: -230px;
  background: #fff;
  padding: 12px;
  border-radius: 12px;
}
.zhiqiu > .item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 40px;
}
.zhiqiu > .item > p {
  float: left;
  width: 200px;
  line-height: 40px;
  border-radius: 6px;
  border: 1px solid #e6e4e4;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  margin: 14px auto;
  color: #202020;
}
.zhiqiu > .item > .index,
.zhiqiu > .item > p:hover {
  font-weight: 700;
  border-color: #f5ae55;
}
.header {
  padding: 0 12px;
  margin-bottom: 25px;
}
.header h4 {
  margin: 0 0;
}
.header p {
  margin: 6px 0;
  font-size: 14px;
  color: #8d92a1;
}
.footer {
  text-align: right;
  padding-right: 20px;
}
.elite_layout {
  min-width: 1250px;
  position: relative;
}
.main {
  margin: auto;
}
.el-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 0;
  z-index: 10;
}
.el-main {
  padding: 0;
}

.el-button,
.el-input__inner {
  -webkit-appearance: none;
  outline: 0;
}

/**轮播 */

.prev {
  position: absolute;
  top: 50%;
  left: 0;
  width: 50px;
}
.next {
  position: absolute;
  top: 50%;
  right: 0;
  width: 50px;
}
.img_brand {
  float: left;
}
.banner {
  overflow: hidden;
}
.trans {
  transition: all 0.5s;
}
.view {
  width: 1200px;
  height: 300px;
  overflow: hidden;
  margin: 0 auto;
}
.p_and_n {
  position: absolute;
  top: 130px;
  width: 1200px;
}
.title p {
  font-size: 14px;
}

.mytitle {
  font-size: 20px !important;
}
</style>
